import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { MenuItem } from '@mui/material';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useState, useEffect } from "react";
import dayjs from 'dayjs';
import 'dayjs/locale/it';
import ButtonGroup from "@mui/material/ButtonGroup";

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { DataGrid, GridToolbar, GridRowParams } from '@mui/x-data-grid';
import Card from '@mui/material/Card';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';

import { collection, addDoc, getDocs, getDoc, updateDoc, doc } from "firebase/firestore";
import {db} from '../firebase';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import { storage } from '../firestore';
import {ref, uploadBytes, listAll, getDownloadURL} from "firebase/storage";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';



const statoRichiesta = [
  {
    value: "nuova",
    label: "NUOVA",
  },
  {
    value: "in valutazione",
    label: "IN VALUTAZIONE",
  },
  {
    value: "approvata",
    label: "APPROVATA",
  },
  {
    value: "abbonamentoEmesso",
    label: "ABBONAMENTO EMESSO",
  },
  {
    value: "respinta",
    label: "RESPINTA",
  },
  {
    value: "ritirata",
    label: "RITIRATA",
  },
]

const statoDocumentazione = [
  {
    value: "RICHIESTA INVIATA",
    label: "RICHIESTA INVIATA",
  },
  {
    value: "VERIFICATA",
    label: "VERIFICATA",
  },
  {
    value: "INCOMPLETA",
    label: "INCOMPLETA",
  },
  {
    value: "DA RICHIEDERE",
    label: "DA RICHIEDERE",
  },
  {
    value: "NON PREVISTA",
    label: "NON PREVISTA",
  }
]

const calcolaQuotaFamiliare = [
  {
    calcolaGiugno: 0,
    calcolaLuglio: 0,
    calcolaAgosto: 0,
    calcolaSettembre: 0,
  },
  {
    calcolaGiugno: 0,
    calcolaLuglio: 0,
    calcolaAgosto: 0,
    calcolaSettembre: 0,
  },
  {
    calcolaGiugno: 0,
    calcolaLuglio: 0,
    calcolaAgosto: 0,
    calcolaSettembre: 0,
  },
  {
    calcolaGiugno: 0,
    calcolaLuglio: 0,
    calcolaAgosto: 0,
    calcolaSettembre: 0,
  },
  {
    calcolaGiugno: 0,
    calcolaLuglio: 0,
    calcolaAgosto: 0,
    calcolaSettembre: 0,
  },
  {
    calcolaGiugno: 0,
    calcolaLuglio: 0,
    calcolaAgosto: 0,
    calcolaSettembre: 0,
  },
  {
    calcolaGiugno: 0,
    calcolaLuglio: 0,
    calcolaAgosto: 0,
    calcolaSettembre: 0,
  },
  {
    calcolaGiugno: 0,
    calcolaLuglio: 0,
    calcolaAgosto: 0,
    calcolaSettembre: 0,
  },
  {
    calcolaGiugno: 0,
    calcolaLuglio: 0,
    calcolaAgosto: 0,
    calcolaSettembre: 0,
  },
  {
    calcolaGiugno: 0,
    calcolaLuglio: 0,
    calcolaAgosto: 0,
    calcolaSettembre: 0,
  },
]

let daVersareState = 0.0;

var docsArray = [];

let abbRows = [];  
let abbGiugnoRows = [];  
let abbLuglioRows = [];  
let abbAgostoRows = [];  
let abbSettembreRows = [];  

let abbAllRows = [];  
let abbGiugnoAllRows = [];  
let abbLuglioAllRows = [];  
let abbAgostoAllRows = [];  
let abbSettembreAllRows = [];  

const Manager = () => {

  
  const [abbonamenti, setAbbonamenti] = useState(abbRows);
  const [abbonamentiGiugno, setAbbonamentiGiugno] = useState(abbGiugnoRows);
  const [abbonamentiLuglio, setAbbonamentiLuglio] = useState(abbLuglioRows);
  const [abbonamentiAgosto, setAbbonamentiAgosto] = useState(abbAgostoRows);
  const [abbonamentiSettembre, setAbbonamentiSettembre] = useState(abbSettembreRows);

  const [abbonamentiAll, setAbbonamentiAll] = useState(abbAllRows);
  const [abbonamentiGiugnoAll, setAbbonamentiGiugnoAll] = useState(abbGiugnoAllRows);
  const [abbonamentiLuglioAll, setAbbonamentiLuglioAll] = useState(abbLuglioAllRows);
  const [abbonamentiAgostoAll, setAbbonamentiAgostoAll] = useState(abbAgostoAllRows);
  const [abbonamentiSettembreAll, setAbbonamentiSettembreAll] = useState(abbSettembreAllRows);

   // Ombrellone Giugno
   const [ombrelloneGiugno, setOmbrelloneGiugno] = useState("");
   const handleOmbrelloneGiugnoChange = e => {
     setOmbrelloneGiugno(e.target.value);
   }

   // Ombrellone Luglio
   const [ombrelloneLuglio, setOmbrelloneLuglio] = useState("");
   const handleOmbrelloneLuglioChange = e => {
    
     setOmbrelloneLuglio(e.target.value);
   }

   // Ombrellone Agosto
   const [ombrelloneAgosto, setOmbrelloneAgosto] = useState("");
   const handleOmbrelloneAgostoChange = e => {
     setOmbrelloneAgosto(e.target.value);
   }

   // Ombrellone Settembre
   const [ombrelloneSettembre, setOmbrelloneSettembre] = useState("");
   const handleOmbrelloneSettembreChange = e => {
     setOmbrelloneSettembre(e.target.value);
   }

  const [snackBarMessage, setSnackBarMessage] = React.useState("");
  const [openSnackBar, setOpenSnackBar] = React.useState(false);

  const handleSnackBar = () => {
    setOpenSnackBar(true);
  };

  const handleCloseSnackBar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackBar(false);
  };


  const salvaAbbonamenti = async () => {
    handleOpenLoader();
    await getDocs(collection(db, "Abbonamento2026"))
    .then((querySnapshot)=>{      
        console.log(querySnapshot.size);      
        let rows = [];  
        querySnapshot.forEach(async documentSnapshot => {
            const rowData = documentSnapshot.data();
            if(rowData.idRichiestaTitolare === selectedIdRichiesta && rowData.turnoAbbonamento === "Giugno"){
              const docRef = doc(db, "Abbonamento2026", documentSnapshot.id);
                await updateDoc(docRef, {
                  ombrellone:ombrelloneGiugno
                });
            }
            if(rowData.idRichiestaTitolare === selectedIdRichiesta && rowData.turnoAbbonamento === "Luglio"){
              const docRef = doc(db, "Abbonamento2026", documentSnapshot.id);
                await updateDoc(docRef, {
                  ombrellone:ombrelloneLuglio
                });
            }
            if(rowData.idRichiestaTitolare === selectedIdRichiesta && rowData.turnoAbbonamento === "Agosto"){
              const docRef = doc(db, "Abbonamento2026", documentSnapshot.id);
                await updateDoc(docRef, {
                  ombrellone:ombrelloneAgosto
                });
            }
            if(rowData.idRichiestaTitolare === selectedIdRichiesta && rowData.turnoAbbonamento === "Settembre"){
              const docRef = doc(db, "Abbonamento2026", documentSnapshot.id);
                await updateDoc(docRef, {
                  ombrellone:ombrelloneSettembre
                });
            }
        });
      
    })
    handleCloseLoader();
    setSnackBarMessage("Le modifiche agli OMBRELLONI sono state salvate con successo!");
    handleSnackBar();
  }
  
  const generaAbbonamenti = async () => {
 
    handleOpenLoader(true);
    // Abbonamenti titolare

     // familiari e conviventi
     var altriAbbonamentiGiugno = [{"approvato":selectedApprovaGiugnoEA1, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA1.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA1},
      {"approvato":selectedApprovaGiugnoEA2, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA2.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA2},
      {"approvato":selectedApprovaGiugnoEA3, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA3.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA3},
      {"approvato":selectedApprovaGiugnoEA4, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA4.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA4},
      {"approvato":selectedApprovaGiugnoEA5, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA5.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA5},
      {"approvato":selectedApprovaGiugnoEA6, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA6.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA6},
      {"approvato":selectedApprovaGiugnoEA7, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA7.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA7},
      {"approvato":selectedApprovaGiugnoEA8, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA8.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA8},
      {"approvato":selectedApprovaGiugnoEA9, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA9.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA9},
      {"approvato":selectedApprovaGiugnoEA10, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA10.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA10}
     ]
     var altriAbbonamentiLuglio = [{"approvato":selectedApprovaLuglioEA1, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA1.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA1},
      {"approvato":selectedApprovaLuglioEA2, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA2.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA2},
      {"approvato":selectedApprovaLuglioEA3, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA3.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA3},
      {"approvato":selectedApprovaLuglioEA4, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA4.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA4},
      {"approvato":selectedApprovaLuglioEA5, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA5.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA5},
      {"approvato":selectedApprovaLuglioEA6, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA6.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA6},
      {"approvato":selectedApprovaLuglioEA7, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA7.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA7},
      {"approvato":selectedApprovaLuglioEA8, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA8.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA8},
      {"approvato":selectedApprovaLuglioEA9, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA9.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA9},
      {"approvato":selectedApprovaLuglioEA10, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA10.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA10}
     ]
     var altriAbbonamentiAgosto = [{"approvato":selectedApprovaAgostoEA1, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA1.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA1},
      {"approvato":selectedApprovaAgostoEA2, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA2.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA2},
      {"approvato":selectedApprovaAgostoEA3, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA3.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA3},
      {"approvato":selectedApprovaAgostoEA4, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA4.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA4},
      {"approvato":selectedApprovaAgostoEA5, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA5.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA5},
      {"approvato":selectedApprovaAgostoEA6, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA6.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA6},
      {"approvato":selectedApprovaAgostoEA7, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA7.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA7},
      {"approvato":selectedApprovaAgostoEA8, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA8.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA8},
      {"approvato":selectedApprovaAgostoEA9, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA9.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA9},
      {"approvato":selectedApprovaAgostoEA10, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA10.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA10}
     ]
     var altriAbbonamentiSettembre = [{"approvato":selectedApprovaSettembreEA1, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA1.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA1},
      {"approvato":selectedApprovaSettembreEA2, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA2.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA2},
      {"approvato":selectedApprovaSettembreEA3, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA3.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA3},
      {"approvato":selectedApprovaSettembreEA4, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA4.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA4},
      {"approvato":selectedApprovaSettembreEA5, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA5.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA5},
      {"approvato":selectedApprovaSettembreEA6, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA6.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA6},
      {"approvato":selectedApprovaSettembreEA7, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA7.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA7},
      {"approvato":selectedApprovaSettembreEA8, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA8.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA8},
      {"approvato":selectedApprovaSettembreEA9, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA9.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA9},
      {"approvato":selectedApprovaSettembreEA10, "nomeCognomeAbbonato":selectedRequest.nomeCognomeEA10.toUpperCase(), "gradoParentela":selectedRequest.gradoParentelaEA10}
     ]

     console.log("altriAbbonamentiGiugno")
    if(selectedApprovaGiugno === "SI"){
      // esempio titolare
     
      try {
        const docRef = await addDoc(collection(db, "Abbonamento2026"), {
          idRichiestaTitolare: selectedIdRichiesta,
          turnoAbbonamento: "Giugno",
          nomeTitolare: selectedRequest.nomeTitolare.toUpperCase(),
          cognomeTitolare : selectedRequest.cognomeTitolare.toUpperCase(),
          categoriaTitolare: categoria.find(o => o.value === selectedRequest.categoriaDiAppartenenza.toUpperCase()).name.toUpperCase(),
          ombrellone: "",
          nomeCognomeAbbonato: "",
          gradoParentela: "",
        });
      } catch (e) {
        console.error("Error adding document: ", e);
      }

      for (const index in altriAbbonamentiGiugno) {  
        if(altriAbbonamentiGiugno[index]["approvato"] === 1){
            try {
              const docRef = await addDoc(collection(db, "Abbonamento2026"), {
                idRichiestaTitolare: selectedIdRichiesta,
                turnoAbbonamento: "Giugno",
                nomeTitolare: selectedRequest.nomeTitolare.toUpperCase(),
                cognomeTitolare : selectedRequest.cognomeTitolare.toUpperCase(),
                categoriaTitolare: categoria.find(o => o.value === selectedRequest.categoriaDiAppartenenza.toUpperCase()).name.toUpperCase(),
                ombrellone: "",
                nomeCognomeAbbonato: altriAbbonamentiGiugno[index]["nomeCognomeAbbonato"],
                gradoParentela: altriAbbonamentiGiugno[index]["gradoParentela"],
              });
            } catch (e) {
              console.error("Error adding document: ", e);
            }
        }
      }
    }

    if(selectedApprovaLuglio === "SI"){
      try {
        const docRef = await addDoc(collection(db, "Abbonamento2026"), {
          idRichiestaTitolare: selectedIdRichiesta,
          turnoAbbonamento: "Luglio",
          nomeTitolare: selectedRequest.nomeTitolare.toUpperCase(),
          cognomeTitolare : selectedRequest.cognomeTitolare.toUpperCase(),
          categoriaTitolare: categoria.find(o => o.value === selectedRequest.categoriaDiAppartenenza.toUpperCase()).name.toUpperCase(),
          ombrellone: "",
          nomeCognomeAbbonato: "",
          gradoParentela: "",
        });
      } catch (e) {
        console.error("Error adding document: ", e);
      }

      for (const index in altriAbbonamentiLuglio) {  
        if(altriAbbonamentiLuglio[index]["approvato"] === 1){
          try {
            const docRef = await addDoc(collection(db, "Abbonamento2026"), {
              idRichiestaTitolare: selectedIdRichiesta,
              turnoAbbonamento: "Luglio",
              nomeTitolare: selectedRequest.nomeTitolare.toUpperCase(),
              cognomeTitolare : selectedRequest.cognomeTitolare.toUpperCase(),
              categoriaTitolare: categoria.find(o => o.value === selectedRequest.categoriaDiAppartenenza.toUpperCase()).name.toUpperCase(),
              ombrellone: "",
              nomeCognomeAbbonato: altriAbbonamentiLuglio[index]["nomeCognomeAbbonato"],
              gradoParentela: altriAbbonamentiLuglio[index]["gradoParentela"],
            });
          } catch (e) {
            console.error("Error adding document: ", e);
          }
        }
      }

      
    }

    if(selectedApprovaAgosto === "SI"){
      try {
        const docRef = await addDoc(collection(db, "Abbonamento2026"), {
          idRichiestaTitolare: selectedIdRichiesta,
          turnoAbbonamento: "Agosto",
          nomeTitolare: selectedRequest.nomeTitolare.toUpperCase(),
          cognomeTitolare : selectedRequest.cognomeTitolare.toUpperCase(),
          categoriaTitolare: categoria.find(o => o.value === selectedRequest.categoriaDiAppartenenza.toUpperCase()).name.toUpperCase(),
          ombrellone: "",
          nomeCognomeAbbonato: "",
          gradoParentela: "",
        });
      } catch (e) {
        console.error("Error adding document: ", e);
      }

      for (const index in altriAbbonamentiAgosto) {  
        if(altriAbbonamentiAgosto[index]["approvato"] === 1){
          try {
            const docRef = await addDoc(collection(db, "Abbonamento2026"), {
              idRichiestaTitolare: selectedIdRichiesta,
              turnoAbbonamento: "Agosto",
              nomeTitolare: selectedRequest.nomeTitolare.toUpperCase(),
              cognomeTitolare : selectedRequest.cognomeTitolare.toUpperCase(),
              categoriaTitolare: categoria.find(o => o.value === selectedRequest.categoriaDiAppartenenza.toUpperCase()).name.toUpperCase(),
              ombrellone: "",
              nomeCognomeAbbonato: altriAbbonamentiAgosto[index]["nomeCognomeAbbonato"],
              gradoParentela: altriAbbonamentiAgosto[index]["gradoParentela"],
            });
          } catch (e) {
            console.error("Error adding document: ", e);
          }
        }
      }

     
    }

    if(selectedApprovaSettembre === "SI"){
      try {
        const docRef = await addDoc(collection(db, "Abbonamento2026"), {
          idRichiestaTitolare: selectedIdRichiesta,
          turnoAbbonamento: "Settembre",
          nomeTitolare: selectedRequest.nomeTitolare.toUpperCase(),
          cognomeTitolare : selectedRequest.cognomeTitolare.toUpperCase(),
          categoriaTitolare: categoria.find(o => o.value === selectedRequest.categoriaDiAppartenenza.toUpperCase()).name.toUpperCase(),
          ombrellone: "",
          nomeCognomeAbbonato: "",
          gradoParentela: "",
        });
      } catch (e) {
        console.error("Error adding document: ", e);
      }

      for (const index in altriAbbonamentiSettembre) {  
        if(altriAbbonamentiSettembre[index]["approvato"] === 1){
          try {
            const docRef = await addDoc(collection(db, "Abbonamento2026"), {
              idRichiestaTitolare: selectedIdRichiesta,
              turnoAbbonamento: "Settembre",
              nomeTitolare: selectedRequest.nomeTitolare.toUpperCase(),
              cognomeTitolare : selectedRequest.cognomeTitolare.toUpperCase(),
              categoriaTitolare: categoria.find(o => o.value === selectedRequest.categoriaDiAppartenenza.toUpperCase()).name.toUpperCase(),
              ombrellone: "",
              nomeCognomeAbbonato: altriAbbonamentiSettembre[index]["nomeCognomeAbbonato"],
              gradoParentela: altriAbbonamentiSettembre[index]["gradoParentela"],
            });
          } catch (e) {
            console.error("Error adding document: ", e);
          }
        }
      }
     
    }

   


    handleCloseLoader(true);

    setSnackBarMessage("Gli abbonamenti sono stati creati con successo");
    handleSnackBar();

    caricaAbbonamenti(selectedIdRichiesta);

  }

  const caricaAbbonamenti = async (idRichiesta) => {
 
    const abbonamentiNew = [];
    const abbonamentiGiugnoNew = [];
    const abbonamentiLuglioNew = [];
    const abbonamentiAgostoNew = [];
    const abbonamentiSettembreNew = [];

    await getDocs(collection(db, "Abbonamento2026"))
        .then((querySnapshot)=>{      
            console.log(querySnapshot.size);      
            querySnapshot.forEach(async documentSnapshot => {
                const rowData = documentSnapshot.data();
                if(rowData.idRichiestaTitolare === idRichiesta){

                  if(rowData.turnoAbbonamento === "Giugno"){
                      abbonamentiGiugnoNew.push({ idAbbonamento:documentSnapshot.id,
                        categoriaTitolare:rowData.categoriaTitolare,
                        cognomeTitolare:rowData.cognomeTitolare,
                        gradoParentela:rowData.gradoParentela,
                        idRichiestaTitolare:rowData.idRichiestaTitolare,
                        nomeCognomeAbbonato:rowData.nomeCognomeAbbonato,
                        nomeTitolare:rowData.nomeTitolare,
                        ombrellone:rowData.ombrellone,
                        turnoAbbonamento:rowData.turnoAbbonamento});
                  }
                  if(rowData.turnoAbbonamento === "Luglio"){
                      abbonamentiLuglioNew.push({ idAbbonamento:documentSnapshot.id,
                      categoriaTitolare:rowData.categoriaTitolare,
                      cognomeTitolare:rowData.cognomeTitolare,
                      gradoParentela:rowData.gradoParentela,
                      idRichiestaTitolare:rowData.idRichiestaTitolare,
                      nomeCognomeAbbonato:rowData.nomeCognomeAbbonato,
                      nomeTitolare:rowData.nomeTitolare,
                      ombrellone:rowData.ombrellone,
                      turnoAbbonamento:rowData.turnoAbbonamento});
                  }
                  if(rowData.turnoAbbonamento === "Agosto"){
                      abbonamentiAgostoNew.push({ idAbbonamento:documentSnapshot.id,
                        categoriaTitolare:rowData.categoriaTitolare,
                        cognomeTitolare:rowData.cognomeTitolare,
                        gradoParentela:rowData.gradoParentela,
                        idRichiestaTitolare:rowData.idRichiestaTitolare,
                        nomeCognomeAbbonato:rowData.nomeCognomeAbbonato,
                        nomeTitolare:rowData.nomeTitolare,
                        ombrellone:rowData.ombrellone,
                        turnoAbbonamento:rowData.turnoAbbonamento});
                  }
                  if(rowData.turnoAbbonamento === "Settembre"){
                      abbonamentiSettembreNew.push({ idAbbonamento:documentSnapshot.id,
                        categoriaTitolare:rowData.categoriaTitolare,
                        cognomeTitolare:rowData.cognomeTitolare,
                        gradoParentela:rowData.gradoParentela,
                        idRichiestaTitolare:rowData.idRichiestaTitolare,
                        nomeCognomeAbbonato:rowData.nomeCognomeAbbonato,
                        nomeTitolare:rowData.nomeTitolare,
                        ombrellone:rowData.ombrellone,
                        turnoAbbonamento:rowData.turnoAbbonamento});
                  }
                  abbonamentiNew.push({ idAbbonamento:documentSnapshot.id,
                  categoriaTitolare:rowData.categoriaTitolare,
                  cognomeTitolare:rowData.cognomeTitolare,
                  gradoParentela:rowData.gradoParentela,
                  idRichiestaTitolare:rowData.idRichiestaTitolare,
                  nomeCognomeAbbonato:rowData.nomeCognomeAbbonato,
                  nomeTitolare:rowData.nomeTitolare,
                  ombrellone:rowData.ombrellone,
                  turnoAbbonamento:rowData.turnoAbbonamento});
            }
          });
          
          setAbbonamenti((arrAbb) => [...abbonamentiNew]);
          setAbbonamentiGiugno((arrAbbG) => [...abbonamentiGiugnoNew]);
          setAbbonamentiLuglio((arrAbbL) => [...abbonamentiLuglioNew]);
          setAbbonamentiAgosto((arrAbbA) => [...abbonamentiAgostoNew]);
          setAbbonamentiSettembre((arrAbbS) => [...abbonamentiSettembreNew]);
          abbonamentiNew.forEach((element) => {
           console.log("abbonamentiNew element: " + "\n" + 
           "abbonamentiNew element idAbbonamento: " + element["idAbbonamento"] + "\n" + 
           "abbonamentiNew element categoriaTitolare: " + element["categoriaTitolare"] + "\n" +
           "abbonamentiNew element cognomeTitolare: " + element["cognomeTitolare"] + "\n" +
           "abbonamentiNew element idRichiestaTitolare: " + element["idRichiestaTitolare"] + "\n" +
           "abbonamentiNew element nomeCognomeAbbonato: " + element["nomeCognomeAbbonato"] + "\n" +
           "abbonamentiNew element nomeTitolare : " + element["nomeTitolare"] + "\n" +
           "abbonamentiNew element ombrellone: " + element["ombrellone"] + "\n" +
           "abbonamentiNew element turnoAbbonamento: " + element["turnoAbbonamento"] + "\n");
        });
           

          

            if(abbonamentiGiugnoNew.length > 0){
              setOmbrelloneGiugno(abbonamentiGiugnoNew[0].ombrellone);
            }else{
              setOmbrelloneGiugno("");
            }
            if(abbonamentiLuglioNew.length > 0){
               setOmbrelloneLuglio(abbonamentiLuglioNew[0].ombrellone);
            }else{
              setOmbrelloneLuglio("");
            }
            if(abbonamentiAgostoNew.length > 0){
               setOmbrelloneAgosto(abbonamentiAgostoNew[0].ombrellone);
            }else{
              setOmbrelloneAgosto("");
            }
            if(abbonamentiSettembreNew.length > 0){
               setOmbrelloneSettembre(abbonamentiSettembreNew[0].ombrellone);
            }else{
              setOmbrelloneSettembre("");
            }
            handleCloseLoader();
        })

  }

  const caricaTuttiGliAbbonamenti = async () => {
 
    const abbonamentiAll = [];
    const abbonamentiGiugnoAll = [];
    const abbonamentiLuglioAll = [];
    const abbonamentiAgostoAll = [];
    const abbonamentiSettembreAll = [];

    await getDocs(collection(db, "Abbonamento2026"))
        .then((querySnapshot)=>{      
            console.log(querySnapshot.size);      
            querySnapshot.forEach(async documentSnapshot => {
                const rowData = documentSnapshot.data();
               

                  if(rowData.turnoAbbonamento === "Giugno"){
                      abbonamentiGiugnoAll.push({ id:documentSnapshot.id,
                        categoriaTitolare:rowData.categoriaTitolare,
                        cognomeTitolare:rowData.cognomeTitolare,
                        gradoParentela:rowData.gradoParentela,
                        idRichiestaTitolare:rowData.idRichiestaTitolare,
                        nomeCognomeAbbonato:rowData.nomeCognomeAbbonato,
                        nomeTitolare:rowData.nomeTitolare,
                        ombrellone:rowData.ombrellone,
                        turnoAbbonamento:rowData.turnoAbbonamento});
                  }
                  if(rowData.turnoAbbonamento === "Luglio"){
                      abbonamentiLuglioAll.push({ id:documentSnapshot.id,
                      categoriaTitolare:rowData.categoriaTitolare,
                      cognomeTitolare:rowData.cognomeTitolare,
                      gradoParentela:rowData.gradoParentela,
                      idRichiestaTitolare:rowData.idRichiestaTitolare,
                      nomeCognomeAbbonato:rowData.nomeCognomeAbbonato,
                      nomeTitolare:rowData.nomeTitolare,
                      ombrellone:rowData.ombrellone,
                      turnoAbbonamento:rowData.turnoAbbonamento});
                  }
                  if(rowData.turnoAbbonamento === "Agosto"){
                      abbonamentiAgostoAll.push({ id:documentSnapshot.id,
                        categoriaTitolare:rowData.categoriaTitolare,
                        cognomeTitolare:rowData.cognomeTitolare,
                        gradoParentela:rowData.gradoParentela,
                        idRichiestaTitolare:rowData.idRichiestaTitolare,
                        nomeCognomeAbbonato:rowData.nomeCognomeAbbonato,
                        nomeTitolare:rowData.nomeTitolare,
                        ombrellone:rowData.ombrellone,
                        turnoAbbonamento:rowData.turnoAbbonamento});
                  }
                  if(rowData.turnoAbbonamento === "Settembre"){
                      abbonamentiSettembreAll.push({ id:documentSnapshot.id,
                        categoriaTitolare:rowData.categoriaTitolare,
                        cognomeTitolare:rowData.cognomeTitolare,
                        gradoParentela:rowData.gradoParentela,
                        idRichiestaTitolare:rowData.idRichiestaTitolare,
                        nomeCognomeAbbonato:rowData.nomeCognomeAbbonato,
                        nomeTitolare:rowData.nomeTitolare,
                        ombrellone:rowData.ombrellone,
                        turnoAbbonamento:rowData.turnoAbbonamento});
                  }
                  abbonamentiAll.push({ id:documentSnapshot.id,
                  categoriaTitolare:rowData.categoriaTitolare,
                  cognomeTitolare:rowData.cognomeTitolare,
                  gradoParentela:rowData.gradoParentela,
                  idRichiestaTitolare:rowData.idRichiestaTitolare,
                  nomeCognomeAbbonato:rowData.nomeCognomeAbbonato,
                  nomeTitolare:rowData.nomeTitolare,
                  ombrellone:rowData.ombrellone,
                  turnoAbbonamento:rowData.turnoAbbonamento});
            
          });
          
          setAbbonamentiAll((arrAbbAll) => [...abbonamentiAll]);
          setAbbonamentiGiugnoAll((arrAbbGAll) => [...abbonamentiGiugnoAll]);
          setAbbonamentiLuglioAll((arrAbbLAll) => [...abbonamentiLuglioAll]);
          setAbbonamentiAgostoAll((arrAbbAAll) => [...abbonamentiAgostoAll]);
          setAbbonamentiSettembreAll((arrAbbSAll) => [...abbonamentiSettembreAll]);
          abbonamentiAll.forEach((element) => {
           console.log("abbonamentiNew element: " + "\n" + 
           "abbonamentiNew element id: " + element["id"] + "\n" + 
           "abbonamentiNew element categoriaTitolare: " + element["categoriaTitolare"] + "\n" +
           "abbonamentiNew element cognomeTitolare: " + element["cognomeTitolare"] + "\n" +
           "abbonamentiNew element idRichiestaTitolare: " + element["idRichiestaTitolare"] + "\n" +
           "abbonamentiNew element nomeCognomeAbbonato: " + element["nomeCognomeAbbonato"] + "\n" +
           "abbonamentiNew element nomeTitolare : " + element["nomeTitolare"] + "\n" +
           "abbonamentiNew element ombrellone: " + element["ombrellone"] + "\n" +
           "abbonamentiNew element turnoAbbonamento: " + element["turnoAbbonamento"] + "\n");
        });
           
          setRowsAll(abbonamentiAll);
          handleCloseLoader();
        })

  }


  const inviaEmailAbbonamenti = async () => {

    var toEmail = selectedRequest.emailTitolare;
  
    var messagePlain = "<strong>IMPORTANTE!<br>I QRCODE ASSOCIATI AI SINGOLI ABBONAMENTI SONO STATI RIGENERATI.<br>SE HAI SALVATO L'ABBONAMNETO IN FORMATO PDF TI INVITIAMO AD EFFETTUARE NUOVAMENTE IL DOWNLOAD.</strong><br><br> Gentile " + selectedRequest.nomeTitolare.toUpperCase() + " " + selectedRequest.cognomeTitolare.toUpperCase() + " ti riportiamo di seguito i tuoi abbonamenti.<br> Sarà tua cura condividere con i tuoi Familiari/Conviventi codici e modalità per l'accesso all'abbonamento da te richiesto.";
    messagePlain += "<br><br>";
    if(abbonamentiGiugno.length > 0){
      messagePlain += "<strong>ABBONAMENTI GIUGNO</strong><br><br>";
      for (const index in abbonamentiGiugno) {  
        if(abbonamentiGiugno[index].nomeCognomeAbbonato !== ""){
          messagePlain += abbonamentiGiugno[index].nomeCognomeAbbonato + " -- CODICE ABBONAMENTO: <strong>" + abbonamentiGiugno[index].idAbbonamento + "</strong><br>";
        }else{
          messagePlain += abbonamentiGiugno[index].nomeTitolare + " " + abbonamentiGiugno[index].cognomeTitolare + " -- CODICE ABBONAMENTO: <strong>" + abbonamentiGiugno[index].idAbbonamento + "</strong><br>";
        }
      }
    }
    messagePlain += "<br><br>";
    if(abbonamentiLuglio.length > 0){
      messagePlain += "<strong>ABBONAMENTI LUGLIO</strong><br><br>";
      for (const index in abbonamentiLuglio) {  
        if(abbonamentiLuglio[index].nomeCognomeAbbonato !== ""){
          messagePlain += abbonamentiLuglio[index].nomeCognomeAbbonato + " -- CODICE ABBONAMENTO: <strong>" + abbonamentiLuglio[index].idAbbonamento + "</strong><br>";
        }else{
          messagePlain += abbonamentiLuglio[index].nomeTitolare + " " + abbonamentiLuglio[index].cognomeTitolare + " -- CODICE ABBONAMENTO: <strong>" + abbonamentiLuglio[index].idAbbonamento + "</strong><br>";
        }
      }
    }
    messagePlain += "<br><br>";
    if(abbonamentiAgosto.length > 0){
      messagePlain += "<strong>ABBONAMENTI AGOSTO</strong><br><br>";
      for (const index in abbonamentiAgosto) {  
        if(abbonamentiAgosto[index].nomeCognomeAbbonato !== ""){
          messagePlain += abbonamentiAgosto[index].nomeCognomeAbbonato + " -- CODICE ABBONAMENTO: <strong>" + abbonamentiAgosto[index].idAbbonamento + "</strong><br>";
        }else{
          messagePlain += abbonamentiAgosto[index].nomeTitolare + " " + abbonamentiAgosto[index].cognomeTitolare + " -- CODICE ABBONAMENTO: <strong>" + abbonamentiAgosto[index].idAbbonamento + "</strong><br>";
        }
      }
    }
    messagePlain += "<br><br>";
    if(abbonamentiSettembre.length > 0){
      messagePlain += "<strong>ABBONAMENTI SETTEMBRE</strong><br><br>";
      for (const index in abbonamentiSettembre) {  
        if(abbonamentiSettembre[index].nomeCognomeAbbonato !== ""){
          messagePlain += abbonamentiSettembre[index].nomeCognomeAbbonato + " -- CODICE ABBONAMENTO: <strong>" + abbonamentiSettembre[index].idAbbonamento + "</strong><br>";
        }else{
          messagePlain += abbonamentiSettembre[index].nomeTitolare + " " + abbonamentiSettembre[index].cognomeTitolare + " -- CODICE ABBONAMENTO: <strong>" + abbonamentiSettembre[index].idAbbonamento + "</strong><br>";
        }
      }
    }
    messagePlain += "<br><br>";
    messagePlain += "Per visualizzare il singolo abbonamento utilizza il portale Campagna Abbonamenti 2026<br>";
    messagePlain += "Utilizza il pulsante in alto a destra IL TUO ABBONAMENTO e inserisci il codice abbonamento che vuoi visualizzare.<br>";
    messagePlain += "Potrai scaricare l'abbonamento anche in formato PDF."    
    messagePlain += "<br><br>Il Gestore";
  
    var messageHtml = messagePlain;
  
    console.log(messageHtml)
    
    sendEmail(messageHtml, messagePlain, toEmail, "DETTAGLI ABBONAMENTI");


  }

  const [selectedTotaleDaVersare, setSelectedSTotaleDaVersare] = useState("0.00");
  // Pagamento effettuato
  const [selectedPagamentoEffettuato, setSelectedPagamentoEffettuato] = useState("NO");
  const [selectedPagamentoEffettuatoError, setSelectedPagamentoEffettuatoError] = useState(false);
  const handlePagamentoEffettuatoSelectedChange = e => {
    setSelectedPagamentoEffettuato(e.target.value);
  }

  // ID
  const [selectedIdRichiesta, setSelectedIdRichiesta] = useState("");
  const [selectedIdRichiestaError, setSelectedIdRichiestaError] = useState(false);
  const handleIdRichiestaSelectedChange = e => {
    setSelectedIdRichiesta(e.target.value);
  }

 // StatoDocumentazione
 const [selectedStatoDocumentazione, setSelectedStatoDocumentazione] = useState("");
 const [selectedStatoDocumentazioneError, setSelectedStatoDocumentazioneError] = useState(false);
 const handleStatoDocumentazioneSelectedChange = e => {
   setSelectedStatoDocumentazione(e.target.value);
 }

   // Stato
   const [selectedStatoRichiesta, setSelectedStatoRichiesta] = useState("");
   const [selectedStatoRichiestaError, setSelectedStatoRichiestaError] = useState(false);
   const handleStatoRichiestaSelectedChange = e => {
     setSelectedStatoRichiesta(e.target.value);
   }
    // Approva Giugno 
  const [selectedApprovaGiugno, setSelectedApprovaGiugno] = useState("NO");
  const [selectedApprovaGiugnoError, setSelectedApprovaGiugnoError] = useState(false);
  const handleApprovaGiugnoSelectedChange = e => {
    setSelectedApprovaGiugno(e.target.value);
  }

     // Approva GiugnoEA1 
     const [selectedApprovaGiugnoEA1, setSelectedApprovaGiugnoEA1] = useState(2);
     const [selectedApprovaGiugnoEA1Error, setSelectedApprovaGiugnoEA1Error] = useState(false);
     const handleApprovaGiugnoEA1SelectedChange = e => {
       
      console.log("handleApprovaGiugnoEA1SelectedChange " + e.target.value);
      
      if(e.target.value === 1){
        calcolaQuotaFamiliare[0].calcolaGiugno= 1;
      
      }else{
        calcolaQuotaFamiliare[0].calcolaGiugno= 0;
      }
      
       calcolaCostoTotale(1);
       setSelectedApprovaGiugnoEA1(e.target.value);
     
     }

      // Approva GiugnoEA2 
      const [selectedApprovaGiugnoEA2, setSelectedApprovaGiugnoEA2] = useState(2);
      const [selectedApprovaGiugnoEA2Error, setSelectedApprovaGiugnoEA2Error] = useState(false);
      const handleApprovaGiugnoEA2SelectedChange = e => {
        console.log("handleApprovaGiugnoEA2SelectedChange " + e.target.value);
        if(e.target.value === 1){
          calcolaQuotaFamiliare[1].calcolaGiugno= 1;
        
        }else{
          calcolaQuotaFamiliare[1].calcolaGiugno= 0;
        }
        
         calcolaCostoTotale(2);
        setSelectedApprovaGiugnoEA2(e.target.value);
      }

      // Approva GiugnoEA3
      const [selectedApprovaGiugnoEA3, setSelectedApprovaGiugnoEA3] = useState(2);
      const [selectedApprovaGiugnoEA3Error, setSelectedApprovaGiugnoEA3Error] = useState(false);
      const handleApprovaGiugnoEA3SelectedChange = e => {
        console.log("handleApprovaGiugnoEA3SelectedChange " + e.target.value);
        if(e.target.value === 1){
          calcolaQuotaFamiliare[2].calcolaGiugno= 1;
        
        }else{
          calcolaQuotaFamiliare[2].calcolaGiugno= 0;
        }
        
         calcolaCostoTotale(3);
        setSelectedApprovaGiugnoEA3(e.target.value);
      }

      // Approva GiugnoEA4
      const [selectedApprovaGiugnoEA4, setSelectedApprovaGiugnoEA4] = useState(2);
      const [selectedApprovaGiugnoEA4Error, setSelectedApprovaGiugnoEA4Error] = useState(false);
      const handleApprovaGiugnoEA4SelectedChange = e => {
        if(e.target.value === 1){
          calcolaQuotaFamiliare[3].calcolaGiugno= 1;
        
        }else{
          calcolaQuotaFamiliare[3].calcolaGiugno= 0;
        }
        
         calcolaCostoTotale(4);
        setSelectedApprovaGiugnoEA4(e.target.value);
      }

      // Approva GiugnoEA5
      const [selectedApprovaGiugnoEA5, setSelectedApprovaGiugnoEA5] = useState(2);
      const [selectedApprovaGiugnoEA5Error, setSelectedApprovaGiugnoEA5Error] = useState(false);
      const handleApprovaGiugnoEA5SelectedChange = e => {
        if(e.target.value === 1){
          calcolaQuotaFamiliare[4].calcolaGiugno= 1;
        
        }else{
          calcolaQuotaFamiliare[4].calcolaGiugno= 0;
        }
        
         calcolaCostoTotale(5);
        setSelectedApprovaGiugnoEA5(e.target.value);
      }

       // Approva GiugnoEA6
       const [selectedApprovaGiugnoEA6, setSelectedApprovaGiugnoEA6] = useState(2);
       const [selectedApprovaGiugnoEA6Error, setSelectedApprovaGiugnoEA6Error] = useState(false);
       const handleApprovaGiugnoEA6SelectedChange = e => {
        if(e.target.value === 1){
          calcolaQuotaFamiliare[5].calcolaGiugno= 1;
        
        }else{
          calcolaQuotaFamiliare[5].calcolaGiugno= 0;
        }
        
         calcolaCostoTotale(6);
         setSelectedApprovaGiugnoEA6(e.target.value);
       }

       // Approva GiugnoEA7
       const [selectedApprovaGiugnoEA7, setSelectedApprovaGiugnoEA7] = useState(2);
       const [selectedApprovaGiugnoEA7Error, setSelectedApprovaGiugnoEA7Error] = useState(false);
       const handleApprovaGiugnoEA7SelectedChange = e => {
        if(e.target.value === 1){
          calcolaQuotaFamiliare[6].calcolaGiugno= 1;
        
        }else{
          calcolaQuotaFamiliare[6].calcolaGiugno= 0;
        }
        
         calcolaCostoTotale(7);
         setSelectedApprovaGiugnoEA7(e.target.value);
       }

      // Approva GiugnoEA8
      const [selectedApprovaGiugnoEA8, setSelectedApprovaGiugnoEA8] = useState(2);
      const [selectedApprovaGiugnoEA8Error, setSelectedApprovaGiugnoEA8Error] = useState(false);
      const handleApprovaGiugnoEA8SelectedChange = e => {
        if(e.target.value === 1){
          calcolaQuotaFamiliare[7].calcolaGiugno= 1;
        
        }else{
          calcolaQuotaFamiliare[7].calcolaGiugno= 0;
        }
        
         calcolaCostoTotale(8);
        setSelectedApprovaGiugnoEA8(e.target.value);
      }

      // Approva GiugnoEA9
      const [selectedApprovaGiugnoEA9, setSelectedApprovaGiugnoEA9] = useState(2);
      const [selectedApprovaGiugnoEA9Error, setSelectedApprovaGiugnoEA9Error] = useState(false);
      const handleApprovaGiugnoEA9SelectedChange = e => {
        if(e.target.value === 1){
          calcolaQuotaFamiliare[8].calcolaGiugno= 1;
        
        }else{
          calcolaQuotaFamiliare[8].calcolaGiugno= 0;
        }
        
         calcolaCostoTotale(9);
        setSelectedApprovaGiugnoEA9(e.target.value);
      }

      // Approva GiugnoEA10
      const [selectedApprovaGiugnoEA10, setSelectedApprovaGiugnoEA10] = useState(2);
      const [selectedApprovaGiugnoEA10Error, setSelectedApprovaGiugnoEA10Error] = useState(false);
      const handleApprovaGiugnoEA10SelectedChange = e => {
        console.log("handleApprovaGiugnoEA10SelectedChange " + e.target.value);
        if(e.target.value === 1){
          calcolaQuotaFamiliare[9].calcolaGiugno= 1;
        
        }else{
          calcolaQuotaFamiliare[9].calcolaGiugno= 0;
        }
        
         calcolaCostoTotale(10);
        setSelectedApprovaGiugnoEA10(e.target.value);
      }
 

  // Approva Luglio 
  const [selectedApprovaLuglio, setSelectedApprovaLuglio] = useState("NO");
  const [selectedApprovaLuglioError, setSelectedApprovaLuglioError] = useState(false);
  const handleApprovaLuglioSelectedChange = e => {
    setSelectedApprovaLuglio(e.target.value);
  }

   // Approva LuglioEA1 
   const [selectedApprovaLuglioEA1, setSelectedApprovaLuglioEA1] = useState(2);
   const [selectedApprovaLuglioEA1Error, setSelectedApprovaLuglioEA1Error] = useState(false);
   const handleApprovaLuglioEA1SelectedChange = e => {
    console.log("handleApprovaLuglioEA1SelectedChange " + e.target.value);
      
      if(e.target.value === 1){
        calcolaQuotaFamiliare[0].calcolaLuglio = 1;
      }else{
        calcolaQuotaFamiliare[0].calcolaLuglio = 0;
      }
      
      
       calcolaCostoTotale(1);
     setSelectedApprovaLuglioEA1(e.target.value);
   
   }

    // Approva LuglioEA2 
    const [selectedApprovaLuglioEA2, setSelectedApprovaLuglioEA2] = useState(2);
    const [selectedApprovaLuglioEA2Error, setSelectedApprovaLuglioEA2Error] = useState(false);
    const handleApprovaLuglioEA2SelectedChange = e => {
      console.log("handleApprovaLuglioEA2SelectedChange " + e.target.value);
      if(e.target.value === 1){
        calcolaQuotaFamiliare[1].calcolaLuglio = 1;
      }else{
        calcolaQuotaFamiliare[1].calcolaLuglio = 0;
      }
      
      
       calcolaCostoTotale(2);
      setSelectedApprovaLuglioEA2(e.target.value);
    }

    // Approva LuglioEA3
    const [selectedApprovaLuglioEA3, setSelectedApprovaLuglioEA3] = useState(2);
    const [selectedApprovaLuglioEA3Error, setSelectedApprovaLuglioEA3Error] = useState(false);
    const handleApprovaLuglioEA3SelectedChange = e => {
      console.log("handleApprovaLuglioEA3SelectedChange " + e.target.value);
      if(e.target.value === 1){
        calcolaQuotaFamiliare[2].calcolaLuglio = 1;
      }else{
        calcolaQuotaFamiliare[2].calcolaLuglio = 0;
      }
      
      
       calcolaCostoTotale(3);
      setSelectedApprovaLuglioEA3(e.target.value);
    }

    // Approva LuglioEA4
    const [selectedApprovaLuglioEA4, setSelectedApprovaLuglioEA4] = useState(2);
    const [selectedApprovaLuglioEA4Error, setSelectedApprovaLuglioEA4Error] = useState(false);
    const handleApprovaLuglioEA4SelectedChange = e => {
      if(e.target.value === 1){
        calcolaQuotaFamiliare[3].calcolaLuglio = 1;
      }else{
        calcolaQuotaFamiliare[3].calcolaLuglio = 0;
      }
      
      
       calcolaCostoTotale(4);
      setSelectedApprovaLuglioEA4(e.target.value);
    }

    // Approva LuglioEA5
    const [selectedApprovaLuglioEA5, setSelectedApprovaLuglioEA5] = useState(2);
    const [selectedApprovaLuglioEA5Error, setSelectedApprovaLuglioEA5Error] = useState(false);
    const handleApprovaLuglioEA5SelectedChange = e => {
      if(e.target.value === 1){
        calcolaQuotaFamiliare[4].calcolaLuglio = 1;
      }else{
        calcolaQuotaFamiliare[4].calcolaLuglio = 0;
      }
      
      
       calcolaCostoTotale(5);
      setSelectedApprovaLuglioEA5(e.target.value);
    }

     // Approva LuglioEA6
     const [selectedApprovaLuglioEA6, setSelectedApprovaLuglioEA6] = useState(2);
     const [selectedApprovaLuglioEA6Error, setSelectedApprovaLuglioEA6Error] = useState(false);
     const handleApprovaLuglioEA6SelectedChange = e => {
      if(e.target.value === 1){
        calcolaQuotaFamiliare[5].calcolaLuglio = 1;
      }else{
        calcolaQuotaFamiliare[5].calcolaLuglio = 0;
      }
      
      
       calcolaCostoTotale(6);
       setSelectedApprovaLuglioEA6(e.target.value);
     }

     // Approva LuglioEA7
     const [selectedApprovaLuglioEA7, setSelectedApprovaLuglioEA7] = useState(2);
     const [selectedApprovaLuglioEA7Error, setSelectedApprovaLuglioEA7Error] = useState(false);
     const handleApprovaLuglioEA7SelectedChange = e => {
      if(e.target.value === 1){
        calcolaQuotaFamiliare[6].calcolaLuglio = 1;
      }else{
        calcolaQuotaFamiliare[6].calcolaLuglio = 0;
      }
      
      
       calcolaCostoTotale(7);
       setSelectedApprovaLuglioEA7(e.target.value);
     }

    // Approva LuglioEA8
    const [selectedApprovaLuglioEA8, setSelectedApprovaLuglioEA8] = useState(2);
    const [selectedApprovaLuglioEA8Error, setSelectedApprovaLuglioEA8Error] = useState(false);
    const handleApprovaLuglioEA8SelectedChange = e => {
      if(e.target.value === 1){
        calcolaQuotaFamiliare[7].calcolaLuglio = 1;
      }else{
        calcolaQuotaFamiliare[7].calcolaLuglio = 0;
      }
      
      
       calcolaCostoTotale(8);
      setSelectedApprovaLuglioEA8(e.target.value);
    }

    // Approva LuglioEA9
    const [selectedApprovaLuglioEA9, setSelectedApprovaLuglioEA9] = useState(2);
    const [selectedApprovaLuglioEA9Error, setSelectedApprovaLuglioEA9Error] = useState(false);
    const handleApprovaLuglioEA9SelectedChange = e => {
      if(e.target.value === 1){
        calcolaQuotaFamiliare[8].calcolaLuglio = 1;
      }else{
        calcolaQuotaFamiliare[8].calcolaLuglio = 0;
      }
      
      
       calcolaCostoTotale(9);
      setSelectedApprovaLuglioEA9(e.target.value);
    }

    // Approva LuglioEA10
    const [selectedApprovaLuglioEA10, setSelectedApprovaLuglioEA10] = useState(2);
    const [selectedApprovaLuglioEA10Error, setSelectedApprovaLuglioEA10Error] = useState(false);
    const handleApprovaLuglioEA10SelectedChange = e => {
      if(e.target.value === 1){
        calcolaQuotaFamiliare[9].calcolaLuglio = 1;
      }else{
        calcolaQuotaFamiliare[9].calcolaLuglio = 0;
      }
      
      
       calcolaCostoTotale(10);
      setSelectedApprovaLuglioEA10(e.target.value);
    }


  // Approva Agosto 
  const [selectedApprovaAgosto, setSelectedApprovaAgosto] = useState("NO");
  const [selectedApprovaAgostoError, setSelectedApprovaAgostoError] = useState(false);
  const handleApprovaAgostoSelectedChange = e => {
    setSelectedApprovaAgosto(e.target.value);
  }

  // Approva AgostoEA1 
  const [selectedApprovaAgostoEA1, setSelectedApprovaAgostoEA1] = useState(2);
  const [selectedApprovaAgostoEA1Error, setSelectedApprovaAgostoEA1Error] = useState(false);
  const handleApprovaAgostoEA1SelectedChange = e => {
    console.log("handleApprovaAgostoEA1SelectedChange " + e.target.value);
      
      if(e.target.value === 1){
        calcolaQuotaFamiliare[0].calcolaAgosto = 1;
      }else{
        calcolaQuotaFamiliare[0].calcolaAgosto = 0;
      }
      
       calcolaCostoTotale(1);
    setSelectedApprovaAgostoEA1(e.target.value);
  }

   // Approva AgostoEA2 
   const [selectedApprovaAgostoEA2, setSelectedApprovaAgostoEA2] = useState(2);
   const [selectedApprovaAgostoEA2Error, setSelectedApprovaAgostoEA2Error] = useState(false);
   const handleApprovaAgostoEA2SelectedChange = e => {
    console.log("handleApprovaAgostoEA2SelectedChange " + e.target.value);
    if(e.target.value === 1){
      calcolaQuotaFamiliare[1].calcolaAgosto = 1;
    }else{
      calcolaQuotaFamiliare[1].calcolaAgosto = 0;
    }
    
     calcolaCostoTotale(2);
     setSelectedApprovaAgostoEA2(e.target.value);
   }

   // Approva AgostoEA3
   const [selectedApprovaAgostoEA3, setSelectedApprovaAgostoEA3] = useState(2);
   const [selectedApprovaAgostoEA3Error, setSelectedApprovaAgostoEA3Error] = useState(false);
   const handleApprovaAgostoEA3SelectedChange = e => {
    console.log("handleApprovaAgostoEA3SelectedChange " + e.target.value);
    if(e.target.value === 1){
      calcolaQuotaFamiliare[2].calcolaAgosto = 1;
    }else{
      calcolaQuotaFamiliare[2].calcolaAgosto = 0;
    }
    
     calcolaCostoTotale(3);
     setSelectedApprovaAgostoEA3(e.target.value);
   }

   // Approva AgostoEA4
   const [selectedApprovaAgostoEA4, setSelectedApprovaAgostoEA4] = useState(2);
   const [selectedApprovaAgostoEA4Error, setSelectedApprovaAgostoEA4Error] = useState(false);
   const handleApprovaAgostoEA4SelectedChange = e => {
    if(e.target.value === 1){
      calcolaQuotaFamiliare[3].calcolaAgosto = 1;
    }else{
      calcolaQuotaFamiliare[3].calcolaAgosto = 0;
    }
    
     calcolaCostoTotale(4);
     setSelectedApprovaAgostoEA4(e.target.value);
   }

   // Approva AgostoEA5
   const [selectedApprovaAgostoEA5, setSelectedApprovaAgostoEA5] = useState(2);
   const [selectedApprovaAgostoEA5Error, setSelectedApprovaAgostoEA5Error] = useState(false);
   const handleApprovaAgostoEA5SelectedChange = e => {
    if(e.target.value === 1){
      calcolaQuotaFamiliare[4].calcolaAgosto = 1;
    }else{
      calcolaQuotaFamiliare[4].calcolaAgosto = 0;
    }
    
     calcolaCostoTotale(5);
     setSelectedApprovaAgostoEA5(e.target.value);
   }

    // Approva AgostoEA6
    const [selectedApprovaAgostoEA6, setSelectedApprovaAgostoEA6] = useState(2);
    const [selectedApprovaAgostoEA6Error, setSelectedApprovaAgostoEA6Error] = useState(false);
    const handleApprovaAgostoEA6SelectedChange = e => {
      if(e.target.value === 1){
        calcolaQuotaFamiliare[5].calcolaAgosto = 1;
      }else{
        calcolaQuotaFamiliare[5].calcolaAgosto = 0;
      }
      
       calcolaCostoTotale(6);
      setSelectedApprovaAgostoEA6(e.target.value);
    }

    // Approva AgostoEA7
    const [selectedApprovaAgostoEA7, setSelectedApprovaAgostoEA7] = useState(2);
    const [selectedApprovaAgostoEA7Error, setSelectedApprovaAgostoEA7Error] = useState(false);
    const handleApprovaAgostoEA7SelectedChange = e => {
      if(e.target.value === 1){
        calcolaQuotaFamiliare[6].calcolaAgosto = 1;
      }else{
        calcolaQuotaFamiliare[6].calcolaAgosto = 0;
      }
      
       calcolaCostoTotale(7);
      setSelectedApprovaAgostoEA7(e.target.value);
    }

   // Approva AgostoEA8
   const [selectedApprovaAgostoEA8, setSelectedApprovaAgostoEA8] = useState(2);
   const [selectedApprovaAgostoEA8Error, setSelectedApprovaAgostoEA8Error] = useState(false);
   const handleApprovaAgostoEA8SelectedChange = e => {
    if(e.target.value === 1){
      calcolaQuotaFamiliare[7].calcolaAgosto = 1;
    }else{
      calcolaQuotaFamiliare[7].calcolaAgosto = 0;
    }
    
     calcolaCostoTotale(8);
     setSelectedApprovaAgostoEA8(e.target.value);
   }

   // Approva AgostoEA9
   const [selectedApprovaAgostoEA9, setSelectedApprovaAgostoEA9] = useState(2);
   const [selectedApprovaAgostoEA9Error, setSelectedApprovaAgostoEA9Error] = useState(false);
   const handleApprovaAgostoEA9SelectedChange = e => {
    if(e.target.value === 1){
      calcolaQuotaFamiliare[8].calcolaAgosto = 1;
    }else{
      calcolaQuotaFamiliare[8].calcolaAgosto = 0;
    }
    
     calcolaCostoTotale(9);
     setSelectedApprovaAgostoEA9(e.target.value);
   }

   // Approva AgostoEA10
   const [selectedApprovaAgostoEA10, setSelectedApprovaAgostoEA10] = useState(2);
   const [selectedApprovaAgostoEA10Error, setSelectedApprovaAgostoEA10Error] = useState(false);
   const handleApprovaAgostoEA10SelectedChange = e => {
    if(e.target.value === 1){
      calcolaQuotaFamiliare[9].calcolaAgosto = 1;
    }else{
      calcolaQuotaFamiliare[9].calcolaAgosto = 0;
    }
    
     calcolaCostoTotale(10);
     setSelectedApprovaAgostoEA10(e.target.value);
   }

  // Approva Settembre 
  const [selectedApprovaSettembre, setSelectedApprovaSettembre] = useState("NO");
  const [selectedApprovaSettembreError, setSelectedApprovaSettembreError] = useState(false);
  const handleApprovaSettembreSelectedChange = e => {
    setSelectedApprovaSettembre(e.target.value);
  }

  // Approva SettembreEA1 
  const [selectedApprovaSettembreEA1, setSelectedApprovaSettembreEA1] = useState(2);
  const [selectedApprovaSettembreEA1Error, setSelectedApprovaSettembreEA1Error] = useState(false);
  const handleApprovaSettembreEA1SelectedChange = e => {
    console.log("handleApprovaSettembreEA1SelectedChange " + e.target.value);
      
    if(e.target.value === 1){
      calcolaQuotaFamiliare[0].calcolaSettembre = 1;
    }else{
      calcolaQuotaFamiliare[0].calcolaSettembre  = 0;
    }
    calcolaCostoTotale(1);
    setSelectedApprovaSettembreEA1(e.target.value);
    
  }

   // Approva SettembreEA2 
   const [selectedApprovaSettembreEA2, setSelectedApprovaSettembreEA2] = useState(2);
   const [selectedApprovaSettembreEA2Error, setSelectedApprovaSettembreEA2Error] = useState(false);
   const handleApprovaSettembreEA2SelectedChange = e => {
    console.log("handleApprovaSettembreEA2SelectedChange " + e.target.value);
    if(e.target.value === 1){
      calcolaQuotaFamiliare[1].calcolaSettembre = 1;
    }else{
      calcolaQuotaFamiliare[1].calcolaSettembre  = 0;
    }
    calcolaCostoTotale(2);
     setSelectedApprovaSettembreEA2(e.target.value);
   }

   // Approva SettembreEA3
   const [selectedApprovaSettembreEA3, setSelectedApprovaSettembreEA3] = useState(2);
   const [selectedApprovaSettembreEA3Error, setSelectedApprovaSettembreEA3Error] = useState(false);
   const handleApprovaSettembreEA3SelectedChange = e => {
    console.log("handleApprovaSettembreEA3SelectedChange " + e.target.value);
    if(e.target.value === 1){
      calcolaQuotaFamiliare[2].calcolaSettembre = 1;
    }else{
      calcolaQuotaFamiliare[2].calcolaSettembre  = 0;
    }
    calcolaCostoTotale(3);
     setSelectedApprovaSettembreEA3(e.target.value);
   }

   // Approva SettembreEA4
   const [selectedApprovaSettembreEA4, setSelectedApprovaSettembreEA4] = useState(2);
   const [selectedApprovaSettembreEA4Error, setSelectedApprovaSettembreEA4Error] = useState(false);
   const handleApprovaSettembreEA4SelectedChange = e => {
    if(e.target.value === 1){
      calcolaQuotaFamiliare[3].calcolaSettembre = 1;
    }else{
      calcolaQuotaFamiliare[3].calcolaSettembre  = 0;
    }
    calcolaCostoTotale(4);
     setSelectedApprovaSettembreEA4(e.target.value);
   }

   // Approva SettembreEA5
   const [selectedApprovaSettembreEA5, setSelectedApprovaSettembreEA5] = useState(2);
   const [selectedApprovaSettembreEA5Error, setSelectedApprovaSettembreEA5Error] = useState(false);
   const handleApprovaSettembreEA5SelectedChange = e => {
    if(e.target.value === 1){
      calcolaQuotaFamiliare[4].calcolaSettembre = 1;
    }else{
      calcolaQuotaFamiliare[4].calcolaSettembre  = 0;
    }
    calcolaCostoTotale(5);
     setSelectedApprovaSettembreEA5(e.target.value);
   }

    // Approva SettembreEA6
    const [selectedApprovaSettembreEA6, setSelectedApprovaSettembreEA6] = useState(2);
    const [selectedApprovaSettembreEA6Error, setSelectedApprovaSettembreEA6Error] = useState(false);
    const handleApprovaSettembreEA6SelectedChange = e => {
      if(e.target.value === 1){
        calcolaQuotaFamiliare[5].calcolaSettembre = 1;
      }else{
        calcolaQuotaFamiliare[5].calcolaSettembre  = 0;
      }
      calcolaCostoTotale(6);
      setSelectedApprovaSettembreEA6(e.target.value);
    }

    // Approva SettembreEA7
    const [selectedApprovaSettembreEA7, setSelectedApprovaSettembreEA7] = useState(2);
    const [selectedApprovaSettembreEA7Error, setSelectedApprovaSettembreEA7Error] = useState(false);
    const handleApprovaSettembreEA7SelectedChange = e => {
      if(e.target.value === 1){
        calcolaQuotaFamiliare[6].calcolaSettembre = 1;
      }else{
        calcolaQuotaFamiliare[6].calcolaSettembre  = 0;
      }
      calcolaCostoTotale(7);
      setSelectedApprovaSettembreEA7(e.target.value);
    }

   // Approva SettembreEA8
   const [selectedApprovaSettembreEA8, setSelectedApprovaSettembreEA8] = useState(2);
   const [selectedApprovaSettembreEA8Error, setSelectedApprovaSettembreEA8Error] = useState(false);
   const handleApprovaSettembreEA8SelectedChange = e => {
    if(e.target.value === 1){
      calcolaQuotaFamiliare[7].calcolaSettembre = 1;
    }else{
      calcolaQuotaFamiliare[7].calcolaSettembre  = 0;
    }
    calcolaCostoTotale(8);
     setSelectedApprovaSettembreEA8(e.target.value);
   }

   // Approva SettembreEA9
   const [selectedApprovaSettembreEA9, setSelectedApprovaSettembreEA9] = useState(2);
   const [selectedApprovaSettembreEA9Error, setSelectedApprovaSettembreEA9Error] = useState(false);
   const handleApprovaSettembreEA9SelectedChange = e => {
    if(e.target.value === 1){
      calcolaQuotaFamiliare[8].calcolaSettembre = 1;
    }else{
      calcolaQuotaFamiliare[8].calcolaSettembre  = 0;
    }
    calcolaCostoTotale(7);
     setSelectedApprovaSettembreEA9(e.target.value);
   }

   // Approva SettembreEA10
   const [selectedApprovaSettembreEA10, setSelectedApprovaSettembreEA10] = useState(2);
   const [selectedApprovaSettembreEA10Error, setSelectedApprovaSettembreEA10Error] = useState(false);
   const handleApprovaSettembreEA10SelectedChange = e => {
    if(e.target.value === 1){
      calcolaQuotaFamiliare[9].calcolaSettembre = 1;
    }else{
      calcolaQuotaFamiliare[9].calcolaSettembre  = 0;
    }
    calcolaCostoTotale(10);
     setSelectedApprovaSettembreEA10(e.target.value);
   }

   const [costoTotaleEA1, setCostoTotaleEA1] = useState(0);

 

   const [costoTotaleEA2, setCostoTotaleEA2] = useState(0);
   const [costoTotaleEA3, setCostoTotaleEA3] = useState(0);
   const [costoTotaleEA4, setCostoTotaleEA4] = useState(0);
   const [costoTotaleEA5, setCostoTotaleEA5] = useState(0);
   const [costoTotaleEA6, setCostoTotaleEA6] = useState(0);
   const [costoTotaleEA7, setCostoTotaleEA7] = useState(0);
   const [costoTotaleEA8, setCostoTotaleEA8] = useState(0);
   const [costoTotaleEA9, setCostoTotaleEA9] = useState(0);
   const [costoTotaleEA10, setCostoTotaleEA10] = useState(0);

   

   function calcolaCostoTotale(ean){

    console.log("calcolaCostoTotaleEA1");
    
    let costoGiugno = parseFloat(categoria.find(o => o.value === selectedRequest.categoriaDiAppartenenza.toUpperCase()).halfMonth.toUpperCase()).toFixed(2);
    let costoLuglio = parseFloat(categoria.find(o => o.value === selectedRequest.categoriaDiAppartenenza.toUpperCase()).fullMonth.toUpperCase()).toFixed(2);
    let costoAgosto = parseFloat(categoria.find(o => o.value === selectedRequest.categoriaDiAppartenenza.toUpperCase()).fullMonth.toUpperCase()).toFixed(2);
    let costoSettembre = parseFloat(categoria.find(o => o.value === selectedRequest.categoriaDiAppartenenza.toUpperCase()).halfMonth.toUpperCase()).toFixed(2);

    let costoTotaleGiugno = (costoGiugno * calcolaQuotaFamiliare[ean - 1].calcolaGiugno);
    let costoTotaleLuglio = (costoLuglio * calcolaQuotaFamiliare[ean - 1].calcolaLuglio);
    let costoTotaleAgosto = (costoAgosto * calcolaQuotaFamiliare[ean - 1].calcolaAgosto) ;
    let costoTotaleSettembre = (costoSettembre * calcolaQuotaFamiliare[ean - 1].calcolaSettembre);

    let tot = parseFloat(costoTotaleGiugno + costoTotaleLuglio + costoTotaleAgosto + costoTotaleSettembre).toFixed(2);


    console.log("calcolaCostoTotaleEA" + ean + " >>> tot: " + tot);

    switch(ean){
      case 1:
        setCostoTotaleEA1(tot);
        break;
        case 2:
        setCostoTotaleEA2(tot);
        break;
        case 3:
        setCostoTotaleEA3(tot);
        break;
        case 4:
        setCostoTotaleEA4(tot);
        break;
        case 5:
        setCostoTotaleEA5(tot);
        break;
        case 6:
        setCostoTotaleEA6(tot);
        break;
        case 7:
        setCostoTotaleEA7(tot);
        break;
        case 8:
        setCostoTotaleEA8(tot);
        break;
        case 9:
        setCostoTotaleEA9(tot);
        break;
        case 10:
        setCostoTotaleEA10(tot);
        break;
    }
   
  }


  const [counterAll, setCounterAll] = React.useState(0);
  const [counterA, setCounterA] = React.useState(0);
  const [counterB, setCounterB] = React.useState(0);
  const [counterC, setCounterC] = React.useState(0);
  const [counterD, setCounterD] = React.useState(0);
  const [counterE, setCounterE] = React.useState(0);
  const [counterF, setCounterF] = React.useState(0);
  const [counterG, setCounterG] = React.useState(0);
  const [counterH, setCounterH] = React.useState(0);
  const [counterI, setCounterI] = React.useState(0);

  const [counterJun, setCounterJun] = React.useState(0);
  const [counterJul, setCounterJul] = React.useState(0);
  const [counterAug, setCounterAug] = React.useState(0);
  const [counterSep, setCounterSep] = React.useState(0);

  const [approvedCounterJun, setApprovedCounterJun] = React.useState(0);
  const [approvedCounterJul, setApprovedCounterJul] = React.useState(0);
  const [approvedCounterAug, setApprovedCounterAug] = React.useState(0);
  const [approvedCounterSep, setApprovedCounterSep] = React.useState(0);

  const chiudiDettagliRichiesta = async () => {
    
    setShowDetails(false);
}

const [selectedRequest, setSelectedRequest] = React.useState(null);



    function RenderDate(props) {

        const caricaDettagliRichiesta = async () => {
            console.log(props.row);
            handleOpenLoader(true);
            await fetchRichiesta(props.row.id);

            handleCloseLoader(true);
            setShowDetails(true);
        }

        const { hasFocus, value } = props;
        const buttonElement = React.useRef(null);
        const rippleRef = React.useRef(null);
      
        React.useLayoutEffect(() => {
          if (hasFocus) {
            const input = buttonElement.current.querySelector('input');
            input?.focus();
          } else if (rippleRef.current) {
            // Only available in @mui/material v5.4.1 or later
            rippleRef.current.stop({});
          }
        }, [hasFocus]);
      
        return (
          <strong>
            <Button
              ref={buttonElement}
              touchRippleRef={rippleRef}
              variant="contained"
              size="small"
              style={{ marginLeft: 16 }}
              // Remove button from tab sequence when cell does not have focus
              tabIndex={hasFocus ? 0 : -1}
              onKeyDown={(event) => {
                if (event.key === ' ') {
                  // Prevent key navigation when focus is on button
                  event.stopPropagation();
                }
              }}
              onClick={caricaDettagliRichiesta}
            >
              APRI
            </Button>
          </strong>
        );
      }

      const columnsAll = [
        { field: 'id', headerName: 'ID', width: 1 },
        {
            field: 'categoriaTitolare',
            headerName: 'Cat.',
            width: 50,
            editable: false,
        },
        {
          field: 'nomeTitolare',
          headerName: 'Nome Titolare',
          width: 150,
          editable: false,
        },
        {
          field: 'cognomeTitolare',
          headerName: 'Cognome Titolare',
          width: 150,
          editable: false,
        },
        {
            field: 'turnoAbbonamento',
            headerName: 'Turno',
            width: 100,
            editable: false,
          },
          {
            field: 'ombrellone',
            headerName: 'Ombrellone',
            width: 70,
            editable: false,
          },
          {
            field: 'nomeCognomeAbbonato',
            headerName: 'Nome Cognome Abbonato',
            width: 250,
            editable: false,
          },
          {
            field: 'gradoParentela',
            headerName: 'Grado parentale Abbonato-Titolare',
            width: 250,
            editable: false,
          },
          {
            field: 'idRichiestaTitolare',
            headerName: 'Richiesta',
            width: 280,
            editable: false,
          }
          
      ];

    const columns = [
        { field: 'id', headerName: 'ID', width: 1 },
        {
            field: 'categoriaDiAppartenenza',
            headerName: 'Cat.',
            width: 50,
            editable: false,
        },
        {
          field: 'nomeTitolare',
          headerName: 'Nome',
          width: 150,
          editable: false,
        },
        {
          field: 'cognomeTitolare',
          headerName: 'Cognome',
          width: 150,
          editable: false,
        },
        {
            field: 'gradoTitolare',
            headerName: 'Grado o Area Funzionale',
            width: 280,
            editable: false,
          },
          {
            field: 'enteDiservizioTitolare',
            headerName: 'Ente-Comando-Ammministrazione',
            width: 280,
            editable: false,
          },
          {
            field: 'turnoGiugno',
            headerName: 'GIUGNO',
            width: 80,
            editable: false,
          },
          {
            field: 'turnoLuglio',
            headerName: 'LUGLIO',
            width: 80,
            editable: false,
          },
          {
            field: 'prioritaTurnoLuglio',
            headerName: 'PR. LUGLIO',
            width: 80,
            editable: false,
          },
          {
            field: 'turnoAgosto',
            headerName: 'AGOSTO',
            width: 80,
            editable: false,
          },
          {
            field: 'prioritaTurnoAgosto',
            headerName: 'PR. AGOSTO',
            width: 80,
            editable: false,
          },
          {
            field: 'turnoSettembre',
            headerName: 'SETTEMBRE',
            width: 120,
            editable: false,
          },
          {
            field: 'numeroAltriAbbonamenti',
            headerName: 'ALTRI ABB.TI',
            width: 100,
            editable: false,
          },
          {
            field: 'emailTitolare',
            headerName: 'Email',
            width: 180,
            editable: false,
          },
          {
            field: 'documentiAllegati',
            headerName: 'VERIFICA DOC.TI',
            width: 120,
            editable: false,
          },
          {
            field: 'stato',
            headerName: 'Stato',
            width: 120,
            editable: false,
          },
          {
            field: 'daPagare',
            headerName: 'Da Pagare',
            width: 120,
            editable: false,
          },
          {
            field: 'pagato',
            headerName: 'Pagato',
            width: 120,
            editable: false,
          },
          {
            field: "action",
            headerName: "Azioni",
            sortable: false,
            renderCell: RenderDate,
          },
      ];

      function CustomTabPanel(props) {
        const { children, value, index, ...other } = props;
      
        return (
          <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
          >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
          </div>
        );
      }
      
      CustomTabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
      };
      
      function a11yProps(index) {
        return {
          id: `simple-tab-${index}`,
          'aria-controls': `simple-tabpanel-${index}`,
        };
      }

      const [valueTab, setValueTab] = React.useState(0);
      const [showOmbrelloni, setShowOmbrelloni] = React.useState(false);
      

      const handleChangeTab = (event, newValue) => {
        console.log("handleChangeTab " + newValue);
        setShowOmbrelloni(newValue === 4);
        setValueTab(newValue);
      };

    const [rows, setRows] = useState([]);
    const [rowsAll, setRowsAll] = useState([]);

    const [openLoader, setOpenLoader] = React.useState(false);
    const handleOpenLoader = () => setOpenLoader(true);
    const handleCloseLoader = () => setOpenLoader(false);

    const caricaRichieste = async () => {
        handleOpenLoader();
        var allCounter = 0;
        var aCounter = 0;
        var bCounter = 0;
        var cCounter = 0;
        var dCounter = 0;
        var eCounter = 0;
        var fCounter = 0;
        var gCounter = 0;
        var hCounter = 0;
        var iCounter = 0;

        var junCounter = 0;
        var julCounter = 0;
        var augCounter = 0;
        var sepCounter = 0;

        var junApprovedCounter = 0;
        var julApprovedCounter = 0;
        var augApprovedCounter = 0;
        var sepApprovedCounter = 0;

        await getDocs(collection(db, "Richieste2026"))
        .then((querySnapshot)=>{      
            console.log(querySnapshot.size);      
            let rows = [];  
            querySnapshot.forEach(async documentSnapshot => {
                const rowData = documentSnapshot.data();
                //console.log(rowData);
                let ente = "";
                if(rowData.categoriaDiAppartenenza === "A-M" || rowData.categoriaDiAppartenenza === "A-C" || rowData.categoriaDiAppartenenza === "E"){
                  ente = "ACCADEMIA AERONAUTICA";
                }else if(rowData.categoriaDiAppartenenza === "C" || rowData.categoriaDiAppartenenza === "E" || rowData.categoriaDiAppartenenza === "F" || rowData.categoriaDiAppartenenza === "G"){
                  ente = rowData.ultimoEnteDiServizioTitolare.toUpperCase();
                }else{
                  ente = rowData.enteDiservizioTitolare.toUpperCase();
                }
                if(rowData.categoriaDiAppartenenza === "A-M" || rowData.categoriaDiAppartenenza === "A-C"){
                  aCounter += 1;
                }
                if(rowData.categoriaDiAppartenenza === "B-M" || rowData.categoriaDiAppartenenza === "B-C"){
                  bCounter += 1;
                }
                if(rowData.categoriaDiAppartenenza === "D-M" || rowData.categoriaDiAppartenenza === "D-C"){
                  dCounter += 1;
                }
                if(rowData.categoriaDiAppartenenza === "C"){
                  cCounter += 1;
                }
                if(rowData.categoriaDiAppartenenza === "E"){
                  eCounter += 1;
                }
                if(rowData.categoriaDiAppartenenza === "F"){
                  fCounter += 1;
                }
                if(rowData.categoriaDiAppartenenza === "G"){
                  gCounter += 1;
                }
                if(rowData.categoriaDiAppartenenza === "H"){
                  hCounter += 1;
                }
                if(rowData.categoriaDiAppartenenza === "I"){
                  iCounter += 1;
                }
                allCounter += 1;

                if(rowData.turnoGiugno === "SI"){
                  junCounter += 1;
                }

                if(rowData.turnoLuglio === "SI"){
                  julCounter += 1;
                }

                if(rowData.turnoAgosto === "SI"){
                  augCounter += 1;
                }

                if(rowData.turnoSettembre === "SI"){
                  sepCounter += 1;
                }

                if(rowData.giugnoApprovato != undefined){
                  if(rowData.giugnoApprovato === "SI"){
                    junApprovedCounter += 1;
                  }
  
                  if(rowData.luglioApprovato === "SI"){
                    julApprovedCounter += 1;
                  }
  
                  if(rowData.agostoApprovato === "SI"){
                    augApprovedCounter += 1;
                  }
  
                  if(rowData.settembreApprovato === "SI"){
                    sepApprovedCounter += 1;
                  }
                }
              
                
                rows.push({
                    id: documentSnapshot.id,
                    categoriaDiAppartenenza: categoria.find(o => o.value === rowData.categoriaDiAppartenenza.toUpperCase()).name.toUpperCase(),
                    nomeTitolare: rowData.nomeTitolare.toUpperCase(),
                    cognomeTitolare: rowData.cognomeTitolare.toUpperCase(),
                    gradoTitolare: rowData.gradoTitolare.toUpperCase(),
                    enteDiservizioTitolare: ente,
                    emailTitolare: rowData.emailTitolare.toLowerCase(),
                    cittaDiNascitaTitolare: rowData.cittaDiNascitaTitolare.toUpperCase(),
                    nazioneDiNascitaTitolare: rowData.nazioneDiNascitaTitolare.toUpperCase(),
                    provinciaDiNascitaTitolare: rowData.provinciaDiNascitaTitolare.toUpperCase(),
                    dataNascitaTitolare: rowData.dataNascitaTitolare,
                    stato: rowData.stato !== undefined ? (rowData.stato.toUpperCase()) : ("NUOVA"),
                    turnoGiugno:rowData.turnoGiugno.toUpperCase(),
                    turnoLuglio:rowData.turnoLuglio.toUpperCase(),
                    prioritaTurnoLuglio: rowData.prioritaTurnoLuglio,
                    turnoAgosto:rowData.turnoAgosto.toUpperCase(),
                    prioritaTurnoAgosto: rowData.prioritaTurnoAgosto,
                    turnoSettembre:rowData.turnoSettembre.toUpperCase(),
                    numeroAltriAbbonamenti: rowData.numeroAltriAbbonamenti,
                    documentiAllegati: rowData.documentazione !== undefined ? rowData.documentazione : "NO",
                    daPagare: rowData.daVersare !== undefined ? parseFloat(rowData.daVersare).toFixed(2) : 0.00,
                    pagato: rowData.daVersareVerificato !== undefined ? (rowData.daVersareVerificato == "SI" ?  parseFloat(rowData.daVersare).toFixed(2) : "0,00"): "--"
                    //QUI daPagare, pagato
                    
                })

            });
            console.log(rows);
            setCounterAll(allCounter);
            setCounterA(aCounter);
            setCounterB(bCounter);
            setCounterC(cCounter);
            setCounterD(dCounter);
            setCounterE(eCounter);
            setCounterF(fCounter);
            setCounterG(gCounter);
            setCounterH(hCounter);
            setCounterI(iCounter);

            setCounterJun(junCounter);
            setCounterJul(julCounter);
            setCounterAug(augCounter);
            setCounterSep(sepCounter);

            setApprovedCounterJun(junApprovedCounter);
            setApprovedCounterJul(julApprovedCounter);
            setApprovedCounterAug(augApprovedCounter);
            setApprovedCounterSep(sepApprovedCounter);

            setRows(rows);
            handleCloseLoader();
        })
    }

    const fetchRichiesta = async (idRichiesta) => {
      console.log("fetchRichiesta >>> " + idRichiesta);
      
      await getDOCS(idRichiesta);
      await caricaAbbonamenti(idRichiesta);
      await getDocs(collection(db, "Richieste2026"))
        .then((querySnapshot)=>{              
            
            const newData = querySnapshot.docs.map((doc) => ({...doc.data()}));
            querySnapshot.forEach(documentSnapshot => {
              const rowData = documentSnapshot.data();
              if(documentSnapshot.id === idRichiesta){
                console.log("fetchRichiesta >>> rowData " + rowData.nomeTitolare);
                setSelectedRequest(rowData);
                setSelectedIdRichiesta(idRichiesta);
                if(rowData.stato != undefined){
                  setSelectedStatoRichiesta(rowData.stato);
                  setSelectedStatoDocumentazione(rowData.documentazione);
                }else{
                  setSelectedStatoRichiesta("nuova");
                }
                if(rowData.giugnoApprovato != undefined){
                  setSelectedApprovaGiugno(rowData.giugnoApprovato);
                  setSelectedApprovaLuglio(rowData.luglioApprovato);
                  setSelectedApprovaAgosto(rowData.agostoApprovato);
                  setSelectedApprovaSettembre(rowData.settembreApprovato);
                  setSelectedPagamentoEffettuato(rowData.daVersareVerificato);
                }else{
                  setSelectedApprovaGiugno("");
                  setSelectedApprovaLuglio("");
                  setSelectedApprovaAgosto("");
                  setSelectedApprovaSettembre("");
                }

                if(rowData.approvatoGiugnoEA1  != undefined ){
                  setSelectedApprovaGiugnoEA1(rowData.approvatoGiugnoEA1);
                  setSelectedApprovaGiugnoEA2(rowData.approvatoGiugnoEA2);
                  setSelectedApprovaGiugnoEA3(rowData.approvatoGiugnoEA3);
                  setSelectedApprovaGiugnoEA4(rowData.approvatoGiugnoEA4);
                  setSelectedApprovaGiugnoEA5(rowData.approvatoGiugnoEA5);
                  setSelectedApprovaGiugnoEA6(rowData.approvatoGiugnoEA6);
                  setSelectedApprovaGiugnoEA7(rowData.approvatoGiugnoEA7);
                  setSelectedApprovaGiugnoEA8(rowData.approvatoGiugnoEA8);
                  setSelectedApprovaGiugnoEA9(rowData.approvatoGiugnoEA9);
                  setSelectedApprovaGiugnoEA10(rowData.approvatoGiugnoEA10);

                  setSelectedApprovaLuglioEA1(rowData.approvatoLuglioEA1);
                  setSelectedApprovaLuglioEA2(rowData.approvatoLuglioEA2);
                  setSelectedApprovaLuglioEA3(rowData.approvatoLuglioEA3);
                  setSelectedApprovaLuglioEA4(rowData.approvatoLuglioEA4);
                  setSelectedApprovaLuglioEA5(rowData.approvatoLuglioEA5);
                  setSelectedApprovaLuglioEA6(rowData.approvatoLuglioEA6);
                  setSelectedApprovaLuglioEA7(rowData.approvatoLuglioEA7);
                  setSelectedApprovaLuglioEA8(rowData.approvatoLuglioEA8);
                  setSelectedApprovaLuglioEA9(rowData.approvatoLuglioEA9);
                  setSelectedApprovaLuglioEA10(rowData.approvatoLuglioEA10);

                  setSelectedApprovaAgostoEA1(rowData.approvatoAgostoEA1);
                  setSelectedApprovaAgostoEA2(rowData.approvatoAgostoEA2);
                  setSelectedApprovaAgostoEA3(rowData.approvatoAgostoEA3);
                  setSelectedApprovaAgostoEA4(rowData.approvatoAgostoEA4);
                  setSelectedApprovaAgostoEA5(rowData.approvatoAgostoEA5);
                  setSelectedApprovaAgostoEA6(rowData.approvatoAgostoEA6);
                  setSelectedApprovaAgostoEA7(rowData.approvatoAgostoEA7);
                  setSelectedApprovaAgostoEA8(rowData.approvatoAgostoEA8);
                  setSelectedApprovaAgostoEA9(rowData.approvatoAgostoEA9);
                  setSelectedApprovaAgostoEA10(rowData.approvatoAgostoEA10);

                  setSelectedApprovaSettembreEA1(rowData.approvatoSettembreEA1);
                  setSelectedApprovaSettembreEA2(rowData.approvatoSettembreEA2);
                  setSelectedApprovaSettembreEA3(rowData.approvatoSettembreEA3);
                  setSelectedApprovaSettembreEA4(rowData.approvatoSettembreEA4);
                  setSelectedApprovaSettembreEA5(rowData.approvatoSettembreEA5);
                  setSelectedApprovaSettembreEA6(rowData.approvatoSettembreEA6);
                  setSelectedApprovaSettembreEA7(rowData.approvatoSettembreEA7);
                  setSelectedApprovaSettembreEA8(rowData.approvatoSettembreEA8);
                  setSelectedApprovaSettembreEA9(rowData.approvatoSettembreEA9);
                  setSelectedApprovaSettembreEA10(rowData.approvatoSettembreEA10);


                 
                  calcolaQuotaFamiliare[0].calcolaGiugno = rowData.approvatoGiugnoEA1 === 1 ? 1 : 0; 
                  calcolaQuotaFamiliare[0].calcolaLuglio = rowData.approvatoLuglioEA1 === 1 ? 1 : 0; 
                  calcolaQuotaFamiliare[0].calcolaAgosto = rowData.approvatoAgostoEA1 === 1 ? 1 : 0; 
                  calcolaQuotaFamiliare[0].calcolaSettembre = rowData.approvatoSettembreEA1 === 1 ? 1 : 0; 
                  calcolaCostoTotale(1);

                   

                  calcolaQuotaFamiliare[1].calcolaGiugno = rowData.approvatoGiugnoEA2 === 1 ? 1 : 0; 
                  calcolaQuotaFamiliare[1].calcolaLuglio = rowData.approvatoLuglioEA2 === 1 ? 1 : 0; 
                  calcolaQuotaFamiliare[1].calcolaAgosto = rowData.approvatoAgostoEA2 === 1 ? 1 : 0; 
                  calcolaQuotaFamiliare[1].calcolaSettembre = rowData.approvatoSettembreEA2 === 1 ? 1 : 0; 
                  calcolaCostoTotale(2);

              

                  setSelectedSTotaleDaVersare(rowData.daVersare);
                }else{
                  setSelectedApprovaGiugnoEA1(2);
                  setSelectedApprovaGiugnoEA2(2);
                  setSelectedApprovaGiugnoEA3(2);
                  setSelectedApprovaGiugnoEA4(2);
                  setSelectedApprovaGiugnoEA5(2);
                  setSelectedApprovaGiugnoEA6(2);
                  setSelectedApprovaGiugnoEA7(2);
                  setSelectedApprovaGiugnoEA8(2);
                  setSelectedApprovaGiugnoEA9(2);
                  setSelectedApprovaGiugnoEA10(2);

                  setSelectedApprovaLuglioEA1(2);
                  setSelectedApprovaLuglioEA2(2);
                  setSelectedApprovaLuglioEA3(2);
                  setSelectedApprovaLuglioEA4(2);
                  setSelectedApprovaLuglioEA5(2);
                  setSelectedApprovaLuglioEA6(2);
                  setSelectedApprovaLuglioEA7(2);
                  setSelectedApprovaLuglioEA8(2);
                  setSelectedApprovaLuglioEA9(2);
                  setSelectedApprovaLuglioEA10(2);

                  setSelectedApprovaAgostoEA1(2);
                  setSelectedApprovaAgostoEA2(2);
                  setSelectedApprovaAgostoEA3(2);
                  setSelectedApprovaAgostoEA4(2);
                  setSelectedApprovaAgostoEA5(2);
                  setSelectedApprovaAgostoEA6(2);
                  setSelectedApprovaAgostoEA7(2);
                  setSelectedApprovaAgostoEA8(2);
                  setSelectedApprovaAgostoEA9(2);
                  setSelectedApprovaAgostoEA10(2);

                  setSelectedApprovaSettembreEA1(2);
                  setSelectedApprovaSettembreEA2(2);
                  setSelectedApprovaSettembreEA3(2);
                  setSelectedApprovaSettembreEA4(2);
                  setSelectedApprovaSettembreEA5(2);
                  setSelectedApprovaSettembreEA6(2);
                  setSelectedApprovaSettembreEA7(2);
                  setSelectedApprovaSettembreEA8(2);
                  setSelectedApprovaSettembreEA9(2);
                  setSelectedApprovaSettembreEA10(2);

                  setSelectedSTotaleDaVersare("0.00");
                }
                return;
              }
            }
          );
         
      }) 
      return;
    }

  
    const updateRichiesta = async () => {
      console.log("id richiesta >>> " + selectedIdRichiesta);
      console.log("stato >>> " + selectedStatoRichiesta);
      handleOpenLoader();

      if(selectedStatoRichiesta === "nuova"){
        setSelectedApprovaGiugno("NO");
        setSelectedApprovaLuglio("NO");
        setSelectedApprovaAgosto("NO");
        setSelectedApprovaSettembre("NO");
        setSelectedStatoDocumentazione("NON PREVISTA");
        setSelectedPagamentoEffettuato("NO");
        
      }

      var costoTotaleDaVersare = 0;
      var costoHalf = categoria.find(o => o.value === selectedRequest.categoriaDiAppartenenza.toUpperCase()).halfMonthF;
      var costoFull = categoria.find(o => o.value === selectedRequest.categoriaDiAppartenenza.toUpperCase()).fullMonthF;
      if(selectedRequest.giugnoApprovato === "SI"){
        let a = costoHalf;
        let b = costoTotaleDaVersare;
        costoTotaleDaVersare = a + b;
      }
      if(selectedRequest.luglioApprovato === "SI"){
        let a = costoFull;
        let b = costoTotaleDaVersare;
        costoTotaleDaVersare = a + b;
      }
      if(selectedRequest.agostoApprovato === "SI"){
        let a = costoFull;
        let b = costoTotaleDaVersare;
        costoTotaleDaVersare = a + b;
      }
      if(selectedRequest.settembreApprovato === "SI"){
        let a = costoHalf;
        let b = costoTotaleDaVersare;
        costoTotaleDaVersare = a + b;
      }
  
      let costoTotaleEA = 0.0;

      if(selectedRequest.numeroAltriAbbonamenti > 0){
        if(selectedRequest.approvatoGiugnoEA1 === 1 || selectedRequest.approvatoLuglioEA1 === 1 || selectedRequest.approvatoAgostoEA1 === 1 || selectedRequest.approvatoAgostoEA1 === 1){
          let a = parseFloat(costoTotaleEA);
          let b = parseFloat(costoTotaleEA1);
          costoTotaleEA = a + b;
        }
        if(selectedRequest.approvatoGiugnoEA2 === 1 || selectedRequest.approvatoLuglioEA2 === 1 || selectedRequest.approvatoAgostoEA2 === 1 || selectedRequest.approvatoAgostoEA2 === 1){
          let a = parseFloat(costoTotaleEA);
          let b = parseFloat(costoTotaleEA2);
          costoTotaleEA = a + b;
        }
        if(selectedRequest.approvatoGiugnoEA3 === 1 || selectedRequest.approvatoLuglioEA3 === 1 || selectedRequest.approvatoAgostoEA3 === 1 || selectedRequest.approvatoAgostoEA3 === 1){
          let a = parseFloat(costoTotaleEA);
          let b = parseFloat(costoTotaleEA3);
          costoTotaleEA = a + b;
        }
        if(selectedRequest.approvatoGiugnoEA4 === 1 || selectedRequest.approvatoLuglioEA4 === 1 || selectedRequest.approvatoAgostoEA4 === 1 || selectedRequest.approvatoAgostoEA4 === 1){
          let a = parseFloat(costoTotaleEA);
          let b = parseFloat(costoTotaleEA4);
          costoTotaleEA = a + b;
          
        }
        if(selectedRequest.approvatoGiugnoEA5 === 1 || selectedRequest.approvatoLuglioEA5 === 1 || selectedRequest.approvatoAgostoEA5 === 1 || selectedRequest.approvatoAgostoEA5 === 1){
          let a = parseFloat(costoTotaleEA);
          let b = parseFloat(costoTotaleEA5);
          costoTotaleEA = a + b;
        }
        if(selectedRequest.approvatoGiugnoEA6 === 1 || selectedRequest.approvatoLuglioEA6 === 1 || selectedRequest.approvatoAgostoEA6 === 1 || selectedRequest.approvatoAgostoEA6 === 1){
          let a = parseFloat(costoTotaleEA);
          let b = parseFloat(costoTotaleEA6);
          costoTotaleEA = a + b;
        }
        if(selectedRequest.approvatoGiugnoEA7 === 1 || selectedRequest.approvatoLuglioEA7 === 1 || selectedRequest.approvatoAgostoEA7 === 1 || selectedRequest.approvatoAgostoEA7 === 1){
          let a = parseFloat(costoTotaleEA);
          let b = parseFloat(costoTotaleEA7);
          costoTotaleEA = a + b;
        }
        if(selectedRequest.approvatoGiugnoEA8 === 1 || selectedRequest.approvatoLuglioEA8 === 1 || selectedRequest.approvatoAgostoEA8 === 1 || selectedRequest.approvatoAgostoEA8 === 1){
          let a = parseFloat(costoTotaleEA);
          let b = parseFloat(costoTotaleEA8);
          costoTotaleEA = a + b;
        }
        if(selectedRequest.approvatoGiugnoEA9 === 1 || selectedRequest.approvatoLuglioEA9 === 1 || selectedRequest.approvatoAgostoEA9 === 1 || selectedRequest.approvatoAgostoEA9 === 1){
          let a = parseFloat(costoTotaleEA);
          let b = parseFloat(costoTotaleEA9);
          costoTotaleEA = a + b;
        }
        if(selectedRequest.approvatoGiugnoEA10 === 1 || selectedRequest.approvatoLuglioEA10 === 1 || selectedRequest.approvatoAgostoEA10 === 1 || selectedRequest.approvatoAgostoEA10 === 1){
          let a = parseFloat(costoTotaleEA);
          let b = parseFloat(costoTotaleEA10);
          costoTotaleEA = a + b;
        }
      }
  
      let daVersare = 0.0;
      let a = parseFloat(costoTotaleEA);
      let b = parseFloat(costoTotaleDaVersare);
      console.log("costoTotaleEA " + a);
      console.log("costoTotaleDaVersare " + b);
      daVersare = a + b;
      console.log("daVersare " + daVersare);
      daVersareState = daVersare;
      console.log("daVersareState " + daVersareState);

      console.log("statusDocumentazione " + selectedStatoDocumentazione);
      
      const docRef = doc(db, "Richieste2026", selectedIdRichiesta);
      await updateDoc(docRef, {
        stato: selectedStatoRichiesta,
        giugnoApprovato: selectedApprovaGiugno,
        luglioApprovato: selectedApprovaLuglio,
        agostoApprovato: selectedApprovaAgosto,
        settembreApprovato: selectedApprovaSettembre,
        approvatoGiugnoEA1: selectedApprovaGiugnoEA1,
        approvatoGiugnoEA2: selectedApprovaGiugnoEA2,
        approvatoGiugnoEA3: selectedApprovaGiugnoEA3,
        approvatoGiugnoEA4: selectedApprovaGiugnoEA4,
        approvatoGiugnoEA5: selectedApprovaGiugnoEA5,
        approvatoGiugnoEA6: selectedApprovaGiugnoEA6,
        approvatoGiugnoEA7: selectedApprovaGiugnoEA7,
        approvatoGiugnoEA8: selectedApprovaGiugnoEA8,
        approvatoGiugnoEA9: selectedApprovaGiugnoEA9,
        approvatoGiugnoEA10: selectedApprovaGiugnoEA10,
        approvatoLuglioEA1: selectedApprovaLuglioEA1,
        approvatoLuglioEA2: selectedApprovaLuglioEA2,
        approvatoLuglioEA3: selectedApprovaLuglioEA3,
        approvatoLuglioEA4: selectedApprovaLuglioEA4,
        approvatoLuglioEA5: selectedApprovaLuglioEA5,
        approvatoLuglioEA6: selectedApprovaLuglioEA6,
        approvatoLuglioEA7: selectedApprovaLuglioEA7,
        approvatoLuglioEA8: selectedApprovaLuglioEA8,
        approvatoLuglioEA9: selectedApprovaLuglioEA9,
        approvatoLuglioEA10: selectedApprovaLuglioEA10,
        approvatoAgostoEA1: selectedApprovaAgostoEA1,
        approvatoAgostoEA2: selectedApprovaAgostoEA2,
        approvatoAgostoEA3: selectedApprovaAgostoEA3,
        approvatoAgostoEA4: selectedApprovaAgostoEA4,
        approvatoAgostoEA5: selectedApprovaAgostoEA5,
        approvatoAgostoEA6: selectedApprovaAgostoEA6,
        approvatoAgostoEA7: selectedApprovaAgostoEA7,
        approvatoAgostoEA8: selectedApprovaAgostoEA8,
        approvatoAgostoEA9: selectedApprovaAgostoEA9,
        approvatoAgostoEA10: selectedApprovaAgostoEA10,
        approvatoSettembreEA1: selectedApprovaSettembreEA1,
        approvatoSettembreEA2: selectedApprovaSettembreEA2,
        approvatoSettembreEA3: selectedApprovaSettembreEA3,
        approvatoSettembreEA4: selectedApprovaSettembreEA4,
        approvatoSettembreEA5: selectedApprovaSettembreEA5,
        approvatoSettembreEA6: selectedApprovaSettembreEA6,
        approvatoSettembreEA7: selectedApprovaSettembreEA7,
        approvatoSettembreEA8: selectedApprovaSettembreEA8,
        approvatoSettembreEA9: selectedApprovaSettembreEA9,
        approvatoSettembreEA10: selectedApprovaSettembreEA10,
        approvatoSettembreEA10: selectedApprovaSettembreEA10,
        costoTotaleDaVersare: costoTotaleDaVersare,
        costoTotaleEA: costoTotaleEA,
        daVersare: daVersare,
        documentazione: selectedStatoDocumentazione,
        daVersareVerificato: selectedPagamentoEffettuato,
      });

      handleCloseLoader();
      setSnackBarMessage("Le modifiche sono state salvate con successo!");
      handleSnackBar();
      return;
    }

    const categoria = [
      {
        value: "A-M",
        label: "Militare in servizio presso Accademia Aeronautica",
        halfMonth: "22.25",
        fullMonth: "33.90",
        halfMonthF: 22.25,
        fullMonthF: 33.90,
        name: "A",
      },
      {
        value: "A-C",
        label: "Civile in servizio presso Accademia Aeronautica",
        halfMonth: "22.25",
        fullMonth: "33.90",
        halfMonthF: 22.25,
        fullMonthF: 33.90,
        name: "A",
      },
      {
        value: "B-M",
        label: "Militare in servizio presso altro Ente A.M.",
        halfMonth: "22.25",
        fullMonth: "33.90",
        halfMonthF: 22.25,
        fullMonthF: 33.90,
        name: "B",
      },
      {
        value: "B-C",
        label: "Civile in servizio presso altro Ente A.M.",
        halfMonth: "22.25",
        fullMonth: "33.90",
        halfMonthF: 22.25,
        fullMonthF: 33.90,
        name: "B",
      },
      {
        value: "C",
        label: "Coniuge superstite del personale Militare o Civile dell' A.M.",
        halfMonth: "22.25",
        fullMonth: "33.90",
        halfMonthF: 22.25,
        fullMonthF: 33.90,
        name: "C",
      },
      {
        value: "D-M",
        label: "Militare in servizio presso altri Enti Ministero della Difesa",
        halfMonth: "22.25",
        fullMonth: "33.90",
        halfMonthF: 22.25,
        fullMonthF: 33.90,
        name: "D",
      },
      {
        value: "D-C",
        label: "Civile in servizio presso altri Enti Ministero della Difesa",
        halfMonth: "22.25",
        fullMonth: "33.90",
        halfMonthF: 22.25,
        fullMonthF: 33.90,
        name: "D",
      },
      {
        value: "E",
        label: "Militare o Civile in quiescenza già in forza all'Accademia Aeronautica",
        halfMonth: "22.25",
        fullMonth: "33.90",
        halfMonthF: 22.25,
        fullMonthF: 33.90,
        name: "E",
      },
      {
        value: "F",
        label: "Militare o Civile in quiescenza già in forza ad altro Ente Ministero Difesa",
        halfMonth: "22.25",
        fullMonth: "33.90",
        halfMonthF: 22.25,
        fullMonthF: 33.90,
        name: "F",
      },
      {
        value: "G",
        label: "Coniuge superstite del personale Militare o Civile (in servizio o in quiescenza) del Ministero della Difesa",
        halfMonth: "22.25",
        fullMonth: "33.90",
        halfMonthF: 22.25,
        fullMonthF: 33.90,
        name: "G",
      },
      {
        value: "H",
        label: "Personale in servizio attivo dei Corpi Armati e militarmente organizzati dello Stato (P.S., G.d.F., Polizia Penitenziaria, VV.FF.) e Corpi Ausiliari delle FF.AA. (Croce Rossa Italiana)",
        halfMonth: "41.60",
        fullMonth: "58.05",
        halfMonthF: 41.60,
        fullMonthF: 58.05,
        name: "H",
      },
      {
        value: "I",
        label: "Personale in serivzio presso altri Ministeri, Enti Statali, Regionali, Provinciali, Comunali",
        halfMonth: "41.60",
        fullMonth: "58.05",
        halfMonthF: 41.60,
        fullMonthF: 58.05,
        name: "I",
      },
    ];


  async function sendEmail(messageHtml, messagePlain, toEmail, typeEmail){
    handleOpenLoader();
    try {
      console.log("sendEmail >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
      console.log("to :" + toEmail.toLowerCase() + "    text: " + messagePlain);
        const docRef = await addDoc(collection(db, "mail"), {
          to: toEmail,
          message: {
            subject: "Distaccamento Straordinario A.M. di \"Miliscola\" - Campagna Abbonamenti 2026",
            text: messagePlain,
            html: messageHtml, 
          } });
          handleCloseLoader();
          setSnackBarMessage("L'email di " + typeEmail.toUpperCase() +  " è stata inviata con successo a " + toEmail.toLowerCase());
          handleSnackBar();
      } catch (e) {
        console.error("Error adding document: ", e);
        handleCloseLoader();
        setSnackBarMessage("Non è stato possibile inviare la mail a " + toEmail.toLowerCase());
        handleSnackBar();
      }

     
  }

  async function addDocsAccessToDB(email, idRichiesta, OTP) {
  
    handleOpenLoader();

    try {
        const docRef = await addDoc(collection(db, "AreaDocumenti2026"), {
          email: email.toLowerCase().replaceAll(' ', ''),
          idRichiesta: idRichiesta.replaceAll(' ', ''),
          OTP: OTP.replaceAll(' ', '')
        });
        
        handleCloseLoader();
      } catch (e) {
        console.error("Error adding document: ", e);
        handleCloseLoader();
      }
}

const inviaEmailRespinta= async () => {
  var toEmail = selectedRequest.emailTitolare;
  
  var messagePlain = "Gentile " + selectedRequest.nomeTitolare.toUpperCase() + " " + selectedRequest.cognomeTitolare.toUpperCase() + " siamo spiacenti di comunicarti che la tua richiesta è stata respinta per mancanza di requisiti.<br><br>";

  messagePlain += "Indirizzo email utilizzato nella richiesta, <strong>" +toEmail + "</strong><br>";
  messagePlain += "Codice richiesta respinta, <strong>" +  selectedIdRichiesta + "</strong><br>";
  messagePlain += "Le ricordiamo che potrà comunque frequentare il Distaccamento in modalità accesso giornaliero, utilizzando l'applicazione NausicaSAMmerPass."    
  messagePlain += "<br><br>Il Gestore";

  var messageHtml = messagePlain;

  console.log(messageHtml)
  
  sendEmail(messageHtml, messagePlain, toEmail, "Richiesta respinta.");


} 

const inviaEmailRespinta2= async () => {
  var toEmail = selectedRequest.emailTitolare;
  
  var messagePlain = "Gentile " + selectedRequest.nomeTitolare.toUpperCase() + " " + selectedRequest.cognomeTitolare.toUpperCase() + " siamo spiacenti di comunicarti che la tua richiesta è stata respinta per indisponibilità.<br><br>";

  messagePlain += "Indirizzo email utilizzato nella richiesta, <strong>" +toEmail + "</strong><br>";
  messagePlain += "Codice richiesta respinta, <strong>" +  selectedIdRichiesta + "</strong><br>";
  messagePlain += "Le ricordiamo che potrà comunque frequentare il Distaccamento in modalità accesso giornaliero, utilizzando l'applicazione NausicaSAMmerPass."    
  messagePlain += "<br><br>Il Gestore";

  var messageHtml = messagePlain;

  console.log(messageHtml)
  
  sendEmail(messageHtml, messagePlain, toEmail, "Richiesta respinta.");


} 

const inviaEmailRitirata = async () => {
  var toEmail = selectedRequest.emailTitolare;
  
  var messagePlain = "Gentile " + selectedRequest.nomeTitolare.toUpperCase() + " " + selectedRequest.cognomeTitolare.toUpperCase() + " come da lei richiesto la sua richiesta di abbonamento è stata ritirata.<br><br>";

  messagePlain += "Indirizzo email utilizzato nella richiesta, <strong>" +toEmail + "</strong><br>";
  messagePlain += "Codice richiesta ritirata, <strong>" +  selectedIdRichiesta + "</strong><br>";
  messagePlain += "Le ricordiamo che potrà comunque frequentare il Distaccamento in modalità accesso giornaliero, utilizzando l'applicazione NausicaSAMmerPass."    
  messagePlain += "<br><br>Il Gestore";

  var messageHtml = messagePlain;

  console.log(messageHtml)
  
  sendEmail(messageHtml, messagePlain, toEmail, "Richiesta ritirata.");


} 




const inviaEmailDocumentazionePreliminare = async () => {
    var toEmail = selectedRequest.emailTitolare;
    var otp = "";
    for (let i = 0; i < 3; i++) {
      console.log(selectedIdRichiesta.charAt(i).charCodeAt(0));
      otp += selectedIdRichiesta.charAt(i).charCodeAt(0).toString();
    }
    

    var messagePlain = "Gentile " + selectedRequest.nomeTitolare.toUpperCase() + " " + selectedRequest.cognomeTitolare.toUpperCase() + " ti inviamo con la presente le istruzioni per fornire la documentazione richiesta.<br><br>";
    messagePlain +=  "Accedi al portale Campagna Abbonamenti 2026 e clicca sul pulsante blu, in alto a destra, Carica Documentazione.<br><br>"
    messagePlain +=  "Utilizza i seguenti dati per accedere:<br>";
    messagePlain +=  "Indirizzo email, <strong>" +toEmail + "</strong><br>";
    messagePlain +=  "Codice richiesta, <strong>" +  selectedIdRichiesta + "</strong><br>";
    messagePlain +=  "Codice verifica, <strong>" +otp + "</strong><br><br>";
    messagePlain +=  "Avrai accesso all'area personale CARICA I TUOI DOCUMENTI dove potrai caricare tutti i documenti previsti da Regolamento (foto CMD, foto titolare, etc)<br><br>";
    messagePlain += "A seguito della verifica della documentazione riceverari comunicazione sull'esito valutativo della domanda."    
    messagePlain += "<br><br>Il Gestore";

    var messageHtml = messagePlain;

    console.log(messageHtml)
    
    sendEmail(messageHtml, messagePlain, toEmail, "Richiesta Documentazione");
    addDocsAccessToDB(toEmail, selectedIdRichiesta, otp);

  } 

  const inviaEmailApprovazioneDefinitiva = async () => {
    var toEmail = selectedRequest.emailTitolare;

    var messagePlain = "Gentile " + selectedRequest.nomeTitolare.toUpperCase() + " " + selectedRequest.cognomeTitolare.toUpperCase() + " ti comunichiamo che la tua richiesta ";
    messagePlain += "<strong>" +  selectedIdRichiesta + "</strong>";
    messagePlain += " è stata <strong>APPROVATA</strong>. <br><br>";
    messagePlain += "Riportiamo i dettagli dei turni approvati: <br><br>";

    var costoTotaleDaVersare = 0;
    var costoHalf = categoria.find(o => o.value === selectedRequest.categoriaDiAppartenenza.toUpperCase()).halfMonthF;
    var costoFull = categoria.find(o => o.value === selectedRequest.categoriaDiAppartenenza.toUpperCase()).fullMonthF;

    if(selectedRequest.giugnoApprovato === "SI"){
      messagePlain += "Turno dal 15 Giugno 2026 al 30 Giugno 2026 <br>";
      messagePlain += "(Costo in euro " + costoHalf + ") <br><br>";
      let a = costoHalf;
      let b = costoTotaleDaVersare;
      costoTotaleDaVersare = a + b;
     
    }
    if(selectedRequest.luglioApprovato === "SI"){
      messagePlain += "Turno dal 1 Luglio 2026 al 31 Luglio 2026 <br>";
      messagePlain += "(Costo in euro " + costoFull + ") <br><br>";
      let a = costoFull;
      let b = costoTotaleDaVersare;
      costoTotaleDaVersare = a + b;
    }
    if(selectedRequest.agostoApprovato === "SI"){
      messagePlain += "Turno dal 1 Agosto 2026 al 31 Agosto 2026 <br>";
      messagePlain += "(Costo in euro " + costoFull + ") <br><br>";
      let a = costoFull;
      let b = costoTotaleDaVersare;
      costoTotaleDaVersare = a + b;
    }
    if(selectedRequest.settembreApprovato === "SI"){
      messagePlain += "Turno dal 1 Settembre 2026 al 15 Settembre 2026 <br>";
      messagePlain += "(Costo in euro " + costoHalf + ") <br><br>";
      let a = costoHalf;
      let b = costoTotaleDaVersare;
      costoTotaleDaVersare = a + b;
    }

    let costoTotaleEA = 0.0;

    if(selectedRequest.numeroAltriAbbonamenti > 0){
      messagePlain += "Sono stati inoltre approvati i turni per i tuoi familiari e/o conviventi: <br>";
      if(selectedRequest.approvatoGiugnoEA1 === 1 || selectedRequest.approvatoLuglioEA1 === 1 || selectedRequest.approvatoAgostoEA1 === 1 || selectedRequest.approvatoAgostoEA1 === 1){
        messagePlain += selectedRequest.nomeCognomeEA1.toUpperCase() + " turni: " + (selectedRequest.approvatoGiugnoEA1 === 1 ? "GIUGNO " : "") + (selectedRequest.approvatoLuglioEA1 === 1 ? "LUGLIO " : "") + (selectedRequest.approvatoAgostoEA1 === 1 ? "AGOSTO " : "") + (selectedRequest.approvatoSettembreEA1 === 1 ? "SETTEMBRE " : "") + "<br>";
        messagePlain += "(Costo in euro " + costoTotaleEA1 + ")<br><br>";
        let a = parseFloat(costoTotaleEA);
        let b = parseFloat(costoTotaleEA1);
        costoTotaleEA = a + b;
      }
      if(selectedRequest.approvatoGiugnoEA2 === 1 || selectedRequest.approvatoLuglioEA2 === 1 || selectedRequest.approvatoAgostoEA2 === 1 || selectedRequest.approvatoAgostoEA2 === 1){
        messagePlain += selectedRequest.nomeCognomeEA2.toUpperCase() + " turni: " + (selectedRequest.approvatoGiugnoEA2 === 1 ? "GIUGNO " : "") + (selectedRequest.approvatoLuglioEA2 === 1 ? "LUGLIO " : "") + (selectedRequest.approvatoAgostoEA2 === 1 ? "AGOSTO " : "") + (selectedRequest.approvatoSettembreEA2 === 1 ? "SETTEMBRE " : "") + "<br>";
        messagePlain += "(Costo in euro " + costoTotaleEA2 + ")<br><br>";
        let a = parseFloat(costoTotaleEA);
        let b = parseFloat(costoTotaleEA2);
        costoTotaleEA = a + b;
      }
      if(selectedRequest.approvatoGiugnoEA3 === 1 || selectedRequest.approvatoLuglioEA3 === 1 || selectedRequest.approvatoAgostoEA3 === 1 || selectedRequest.approvatoAgostoEA3 === 1){
        messagePlain += selectedRequest.nomeCognomeEA3.toUpperCase() + " turni: " + (selectedRequest.approvatoGiugnoEA3 === 1 ? "GIUGNO " : "") + (selectedRequest.approvatoLuglioEA3 === 1 ? "LUGLIO " : "") + (selectedRequest.approvatoAgostoEA3 === 1 ? "AGOSTO " : "") + (selectedRequest.approvatoSettembreEA3 === 1 ? "SETTEMBRE " : "") + "<br>";
        messagePlain += "(Costo in euro " + costoTotaleEA3 + ")<br><br>";
        let a = parseFloat(costoTotaleEA);
        let b = parseFloat(costoTotaleEA3);
        costoTotaleEA = a + b;
      }
      if(selectedRequest.approvatoGiugnoEA4 === 1 || selectedRequest.approvatoLuglioEA4 === 1 || selectedRequest.approvatoAgostoEA4 === 1 || selectedRequest.approvatoAgostoEA4 === 1){
        messagePlain += selectedRequest.nomeCognomeEA4.toUpperCase() + " turni: " + (selectedRequest.approvatoGiugnoEA4 === 1 ? "GIUGNO " : "") + (selectedRequest.approvatoLuglioEA4 === 1 ? "LUGLIO " : "") + (selectedRequest.approvatoAgostoEA4 === 1 ? "AGOSTO " : "") + (selectedRequest.approvatoSettembreEA4 === 1 ? "SETTEMBRE " : "") + "<br>";
        messagePlain += "(Costo in euro " + costoTotaleEA4 + ")<br><br>";
        let a = parseFloat(costoTotaleEA);
        let b = parseFloat(costoTotaleEA4);
        costoTotaleEA = a + b;
        
      }
      if(selectedRequest.approvatoGiugnoEA5 === 1 || selectedRequest.approvatoLuglioEA5 === 1 || selectedRequest.approvatoAgostoEA5 === 1 || selectedRequest.approvatoAgostoEA5 === 1){
        messagePlain += selectedRequest.nomeCognomeEA5.toUpperCase() + " turni: " + (selectedRequest.approvatoGiugnoEA5 === 1 ? "GIUGNO " : "") + (selectedRequest.approvatoLuglioEA5 === 1 ? "LUGLIO " : "") + (selectedRequest.approvatoAgostoEA5 === 1 ? "AGOSTO " : "") + (selectedRequest.approvatoSettembreEA5 === 1 ? "SETTEMBRE " : "") + "<br>";
        messagePlain += "(Costo in euro " + costoTotaleEA5 + ")<br><br>";
        let a = parseFloat(costoTotaleEA);
        let b = parseFloat(costoTotaleEA5);
        costoTotaleEA = a + b;
      }
      if(selectedRequest.approvatoGiugnoEA6 === 1 || selectedRequest.approvatoLuglioEA6 === 1 || selectedRequest.approvatoAgostoEA6 === 1 || selectedRequest.approvatoAgostoEA6 === 1){
        messagePlain += selectedRequest.nomeCognomeEA6.toUpperCase() + " turni: " + (selectedRequest.approvatoGiugnoEA6 === 1 ? "GIUGNO " : "") + (selectedRequest.approvatoLuglioEA6 === 1 ? "LUGLIO " : "") + (selectedRequest.approvatoAgostoEA6 === 1 ? "AGOSTO " : "") + (selectedRequest.approvatoSettembreEA6 === 1 ? "SETTEMBRE " : "") + "<br>";
        messagePlain += "(Costo in euro " + costoTotaleEA6 + ")<br><br>";
        let a = parseFloat(costoTotaleEA);
        let b = parseFloat(costoTotaleEA5);
        costoTotaleEA = a + b;
      }
      if(selectedRequest.approvatoGiugnoEA7 === 1 || selectedRequest.approvatoLuglioEA7 === 1 || selectedRequest.approvatoAgostoEA7 === 1 || selectedRequest.approvatoAgostoEA7 === 1){
        messagePlain += selectedRequest.nomeCognomeEA7.toUpperCase() + " turni: " + (selectedRequest.approvatoGiugnoEA7 === 1 ? "GIUGNO " : "") + (selectedRequest.approvatoLuglioEA7 === 1 ? "LUGLIO " : "") + (selectedRequest.approvatoAgostoEA7 === 1 ? "AGOSTO " : "") + (selectedRequest.approvatoSettembreEA7 === 1 ? "SETTEMBRE " : "") + "<br>";
        messagePlain += "(Costo in euro " + costoTotaleEA7 + ")<br><br>";
        let a = parseFloat(costoTotaleEA);
        let b = parseFloat(costoTotaleEA7);
        costoTotaleEA = a + b;
      }
      if(selectedRequest.approvatoGiugnoEA8 === 1 || selectedRequest.approvatoLuglioEA8 === 1 || selectedRequest.approvatoAgostoEA8 === 1 || selectedRequest.approvatoAgostoEA8 === 1){
        messagePlain += selectedRequest.nomeCognomeEA8.toUpperCase() + " turni: " + (selectedRequest.approvatoGiugnoEA8 === 1 ? "GIUGNO " : "") + (selectedRequest.approvatoLuglioEA8 === 1 ? "LUGLIO " : "") + (selectedRequest.approvatoAgostoEA8 === 1 ? "AGOSTO " : "") + (selectedRequest.approvatoSettembreEA8 === 1 ? "SETTEMBRE " : "") + "<br>";
        messagePlain += "(Costo in euro " + costoTotaleEA8 + ")<br><br>";
        let a = parseFloat(costoTotaleEA);
        let b = parseFloat(costoTotaleEA8);
        costoTotaleEA = a + b;
      }
      if(selectedRequest.approvatoGiugnoEA9 === 1 || selectedRequest.approvatoLuglioEA9 === 1 || selectedRequest.approvatoAgostoEA9 === 1 || selectedRequest.approvatoAgostoEA9 === 1){
        messagePlain += selectedRequest.nomeCognomeEA9.toUpperCase() + " turni: " + (selectedRequest.approvatoGiugnoEA9 === 1 ? "GIUGNO " : "") + (selectedRequest.approvatoLuglioEA9 === 1 ? "LUGLIO " : "") + (selectedRequest.approvatoAgostoEA9 === 1 ? "AGOSTO " : "") + (selectedRequest.approvatoSettembreEA9 === 1 ? "SETTEMBRE " : "") + "<br>";
        messagePlain += "(Costo in euro " + costoTotaleEA9 + ")<br><br>";
        let a = parseFloat(costoTotaleEA);
        let b = parseFloat(costoTotaleEA9);
        costoTotaleEA = a + b;
      }
      if(selectedRequest.approvatoGiugnoEA10 === 1 || selectedRequest.approvatoLuglioEA10 === 1 || selectedRequest.approvatoAgostoEA10 === 1 || selectedRequest.approvatoAgostoEA10 === 1){
        messagePlain += selectedRequest.nomeCognomeEA10.toUpperCase() + " turni: " + (selectedRequest.approvatoGiugnoEA10 === 1 ? "GIUGNO " : "") + (selectedRequest.approvatoLuglioEA10 === 1 ? "LUGLIO " : "") + (selectedRequest.approvatoAgostoEA10 === 1 ? "AGOSTO " : "") + (selectedRequest.approvatoSettembreEA10 === 1 ? "SETTEMBRE " : "") + "<br>";
        messagePlain += "(Costo in euro " + costoTotaleEA10 + ")<br><br>";
        let a = parseFloat(costoTotaleEA);
        let b = parseFloat(costoTotaleEA10);
        costoTotaleEA = a + b;
      }
    }

    let daVersare = 0.0;
    let a = parseFloat(costoTotaleEA);
    let b = parseFloat(costoTotaleDaVersare);
    console.log("costoTotaleEA " + a);
    console.log("costoTotaleDaVersare " + b);
    daVersare = a + b;
    console.log("daVersare " + (parseFloat(daVersare).toFixed(2)));

    messagePlain += "Ti invitiamo a versare la somma di <strong>" + (parseFloat(daVersare).toFixed(2)) + "</strong> euro tramite bonifico sul Conto Corrente Bancario presso <br>"
    messagePlain += "Banco di Credito Cooperativo di Napoli, intestato a \"NAUSICA s.r.l.\", IBAN IT64X0711039840000000012722";
     
    messagePlain += "<br><br>Riceverai a breve un link per effettuare l'upload della copia del versamento effettuato."
    messagePlain += "<br><br>";
    messagePlain += "A seguito della verifica del pagamento, il tuo abbonamento verrà emesso e riceverai istruzioni su come ottenerne copia digitale."
    messagePlain += "<br><br>Il Gestore";

    var messageHtml = messagePlain;

    console.log(messageHtml)
    
    sendEmail(messageHtml, messagePlain, toEmail, "Approvazione domanda");
  } 
  
  const inviaEmailDatiAccessoCaricaDocumenti = async () => {
    var toEmail = selectedRequest.emailTitolare;
    var otp = "";
    for (let i = 0; i < 3; i++) {
      console.log(selectedIdRichiesta.charAt(i).charCodeAt(0));
      otp += selectedIdRichiesta.charAt(i).charCodeAt(0).toString();
    }
    

    var messagePlain = "Gentile " + selectedRequest.nomeTitolare.toUpperCase() + " " + selectedRequest.cognomeTitolare.toUpperCase() + " ti inviamo le istruzioni per fornire copia del pagamento effettuato.<br><br>";
    messagePlain +=  "Accedi al portale Campagna Abbonamenti 2026 e clicca sul pulsante blu, in alto a destra, Carica Documentazione.<br><br>"
    messagePlain +=  "Utilizza i seguenti dati per accedere:<br>";
    messagePlain +=  "Indirizzo email, <strong>" +toEmail + "</strong><br>";
    messagePlain +=  "Codice richiesta, <strong>" +  selectedIdRichiesta + "</strong><br>";
    messagePlain +=  "Codice verifica, <strong>" +otp + "</strong><br><br>";
    messagePlain +=  "Avrai accesso all'area personale CARICA I TUOI DOCUMENTI dove potrai caricare tutti i documenti previsti da Regolamento (copia versamento avvenuto, foto CMD, foto titolare, etc)<br><br>";
    messagePlain += "A seguito della verifica della documentazione riceverari comunicazione sull'esito valutativo della domanda."    
    messagePlain += "<br><br>Il Gestore";

    var messageHtml = messagePlain;

    console.log(messageHtml)
    
    sendEmail(messageHtml, messagePlain, toEmail, "Richiesta Documentazione");
    addDocsAccessToDB(toEmail, selectedIdRichiesta, otp);

  } 






const inviaEmailDocumentazione = async () => {
    var toEmail = selectedRequest.emailTitolare;
    var otp = "";
    for (let i = 0; i < 3; i++) {
      console.log(selectedIdRichiesta.charAt(i).charCodeAt(0));
      otp += selectedIdRichiesta.charAt(i).charCodeAt(0).toString();
    }
    

    var messagePlain = "Gentile " + selectedRequest.nomeTitolare.toUpperCase() + " " + selectedRequest.cognomeTitolare.toUpperCase() + " a seguito dell'approvazione della tua richiesta, ti inviamo con la presente le istruzioni per fornire la documentazione richiesta.<br><br>";
    messagePlain +=  "Accedi al portale Campagna Abbonamenti 2026 e clicca sul pulsante blu, in alto a destra, Carica Documentazione.<br><br>"
    messagePlain +=  "Utilizza i seguenti dati per accedere:<br>";
    messagePlain +=  "Indirizzo email, <strong>" +toEmail + "</strong><br>";
    messagePlain +=  "Codice richiesta, <strong>" +  selectedIdRichiesta + "</strong><br>";
    messagePlain +=  "Codice verifica, <strong>" +otp + "</strong><br><br>";
    messagePlain +=  "Avrai accesso all'area personale CARICA I TUOI DOCUMENTI dove potrai caricare tutti i documenti previsti da Regolamento (copia versamento avvenuto, foto CMD, foto titolare, etc)<br><br>";
    messagePlain += "A seguito della verifica della documentazione e del pagamento, il tuo abbonamento verrà emesso e riceverai istruzioni su come ottenerne copia digitale."    
    messagePlain += "<br><br>Il Gestore";

    var messageHtml = messagePlain;

    console.log(messageHtml)
    
    sendEmail(messageHtml, messagePlain, toEmail, "Richiesta Documentazione");
    addDocsAccessToDB(toEmail, selectedIdRichiesta, otp);

  } 

  const inviaEmailApprovazione = async () => {
    var toEmail = selectedRequest.emailTitolare;

    var messagePlain = "Gentile " + selectedRequest.nomeTitolare.toUpperCase() + " " + selectedRequest.cognomeTitolare.toUpperCase() + " ti comunichiamo che la tua richiesta ";
    messagePlain += "<strong>" +  selectedIdRichiesta + "</strong>";
    messagePlain += " è stata <strong>APPROVATA</strong>. <br><br>";
    messagePlain += "Riportiamo i dettagli dei turni approvati: <br><br>";

    var costoTotaleDaVersare = 0;
    var costoHalf = categoria.find(o => o.value === selectedRequest.categoriaDiAppartenenza.toUpperCase()).halfMonthF;
    var costoFull = categoria.find(o => o.value === selectedRequest.categoriaDiAppartenenza.toUpperCase()).fullMonthF;

    if(selectedRequest.giugnoApprovato === "SI"){
      messagePlain += "Turno dal 15 Giugno 2026 al 30 Giugno 2026 <br>";
      messagePlain += "(Costo in euro " + costoHalf + ") <br><br>";
      let a = costoHalf;
      let b = costoTotaleDaVersare;
      costoTotaleDaVersare = a + b;
     
    }
    if(selectedRequest.luglioApprovato === "SI"){
      messagePlain += "Turno dal 1 Luglio 2026 al 31 Luglio 2026 <br>";
      messagePlain += "(Costo in euro " + costoFull + ") <br><br>";
      let a = costoFull;
      let b = costoTotaleDaVersare;
      costoTotaleDaVersare = a + b;
    }
    if(selectedRequest.agostoApprovato === "SI"){
      messagePlain += "Turno dal 1 Agosto 2026 al 31 Agosto 2026 <br>";
      messagePlain += "(Costo in euro " + costoFull + ") <br><br>";
      let a = costoFull;
      let b = costoTotaleDaVersare;
      costoTotaleDaVersare = a + b;
    }
    if(selectedRequest.settembreApprovato === "SI"){
      messagePlain += "Turno dal 1 Settembre 2026 al 15 Settembre 2026 <br>";
      messagePlain += "(Costo in euro " + costoHalf + ") <br><br>";
      let a = costoHalf;
      let b = costoTotaleDaVersare;
      costoTotaleDaVersare = a + b;
    }

    let costoTotaleEA = 0.0;

    if(selectedRequest.numeroAltriAbbonamenti > 0){
      messagePlain += "Sono stati inoltre approvati i turni per i tuoi familiari e/o conviventi: <br>";
      if(selectedRequest.approvatoGiugnoEA1 === 1 || selectedRequest.approvatoLuglioEA1 === 1 || selectedRequest.approvatoAgostoEA1 === 1 || selectedRequest.approvatoAgostoEA1 === 1){
        messagePlain += selectedRequest.nomeCognomeEA1.toUpperCase() + " turni: " + (selectedRequest.approvatoGiugnoEA1 === 1 ? "GIUGNO " : "") + (selectedRequest.approvatoLuglioEA1 === 1 ? "LUGLIO " : "") + (selectedRequest.approvatoAgostoEA1 === 1 ? "AGOSTO " : "") + (selectedRequest.approvatoSettembreEA1 === 1 ? "SETTEMBRE " : "") + "<br>";
        messagePlain += "(Costo in euro " + costoTotaleEA1 + ")<br><br>";
        let a = parseFloat(costoTotaleEA);
        let b = parseFloat(costoTotaleEA1);
        costoTotaleEA = a + b;
      }
      if(selectedRequest.approvatoGiugnoEA2 === 1 || selectedRequest.approvatoLuglioEA2 === 1 || selectedRequest.approvatoAgostoEA2 === 1 || selectedRequest.approvatoAgostoEA2 === 1){
        messagePlain += selectedRequest.nomeCognomeEA2.toUpperCase() + " turni: " + (selectedRequest.approvatoGiugnoEA2 === 1 ? "GIUGNO " : "") + (selectedRequest.approvatoLuglioEA2 === 1 ? "LUGLIO " : "") + (selectedRequest.approvatoAgostoEA2 === 1 ? "AGOSTO " : "") + (selectedRequest.approvatoSettembreEA2 === 1 ? "SETTEMBRE " : "") + "<br>";
        messagePlain += "(Costo in euro " + costoTotaleEA2 + ")<br><br>";
        let a = parseFloat(costoTotaleEA);
        let b = parseFloat(costoTotaleEA2);
        costoTotaleEA = a + b;
      }
      if(selectedRequest.approvatoGiugnoEA3 === 1 || selectedRequest.approvatoLuglioEA3 === 1 || selectedRequest.approvatoAgostoEA3 === 1 || selectedRequest.approvatoAgostoEA3 === 1){
        messagePlain += selectedRequest.nomeCognomeEA3.toUpperCase() + " turni: " + (selectedRequest.approvatoGiugnoEA3 === 1 ? "GIUGNO " : "") + (selectedRequest.approvatoLuglioEA3 === 1 ? "LUGLIO " : "") + (selectedRequest.approvatoAgostoEA3 === 1 ? "AGOSTO " : "") + (selectedRequest.approvatoSettembreEA3 === 1 ? "SETTEMBRE " : "") + "<br>";
        messagePlain += "(Costo in euro " + costoTotaleEA3 + ")<br><br>";
        let a = parseFloat(costoTotaleEA);
        let b = parseFloat(costoTotaleEA3);
        costoTotaleEA = a + b;
      }
      if(selectedRequest.approvatoGiugnoEA4 === 1 || selectedRequest.approvatoLuglioEA4 === 1 || selectedRequest.approvatoAgostoEA4 === 1 || selectedRequest.approvatoAgostoEA4 === 1){
        messagePlain += selectedRequest.nomeCognomeEA4.toUpperCase() + " turni: " + (selectedRequest.approvatoGiugnoEA4 === 1 ? "GIUGNO " : "") + (selectedRequest.approvatoLuglioEA4 === 1 ? "LUGLIO " : "") + (selectedRequest.approvatoAgostoEA4 === 1 ? "AGOSTO " : "") + (selectedRequest.approvatoSettembreEA4 === 1 ? "SETTEMBRE " : "") + "<br>";
        messagePlain += "(Costo in euro " + costoTotaleEA4 + ")<br><br>";
        let a = parseFloat(costoTotaleEA);
        let b = parseFloat(costoTotaleEA4);
        costoTotaleEA = a + b;
        
      }
      if(selectedRequest.approvatoGiugnoEA5 === 1 || selectedRequest.approvatoLuglioEA5 === 1 || selectedRequest.approvatoAgostoEA5 === 1 || selectedRequest.approvatoAgostoEA5 === 1){
        messagePlain += selectedRequest.nomeCognomeEA5.toUpperCase() + " turni: " + (selectedRequest.approvatoGiugnoEA5 === 1 ? "GIUGNO " : "") + (selectedRequest.approvatoLuglioEA5 === 1 ? "LUGLIO " : "") + (selectedRequest.approvatoAgostoEA5 === 1 ? "AGOSTO " : "") + (selectedRequest.approvatoSettembreEA5 === 1 ? "SETTEMBRE " : "") + "<br>";
        messagePlain += "(Costo in euro " + costoTotaleEA5 + ")<br><br>";
        let a = parseFloat(costoTotaleEA);
        let b = parseFloat(costoTotaleEA5);
        costoTotaleEA = a + b;
      }
      if(selectedRequest.approvatoGiugnoEA6 === 1 || selectedRequest.approvatoLuglioEA6 === 1 || selectedRequest.approvatoAgostoEA6 === 1 || selectedRequest.approvatoAgostoEA6 === 1){
        messagePlain += selectedRequest.nomeCognomeEA6.toUpperCase() + " turni: " + (selectedRequest.approvatoGiugnoEA6 === 1 ? "GIUGNO " : "") + (selectedRequest.approvatoLuglioEA6 === 1 ? "LUGLIO " : "") + (selectedRequest.approvatoAgostoEA6 === 1 ? "AGOSTO " : "") + (selectedRequest.approvatoSettembreEA6 === 1 ? "SETTEMBRE " : "") + "<br>";
        messagePlain += "(Costo in euro " + costoTotaleEA6 + ")<br><br>";
        let a = parseFloat(costoTotaleEA);
        let b = parseFloat(costoTotaleEA5);
        costoTotaleEA = a + b;
      }
      if(selectedRequest.approvatoGiugnoEA7 === 1 || selectedRequest.approvatoLuglioEA7 === 1 || selectedRequest.approvatoAgostoEA7 === 1 || selectedRequest.approvatoAgostoEA7 === 1){
        messagePlain += selectedRequest.nomeCognomeEA7.toUpperCase() + " turni: " + (selectedRequest.approvatoGiugnoEA7 === 1 ? "GIUGNO " : "") + (selectedRequest.approvatoLuglioEA7 === 1 ? "LUGLIO " : "") + (selectedRequest.approvatoAgostoEA7 === 1 ? "AGOSTO " : "") + (selectedRequest.approvatoSettembreEA7 === 1 ? "SETTEMBRE " : "") + "<br>";
        messagePlain += "(Costo in euro " + costoTotaleEA7 + ")<br><br>";
        let a = parseFloat(costoTotaleEA);
        let b = parseFloat(costoTotaleEA7);
        costoTotaleEA = a + b;
      }
      if(selectedRequest.approvatoGiugnoEA8 === 1 || selectedRequest.approvatoLuglioEA8 === 1 || selectedRequest.approvatoAgostoEA8 === 1 || selectedRequest.approvatoAgostoEA8 === 1){
        messagePlain += selectedRequest.nomeCognomeEA8.toUpperCase() + " turni: " + (selectedRequest.approvatoGiugnoEA8 === 1 ? "GIUGNO " : "") + (selectedRequest.approvatoLuglioEA8 === 1 ? "LUGLIO " : "") + (selectedRequest.approvatoAgostoEA8 === 1 ? "AGOSTO " : "") + (selectedRequest.approvatoSettembreEA8 === 1 ? "SETTEMBRE " : "") + "<br>";
        messagePlain += "(Costo in euro " + costoTotaleEA8 + ")<br><br>";
        let a = parseFloat(costoTotaleEA);
        let b = parseFloat(costoTotaleEA8);
        costoTotaleEA = a + b;
      }
      if(selectedRequest.approvatoGiugnoEA9 === 1 || selectedRequest.approvatoLuglioEA9 === 1 || selectedRequest.approvatoAgostoEA9 === 1 || selectedRequest.approvatoAgostoEA9 === 1){
        messagePlain += selectedRequest.nomeCognomeEA9.toUpperCase() + " turni: " + (selectedRequest.approvatoGiugnoEA9 === 1 ? "GIUGNO " : "") + (selectedRequest.approvatoLuglioEA9 === 1 ? "LUGLIO " : "") + (selectedRequest.approvatoAgostoEA9 === 1 ? "AGOSTO " : "") + (selectedRequest.approvatoSettembreEA9 === 1 ? "SETTEMBRE " : "") + "<br>";
        messagePlain += "(Costo in euro " + costoTotaleEA9 + ")<br><br>";
        let a = parseFloat(costoTotaleEA);
        let b = parseFloat(costoTotaleEA9);
        costoTotaleEA = a + b;
      }
      if(selectedRequest.approvatoGiugnoEA10 === 1 || selectedRequest.approvatoLuglioEA10 === 1 || selectedRequest.approvatoAgostoEA10 === 1 || selectedRequest.approvatoAgostoEA10 === 1){
        messagePlain += selectedRequest.nomeCognomeEA10.toUpperCase() + " turni: " + (selectedRequest.approvatoGiugnoEA10 === 1 ? "GIUGNO " : "") + (selectedRequest.approvatoLuglioEA10 === 1 ? "LUGLIO " : "") + (selectedRequest.approvatoAgostoEA10 === 1 ? "AGOSTO " : "") + (selectedRequest.approvatoSettembreEA10 === 1 ? "SETTEMBRE " : "") + "<br>";
        messagePlain += "(Costo in euro " + costoTotaleEA10 + ")<br><br>";
        let a = parseFloat(costoTotaleEA);
        let b = parseFloat(costoTotaleEA10);
        costoTotaleEA = a + b;
      }
    }

    let daVersare = 0.0;
    let a = parseFloat(costoTotaleEA);
    let b = parseFloat(costoTotaleDaVersare);
    console.log("costoTotaleEA " + a);
    console.log("costoTotaleDaVersare " + b);
    daVersare = a + b;
    console.log("daVersare " + (parseFloat(daVersare).toFixed(2)));

    messagePlain += "Ti invitiamo a versare la somma di <strong>" + (parseFloat(daVersare).toFixed(2)) + "</strong> euro tramite bonifico sul Conto Corrente Bancario presso <br>"
    messagePlain += "Banco di Credito Cooperativo di Napoli, intestato a \"NAUSICA s.r.l.\", IBAN IT64X0711039840000000012722";
     
    messagePlain += "<br><br>Riceverai a breve un link per effettuare l'upload della documentazione da fornire (prevista dal Regolamento 2026) insieme alla copia del versamento effettuato."
    messagePlain += "<br><br>";
    messagePlain += "A seguito della verifica della documentazione e del pagamento, il tuo abbonamento verrà emesso e riceverai istruzioni su come ottenerne copia digitale."
    messagePlain += "<br><br>Il Gestore";

    var messageHtml = messagePlain;

    console.log(messageHtml)
    
    sendEmail(messageHtml, messagePlain, toEmail, "Approvazione domanda");
  } 

  const inviaEmailApprovazioneSoloGiugno = async () => {
    var toEmail = selectedRequest.emailTitolare;

    var messagePlain = "Gentile " + selectedRequest.nomeTitolare.toUpperCase() + " " + selectedRequest.cognomeTitolare.toUpperCase() + " ti comunichiamo che la tua richiesta ";
    messagePlain += "<strong>" +  selectedIdRichiesta + "</strong>";
    messagePlain += " è stata <strong>APPROVATA</strong> per il mese di GIUGNO. <br><br>";
    messagePlain += " ENTRO IL 25 GIUGNO RICEVERAI ULTERIORE COMUNICAZIONE RELATIVA LA VALUTAZIONE DEI SUCCESSIVI TURNI. <br><br>";
    messagePlain += "Riportiamo i dettagli dei turni approvati: <br><br>";

    var costoTotaleDaVersare = 0;
    var costoHalf = categoria.find(o => o.value === selectedRequest.categoriaDiAppartenenza.toUpperCase()).halfMonthF;
    var costoFull = categoria.find(o => o.value === selectedRequest.categoriaDiAppartenenza.toUpperCase()).fullMonthF;

    if(selectedRequest.giugnoApprovato === "SI"){
      messagePlain += "Turno dal 15 Giugno 2026 al 30 Giugno 2026 <br>";
      messagePlain += "(Costo in euro " + costoHalf + ") <br><br>";
      let a = costoHalf;
      let b = costoTotaleDaVersare;
      costoTotaleDaVersare = a + b;
     
    }

    let costoTotaleEA = 0.0;
  

    if(selectedRequest.numeroAltriAbbonamenti > 0){
      messagePlain += "Sono stati inoltre approvati i turni per i tuoi familiari e/o conviventi: <br>";
      if(selectedRequest.approvatoGiugnoEA1 === 1){
        messagePlain += selectedRequest.nomeCognomeEA1.toUpperCase() + " turni: " + (selectedRequest.approvatoGiugnoEA1 === 1 ? "GIUGNO " : "") + "<br>";
        messagePlain += "(Costo in euro " + costoTotaleEA1 + ")<br><br>";
        let a = parseFloat(costoTotaleEA);
        let b = parseFloat(costoTotaleEA1);
        costoTotaleEA = a + b;
      }
      if(selectedRequest.approvatoGiugnoEA2 === 1){
        messagePlain += selectedRequest.nomeCognomeEA2.toUpperCase() + " turni: " + (selectedRequest.approvatoGiugnoEA2 === 1 ? "GIUGNO " : "") + "<br>";
        messagePlain += "(Costo in euro " + costoTotaleEA2 + ")<br><br>";
        let a = parseFloat(costoTotaleEA);
        let b = parseFloat(costoTotaleEA2);
        costoTotaleEA = a + b;
      }
      if(selectedRequest.approvatoGiugnoEA3 === 1){
        messagePlain += selectedRequest.nomeCognomeEA3.toUpperCase() + " turni: " + (selectedRequest.approvatoGiugnoEA3 === 1 ? "GIUGNO " : "") + "<br>";
        messagePlain += "(Costo in euro " + costoTotaleEA3 + ")<br><br>";
        let a = parseFloat(costoTotaleEA);
        let b = parseFloat(costoTotaleEA3);
        costoTotaleEA = a + b;
      }
      if(selectedRequest.approvatoGiugnoEA4 === 1){
        messagePlain += selectedRequest.nomeCognomeEA4.toUpperCase() + " turni: " + (selectedRequest.approvatoGiugnoEA4 === 1 ? "GIUGNO " : "") + "<br>";
        messagePlain += "(Costo in euro " + costoTotaleEA4 + ")<br><br>";
        let a = parseFloat(costoTotaleEA);
        let b = parseFloat(costoTotaleEA4);
        costoTotaleEA = a + b;
        
      }
      if(selectedRequest.approvatoGiugnoEA5 === 1){
        messagePlain += selectedRequest.nomeCognomeEA5.toUpperCase() + " turni: " + (selectedRequest.approvatoGiugnoEA5 === 1 ? "GIUGNO " : "") + "<br>";
        messagePlain += "(Costo in euro " + costoTotaleEA5 + ")<br><br>";
        let a = parseFloat(costoTotaleEA);
        let b = parseFloat(costoTotaleEA5);
        costoTotaleEA = a + b;
      }
      if(selectedRequest.approvatoGiugnoEA6 === 1){
        messagePlain += selectedRequest.nomeCognomeEA6.toUpperCase() + " turni: " + (selectedRequest.approvatoGiugnoEA6 === 1 ? "GIUGNO " : "") + "<br>";
        messagePlain += "(Costo in euro " + costoTotaleEA6 + ")<br><br>";
        let a = parseFloat(costoTotaleEA);
        let b = parseFloat(costoTotaleEA6);
        costoTotaleEA = a + b;
      }
      if(selectedRequest.approvatoGiugnoEA7 === 1){
        messagePlain += selectedRequest.nomeCognomeEA7.toUpperCase() + " turni: " + (selectedRequest.approvatoGiugnoEA7 === 1 ? "GIUGNO " : "") + "<br>";
        messagePlain += "(Costo in euro " + costoTotaleEA7 + ")<br><br>";
        let a = parseFloat(costoTotaleEA);
        let b = parseFloat(costoTotaleEA7);
        costoTotaleEA = a + b;
      }
      if(selectedRequest.approvatoGiugnoEA8 === 1){
        messagePlain += selectedRequest.nomeCognomeEA8.toUpperCase() + " turni: " + (selectedRequest.approvatoGiugnoEA8 === 1 ? "GIUGNO " : "") + "<br>";
        messagePlain += "(Costo in euro " + costoTotaleEA8 + ")<br><br>";
        let a = parseFloat(costoTotaleEA);
        let b = parseFloat(costoTotaleEA8);
        costoTotaleEA = a + b;
      }
      if(selectedRequest.approvatoGiugnoEA9 === 1){
        messagePlain += selectedRequest.nomeCognomeEA9.toUpperCase() + " turni: " + (selectedRequest.approvatoGiugnoEA9 === 1 ? "GIUGNO " : "") + "<br>";
        messagePlain += "(Costo in euro " + costoTotaleEA9 + ")<br><br>";
        let a = parseFloat(costoTotaleEA);
        let b = parseFloat(costoTotaleEA9);
        costoTotaleEA = a + b;
      }
      if(selectedRequest.approvatoGiugnoEA10 === 1){
        messagePlain += selectedRequest.nomeCognomeEA10.toUpperCase() + " turni: " + (selectedRequest.approvatoGiugnoEA10 === 1 ? "GIUGNO " : "") + "<br>";
        messagePlain += "(Costo in euro " + costoTotaleEA10 + ")<br><br>";
        let a = parseFloat(costoTotaleEA);
        let b = parseFloat(costoTotaleEA10);
        costoTotaleEA = a + b;
      }
    }

    let daVersare = 0.0;
    let a = parseFloat(costoTotaleEA);
    let b = parseFloat(costoTotaleDaVersare);
    console.log("costoTotaleEA " + a);
    console.log("costoTotaleDaVersare " + b);
    daVersare = a + b;
    console.log("daVersare " + (parseFloat(daVersare).toFixed(2)));

    messagePlain += "Ti invitiamo a versare la somma di <strong>" + (parseFloat(daVersare).toFixed(2)) + "</strong> euro tramite bonifico sul Conto Corrente Bancario presso <br>"
    messagePlain += "Banco di Credito Cooperativo di Napoli, intestato a \"NAUSICA s.r.l.\", IBAN IT64X0711039840000000012722";
     
    messagePlain += "<br><br>Riceverai a breve un link per effettuare l'upload della documentazione da fornire (prevista dal Regolamento 2026) insieme alla copia del versamento effettuato."
    messagePlain += "<br><br>";
    messagePlain += "A seguito della verifica della documentazione e del pagamento, il tuo abbonamento verrà emesso e riceverai istruzioni su come ottenerne copia digitale."
    messagePlain += "<br><br>Il Gestore";

    var messageHtml = messagePlain;

    console.log(messageHtml)
    
    sendEmail(messageHtml, messagePlain, toEmail);
  } 
const [showDetails, setShowDetails] = React.useState(false);

useEffect(() => {
    daVersareState = 0.0;
    caricaRichieste();
    caricaTuttiGliAbbonamenti();
  }, []);
  
  const [attachments, setAttachments] = useState(null);

       
function getDOCS(idRichiesta){
  docsArray = [];
  setAttachments((arr) => []);
  console.log("getDOCS >>>>>>>>>>>>>>>>>>>>>>>>>>>><");
  handleOpenLoader(true);
  const storageRef = ref(storage, "/" + idRichiesta + "/");
  listAll(storageRef)
  .then((res) => {
      res.items.forEach((item) => {
        getDownloadURL(ref(storage, "/" + idRichiesta + "/" + item.name))
        .then((url) => {
          docsArray.push({name:item.name, url:url});
          console.log("{name:" + item.name + ", url:" + url + "})");
          setAttachments((arr) => [...arr, {name:item.name, url:url}]);
        })
        .catch((error) => {
          // Handle any errors
        });
      });
      handleCloseLoader(true);
     
      console.log("getDOCS docsArray >>>>>>>>>>>>>>>>>>>>>>>>>>>>  " + docsArray);
  })
  .catch((err) => {
      alert(err.message);
  });  
}

    return (
        <Box  sx={{ flexGrow: 1 }}>
           <Stack direction="row" spacing={0.5}>
           <Card variant="outlined" sx={{ width: "30%", marginBottom:5 }}>
              <Box sx={{ p: 2 }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <Typography gutterBottom variant="h7" component="div">
                    RICHIESTE PERVENUTE
                  </Typography>
                  <Typography gutterBottom variant="h7" component="div">
                  <strong>{counterAll}</strong>
                  </Typography>
                </Stack>
              </Box>
              <Divider />
              <Box sx={{ p: 2}}>
                <Stack direction="row" spacing={0.5}>
                    <Card variant="outlined" sx={{ width: "10%", marginBottom:5, justifyContent:"center", textAlign:"center" }}>
                      <Box sx={{ p: 2 }}>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          <Typography gutterBottom variant="h7" component="div" sx={{textAlign:"center", justifyContent:"center"}}>
                           A
                          </Typography>
                        </Stack>
                      </Box>
                      <Divider />
                      <Box sx={{ p: 2}}>
                        <Stack direction="row" spacing={1}>
                        <Typography gutterBottom variant="body2">
                          <strong>{counterA}</strong>
                        </Typography>
                        </Stack>
                      </Box>
                    </Card>
                    <Card variant="outlined" sx={{ width: "10%", marginBottom:5, justifyContent:"center", textAlign:"center" }}>
                      <Box sx={{ p: 2 }}>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          <Typography gutterBottom variant="h7" component="div" sx={{textAlign:"center", justifyContent:"center"}}>
                           B
                          </Typography>
                        </Stack>
                      </Box>
                      <Divider />
                      <Box sx={{ p: 2}}>
                        <Stack direction="row" spacing={1}>
                        <Typography gutterBottom variant="body2">
                          <strong>{counterB}</strong>
                        </Typography>
                        </Stack>
                      </Box>
                    </Card>
                    <Card variant="outlined" sx={{ width: "10%", marginBottom:5, justifyContent:"center", textAlign:"center" }}>
                      <Box sx={{ p: 2 }}>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          <Typography gutterBottom variant="h7" component="div" sx={{textAlign:"center", justifyContent:"center"}}>
                           C
                          </Typography>
                        </Stack>
                      </Box>
                      <Divider />
                      <Box sx={{ p: 2}}>
                        <Stack direction="row" spacing={1}>
                        <Typography gutterBottom variant="body2">
                          <strong>{counterC}</strong>
                        </Typography>
                        </Stack>
                      </Box>
                    </Card>
                    <Card variant="outlined" sx={{ width: "10%", marginBottom:5, justifyContent:"center", textAlign:"center" }}>
                      <Box sx={{ p: 2 }}>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          <Typography gutterBottom variant="h7" component="div" sx={{textAlign:"center", justifyContent:"center"}}>
                           D
                          </Typography>
                        </Stack>
                      </Box>
                      <Divider />
                      <Box sx={{ p: 2}}>
                        <Stack direction="row" spacing={1}>
                        <Typography gutterBottom variant="body2">
                          <strong>{counterD}</strong>
                        </Typography>
                        </Stack>
                      </Box>
                    </Card>
                    <Card variant="outlined" sx={{ width: "10%", marginBottom:5, justifyContent:"center", textAlign:"center" }}>
                      <Box sx={{ p: 2 }}>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          <Typography gutterBottom variant="h7" component="div" sx={{textAlign:"center", justifyContent:"center"}}>
                           E
                          </Typography>
                        </Stack>
                      </Box>
                      <Divider />
                      <Box sx={{ p: 2}}>
                        <Stack direction="row" spacing={1}>
                        <Typography gutterBottom variant="body2">
                          <strong>{counterE}</strong>
                        </Typography>
                        </Stack>
                      </Box>
                    </Card>
                    <Card variant="outlined" sx={{ width: "10%", marginBottom:5, justifyContent:"center", textAlign:"center" }}>
                      <Box sx={{ p: 2 }}>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          <Typography gutterBottom variant="h7" component="div" sx={{textAlign:"center", justifyContent:"center"}}>
                           F
                          </Typography>
                        </Stack>
                      </Box>
                      <Divider />
                      <Box sx={{ p: 2}}>
                        <Stack direction="row" spacing={1}>
                        <Typography gutterBottom variant="body2">
                          <strong>{counterF}</strong>
                        </Typography>
                        </Stack>
                      </Box>
                    </Card>
                    <Card variant="outlined" sx={{ width: "10%", marginBottom:5, justifyContent:"center", textAlign:"center" }}>
                      <Box sx={{ p: 2 }}>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          <Typography gutterBottom variant="h7" component="div" sx={{textAlign:"center", justifyContent:"center"}}>
                           G
                          </Typography>
                        </Stack>
                      </Box>
                      <Divider />
                      <Box sx={{ p: 2}}>
                        <Stack direction="row" spacing={1}>
                        <Typography gutterBottom variant="body2">
                          <strong>{counterG}</strong>
                        </Typography>
                        </Stack>
                      </Box>
                    </Card>
                    <Card variant="outlined" sx={{ width: "10%", marginBottom:5, justifyContent:"center", textAlign:"center" }}>
                      <Box sx={{ p: 2 }}>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          <Typography gutterBottom variant="h7" component="div" sx={{textAlign:"center", justifyContent:"center"}}>
                           H
                          </Typography>
                        </Stack>
                      </Box>
                      <Divider />
                      <Box sx={{ p: 2}}>
                        <Stack direction="row" spacing={1}>
                        <Typography gutterBottom variant="body2">
                          <strong>{counterH}</strong>
                        </Typography>
                        </Stack>
                      </Box>
                    </Card>
                    <Card variant="outlined" sx={{ width: "10%", marginBottom:5, justifyContent:"center", textAlign:"center" }}>
                      <Box sx={{ p: 2 }}>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          <Typography gutterBottom variant="h7" component="div" sx={{textAlign:"center", justifyContent:"center"}}>
                           I
                          </Typography>
                        </Stack>
                      </Box>
                      <Divider />
                      <Box sx={{ p: 2}}>
                        <Stack direction="row" spacing={1}>
                        <Typography gutterBottom variant="body2">
                          <strong>{counterI}</strong>
                        </Typography>
                        </Stack>
                      </Box>
                    </Card>
                </Stack>
              </Box>
            </Card>
            <Card variant="outlined" sx={{ width: "30%", marginBottom:5 }}>
              <Box sx={{ p: 2 }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <Typography gutterBottom variant="h7" component="div">
                   TURNI RICHIESTI
                  </Typography>
                  
                </Stack>
              </Box>
              <Divider />
              <Box sx={{ p: 2}}>
                <Stack direction="row" spacing={0.5}>
                    <Card variant="outlined" sx={{ width: "23%", marginBottom:5, justifyContent:"center", textAlign:"center" }}>
                      <Box sx={{ p: 2 }}>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          <Typography gutterBottom variant="h7" component="div" sx={{textAlign:"center", justifyContent:"center"}}>
                           GIUGNO
                          </Typography>
                        </Stack>
                      </Box>
                      <Divider />
                      <Box sx={{ p: 2}}>
                        <Stack direction="row" spacing={1}>
                        <Typography gutterBottom variant="body2">
                          <strong>{counterJun}</strong>
                        </Typography>
                        </Stack>
                      </Box>
                    </Card>
                    <Card variant="outlined" sx={{ width: "23%", marginBottom:5, justifyContent:"center", textAlign:"center" }}>
                      <Box sx={{ p: 2 }}>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          <Typography gutterBottom variant="h7" component="div" sx={{textAlign:"center", justifyContent:"center"}}>
                           LUGLIO
                          </Typography>
                        </Stack>
                      </Box>
                      <Divider />
                      <Box sx={{ p: 2}}>
                        <Stack direction="row" spacing={1}>
                        <Typography gutterBottom variant="body2">
                          <strong>{counterJul}</strong>
                        </Typography>
                        </Stack>
                      </Box>
                    </Card>
                    <Card variant="outlined" sx={{ width: "23%", marginBottom:5, justifyContent:"center", textAlign:"center" }}>
                      <Box sx={{ p: 2 }}>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          <Typography gutterBottom variant="h7" component="div" sx={{textAlign:"center", justifyContent:"center"}}>
                           AGOSTO
                          </Typography>
                        </Stack>
                      </Box>
                      <Divider />
                      <Box sx={{ p: 2}}>
                        <Stack direction="row" spacing={1}>
                        <Typography gutterBottom variant="body2">
                          <strong>{counterAug}</strong>
                        </Typography>
                        </Stack>
                      </Box>
                    </Card>
                    <Card variant="outlined" sx={{ width: "23%", marginBottom:5, justifyContent:"center", textAlign:"center" }}>
                      <Box sx={{ p: 2 }}>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          <Typography gutterBottom variant="h7" component="div" sx={{textAlign:"center", justifyContent:"center"}}>
                           SETTEMBRE
                          </Typography>
                        </Stack>
                      </Box>
                      <Divider />
                      <Box sx={{ p: 2}}>
                        <Stack direction="row" spacing={1}>
                        <Typography gutterBottom variant="body2">
                          <strong>{counterSep}</strong>
                        </Typography>
                        </Stack>
                      </Box>
                    </Card>
                </Stack>
              </Box>
            </Card>
            <Card variant="outlined" sx={{ width: "30%", marginBottom:5 }}>
              <Box sx={{ p: 2 }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <Typography gutterBottom variant="h7" component="div">
                   TURNI APPROVATI
                  </Typography>
                  
                </Stack>
              </Box>
              <Divider />
              <Box sx={{ p: 2}}>
                <Stack direction="row" spacing={0.5}>
                    <Card variant="outlined" sx={{ width: "23%", marginBottom:5, justifyContent:"center", textAlign:"center" }}>
                      <Box sx={{ p: 2 }}>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          <Typography gutterBottom variant="h7" component="div" sx={{textAlign:"center", justifyContent:"center"}}>
                           GIUGNO
                          </Typography>
                        </Stack>
                      </Box>
                      <Divider />
                      <Box sx={{ p: 2}}>
                        <Stack direction="row" spacing={1}>
                        <Typography gutterBottom variant="body2">
                          <strong>{approvedCounterJun}</strong>
                        </Typography>
                        </Stack>
                      </Box>
                    </Card>
                    <Card variant="outlined" sx={{ width: "23%", marginBottom:5, justifyContent:"center", textAlign:"center" }}>
                      <Box sx={{ p: 2 }}>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          <Typography gutterBottom variant="h7" component="div" sx={{textAlign:"center", justifyContent:"center"}}>
                           LUGLIO
                          </Typography>
                        </Stack>
                      </Box>
                      <Divider />
                      <Box sx={{ p: 2}}>
                        <Stack direction="row" spacing={1}>
                        <Typography gutterBottom variant="body2">
                          <strong>{approvedCounterJul}</strong>
                        </Typography>
                        </Stack>
                      </Box>
                    </Card>
                    <Card variant="outlined" sx={{ width: "23%", marginBottom:5, justifyContent:"center", textAlign:"center" }}>
                      <Box sx={{ p: 2 }}>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          <Typography gutterBottom variant="h7" component="div" sx={{textAlign:"center", justifyContent:"center"}}>
                           AGOSTO
                          </Typography>
                        </Stack>
                      </Box>
                      <Divider />
                      <Box sx={{ p: 2}}>
                        <Stack direction="row" spacing={1}>
                        <Typography gutterBottom variant="body2">
                          <strong>{approvedCounterAug}</strong>
                        </Typography>
                        </Stack>
                      </Box>
                    </Card>
                    <Card variant="outlined" sx={{ width: "23%", marginBottom:5, justifyContent:"center", textAlign:"center" }}>
                      <Box sx={{ p: 2 }}>
                        <Stack direction="row" justifyContent="center" alignItems="center">
                          <Typography gutterBottom variant="h7" component="div" sx={{textAlign:"center", justifyContent:"center"}}>
                           SETTEMBRE
                          </Typography>
                        </Stack>
                      </Box>
                      <Divider />
                      <Box sx={{ p: 2}}>
                        <Stack direction="row" spacing={1}>
                        <Typography gutterBottom variant="body2">
                          <strong>{approvedCounterSep}</strong>
                        </Typography>
                        </Stack>
                      </Box>
                    </Card>
                </Stack>
              </Box>
            </Card>
            </Stack>
            <Box sx={{ textAlign:"right", paddingBottom:5}}>
            {
              (showDetails === true) ? (  
              <Button
                variant="contained"
                sx={{ mt: 1, mr: 1 }}
                size='small'
                onClick={chiudiDettagliRichiesta}
                >
                CHIUDI DETTAGLI
            </Button>
            
            ) : ( 
            <Button
                variant="contained"
                sx={{ mt: 1, mr: 1 }}
                size='small'
                onClick={caricaRichieste}
                >
                RICARICA RICHIESTE
            </Button>) 
            }
            </Box>
           
           
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={openLoader}
                onClick={handleCloseLoader}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            {
              (showDetails === true) ? ( 
              <Box sx={{ width: '100%' }}>
                 <Typography>{categoria.find(o => o.value === selectedRequest.categoriaDiAppartenenza.toUpperCase()).label.toUpperCase()}</Typography>
                 <Typography>{selectedRequest.gradoTitolare.toUpperCase() + " - " + selectedRequest.nomeTitolare.toUpperCase() + " " + selectedRequest.cognomeTitolare.toUpperCase()}</Typography>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={valueTab} onChange={handleChangeTab} aria-label="dettagli richiesta">
                  <Tab label="DATI PERSONALI" {...a11yProps(0)} />
                  <Tab label="CATEGORIA DI APPARTENENZA" {...a11yProps(1)} />
                  <Tab label="TURNI SCELTI" {...a11yProps(2)} />
                  <Tab label="FAMILIARI e/o CONVIVENTI" {...a11yProps(3)} />
                  <Tab label="VALUTAZIONE DOMANDA E TOOLS" {...a11yProps(4)} />
                </Tabs>
              </Box>
              <CustomTabPanel value={valueTab} index={0}>
              <Grid
                    container
                    sx={{ width: "100%",  paddingTop: 2, paddingBottom:5 }}
                    rowGap={3}
                  >
                    <Grid item xs={12} sx={{ width: "100%"}}>
                      <TextField
                              inputProps={
                                { readOnly: true }
                            }
                              value={selectedRequest.nomeTitolare.toUpperCase()}
                              id="outlined-name-currency"
                              label="Nome"
                              placeholder=""
                              xs={12}
                              sx={{
                                width: "100%",
                                textAlign: "left",
                                boxShadow: 5,
                                borderRadius: 1,
                              }}
                        ></TextField>
                    </Grid>
                    <Grid item xs={12} sx={{ width: "100%"}}>
                      <TextField
                              inputProps={
                                { readOnly: true }
                            }
                              value={selectedRequest.cognomeTitolare.toUpperCase()}
                              id="outlined-lastName-currency"
                              label="Cognome"
                              placeholder=""
                              xs={12}
                              sx={{
                                width: "100%",
                                textAlign: "left",
                                boxShadow: 5,
                                borderRadius: 1,
                              }}
                        ></TextField>
                    </Grid>
                    <Grid item xs={12} sx={{ width: "100%"}}>
                      <TextField
                              inputProps={
                                { readOnly: true }
                            }
                              value={selectedRequest.cittaDiNascitaTitolare.toUpperCase()}
                              id="outlined-bCity-currency"
                              label="Citta di nascita"
                              placeholder=""
                              xs={12}
                              sx={{
                                width: "100%",
                                textAlign: "left",
                                boxShadow: 5,
                                borderRadius: 1,
                              }}
                        ></TextField>
                    </Grid>
                    <Grid item xs={12} sx={{ width: "100%"}}>
                      <TextField
                               inputProps={
                                { readOnly: true }
                            }
                              value={selectedRequest.nazioneDiNascitaTitolare.toUpperCase()}
                              id="outlined-bProv-currency"
                              label="Provincia di nascita"
                              placeholder=""
                              xs={12}
                              sx={{
                                width: "100%",
                                textAlign: "left",
                                boxShadow: 5,
                                borderRadius: 1,
                              }}
                        ></TextField>
                    </Grid>
                    <Grid item xs={12} sx={{ width: "100%"}}>
                      <TextField
                              inputProps={
                                { readOnly: true }
                            }
                              id="outlined-bCountry-currency"
                              label="Nazione di nascita"
                              value={selectedRequest.provinciaDiNascitaTitolare.toUpperCase()}
                              placeholder=""
                              xs={12}
                              sx={{
                                width: "100%",
                                textAlign: "left",
                                boxShadow: 5,
                                borderRadius: 1,
                              }}
                        ></TextField>
                    </Grid>
                    <Grid item xs={12} sx={{ width: "100%" }}>
                            <TextField
                               inputProps={
                                { readOnly: true }
                            }
                              value={selectedRequest.dataNascitaTitolare.toUpperCase()}
                              id="outlined-email-currency"
                              label="Email"
                              placeholder=""
                              xs={12}
                              sx={{
                                width: "100%",
                                textAlign: "left",
                                boxShadow: 5,
                                borderRadius: 1,
                              }}
                            ></TextField>
                
                    </Grid>
                    <Grid item xs={12} sx={{ width: "100%"}}>
                            <TextField
                               inputProps={
                                { readOnly: true }
                            }
                              value={selectedRequest.emailTitolare.toLowerCase()}
                              id="outlined-email-currency"
                              label="Email"
                              placeholder=""
                              xs={12}
                              sx={{
                                width: "100%",
                                textAlign: "left",
                                boxShadow: 5,
                                borderRadius: 1,
                              }}
                            ></TextField>
                          </Grid>
                  </Grid>
              </CustomTabPanel>
              <CustomTabPanel value={valueTab} index={1}>
                  <Grid
                    container
                    sx={{ width: "100%",  paddingTop: 2, paddingBottom:5 }}
                    rowGap={3}
                  >
                    <Grid item xs={12} sx={{ width: "100%"}}>
                      <TextField
                              inputProps={
                                { readOnly: true }
                            }
                              value={categoria.find(o => o.value === selectedRequest.categoriaDiAppartenenza.toUpperCase()).label.toUpperCase()}
                              id="outlined-categoria-currency"
                              label="Categoria Di Appartenenza"
                              placeholder=""
                              xs={12}
                              sx={{
                                width: "100%",
                                textAlign: "left",
                                boxShadow: 5,
                                borderRadius: 1,
                              }}
                        ></TextField>
                    </Grid>
                    {
                      (
                        selectedRequest.categoriaDiAppartenenza === "A-M" ||
                        selectedRequest.categoriaDiAppartenenza === "A-C" ||
                        selectedRequest.categoriaDiAppartenenza === "B-M" ||
                        selectedRequest.categoriaDiAppartenenza === "B-C" ||
                        selectedRequest.categoriaDiAppartenenza === "D-M" ||
                        selectedRequest.categoriaDiAppartenenza === "D-C" ||
                        selectedRequest.categoriaDiAppartenenza === "H" ||
                        selectedRequest.categoriaDiAppartenenza === "I" ||
                        selectedRequest.categoriaDiAppartenenza === "E" ||
                        selectedRequest.categoriaDiAppartenenza === "F"
                      ) ? (
                        <Grid item xs={12} sx={{ width: "100%"}}>
                          <TextField
                                  inputProps={
                                    { readOnly: true }
                                }
                                  value={selectedRequest.gradoTitolare.toUpperCase()}
                                  id="outlined-grado-currency"
                                  label="Grado"
                                  placeholder=""
                                  xs={12}
                                  sx={{
                                    width: "100%",
                                    textAlign: "left",
                                    boxShadow: 5,
                                    borderRadius: 1,
                                  }}
                            ></TextField>
                        </Grid>
                      ) : (<></>)
                    }
                     {
                      (
                        selectedRequest.categoriaDiAppartenenza === "A-M" ||
                        selectedRequest.categoriaDiAppartenenza === "A-C" ||
                        selectedRequest.categoriaDiAppartenenza === "B-M" ||
                        selectedRequest.categoriaDiAppartenenza === "B-C" ||
                        selectedRequest.categoriaDiAppartenenza === "D-M" ||
                        selectedRequest.categoriaDiAppartenenza === "D-C" 
                      ) ? (
                        <Grid item xs={12} sx={{ width: "100%"}}>
                        <TextField
                                inputProps={
                                  { readOnly: true }
                              }
                                value={selectedRequest.cmdTitolare.toUpperCase()}
                                id="outlined-cmd-currency"
                                label="CMD"
                                placeholder=""
                                xs={12}
                                sx={{
                                  width: "100%",
                                  textAlign: "left",
                                  boxShadow: 5,
                                  borderRadius: 1,
                                }}
                          ></TextField>
                      </Grid>
                      ) : (<></>)
                    }
                    {
                      (
                        selectedRequest.categoriaDiAppartenenza === "B-M" ||
                        selectedRequest.categoriaDiAppartenenza === "B-C" ||
                        selectedRequest.categoriaDiAppartenenza === "D-M" ||
                        selectedRequest.categoriaDiAppartenenza === "D-C" ||
                        selectedRequest.categoriaDiAppartenenza === "H" ||
                        selectedRequest.categoriaDiAppartenenza === "I" 
                      ) ? (
                        <Grid item xs={12} sx={{ width: "100%"}}>
                        <TextField
                                 inputProps={
                                  { readOnly: true }
                              }
                                value={selectedRequest.enteDiservizioTitolare.toUpperCase()}
                                id="outlined-entediservizio-currency"
                                label="Ente di servizio"
                                placeholder=""
                                xs={12}
                                sx={{
                                  width: "100%",
                                  textAlign: "left",
                                  boxShadow: 5,
                                  borderRadius: 1,
                                }}
                          ></TextField>
                      </Grid>
                      ) : (<></>)
                    }
                     {
                      (
                        selectedRequest.categoriaDiAppartenenza === "C" ||
                        selectedRequest.categoriaDiAppartenenza === "G" ||
                        selectedRequest.categoriaDiAppartenenza === "H" ||
                        selectedRequest.categoriaDiAppartenenza === "I" ||
                        selectedRequest.categoriaDiAppartenenza === "E" ||
                        selectedRequest.categoriaDiAppartenenza === "F" 
                      ) ? (
                        <Grid item xs={12} sx={{ width: "100%"}}>
                        <TextField
                                inputProps={
                                  { readOnly: true }
                              }
                                id="outlined-ultimoentediservizio-currency"
                                label="Ultimo ente di servizio"
                                value={ selectedRequest.categoriaDiAppartenenza === "E" ? "ACCADEMIA AERONAUTICA" : selectedRequest.ultimoEnteDiServizioTitolare.toUpperCase()}
                                placeholder=""
                                xs={12}
                                sx={{
                                  width: "100%",
                                  textAlign: "left",
                                  boxShadow: 5,
                                  borderRadius: 1,
                                }}
                          ></TextField>
                      </Grid>
                      ) : (<></>)
                    }
                    {
                      (
                        selectedRequest.categoriaDiAppartenenza === "C" ||
                        selectedRequest.categoriaDiAppartenenza === "G" 
                      ) ? (
                        <Grid item xs={12} sx={{ width: "100%" }}>
                            <TextField
                               inputProps={
                                { readOnly: true }
                            }
                              value={selectedRequest.nomeCognomeDefunto.toUpperCase()}
                              id="outlined-nomedefunto-currency"
                              label="Nome e Cognome defunto"
                              placeholder=""
                              xs={12}
                              sx={{
                                width: "100%",
                                textAlign: "left",
                                boxShadow: 5,
                                borderRadius: 1,
                              }}
                            ></TextField>
                
                    </Grid>
                      ) : (<></>)
                    }
                     {
                      (
                        selectedRequest.categoriaDiAppartenenza === "C" ||
                        selectedRequest.categoriaDiAppartenenza === "G" ||
                        selectedRequest.categoriaDiAppartenenza === "H" ||
                        selectedRequest.categoriaDiAppartenenza === "I" ||
                        selectedRequest.categoriaDiAppartenenza === "E" ||
                        selectedRequest.categoriaDiAppartenenza === "F" 
                      ) ? (
                        <Grid item xs={12} sx={{ width: "100%"}}>
                        <TextField
                           inputProps={
                            { readOnly: true }
                        }
                          value={selectedRequest.estremiDocumento.toLowerCase()}
                          id="outlined-estremidocumento-currency"
                          label="Estremi documento che attesti l'appartenenza alla categoria scelta"
                          placeholder=""
                          xs={12}
                          sx={{
                            width: "100%",
                            textAlign: "left",
                            boxShadow: 5,
                            borderRadius: 1,
                          }}
                        ></TextField>
                      </Grid>
                      ) : (<></>)
                    }
                  </Grid>
              </CustomTabPanel>
              <CustomTabPanel value={valueTab} index={2}>
                <Grid
                  container
                  sx={{ width: "100%",  paddingTop: 2, paddingBottom:5 }}
                  rowGap={3}
                >
                  <Grid item xs={12} sx={{ width: "100%" }}>
                          <TextField
                            id="outlined-turnogiugno-currency"
                            label="Turno dal 15 Giugno al 30 Giugno"
                            defaultValue=""
                            placeholder="Seleziona"
                            value={selectedRequest.turnoGiugno.toUpperCase()}
                            xs={6}
                            sx={{
                              width: "63%",
                              textAlign: "left",
                              boxShadow: 5,
                              borderRadius: 1,
                              marginRight: "1%"
                            }}
                          >
                          </TextField>
                          { (selectedRequest.turnoGiugno.toUpperCase() === "SI") ? ( <TextField
                            id="outlined-giugnopriorita-currency"
                            
                            label="Priorita'"
                            defaultValue=""
                            placeholder="Seleziona"
                            value={selectedRequest.prioritaTurnoGiugno === "" ? "ALTRO" : selectedRequest.prioritaTurnoGiugno }
                            xs={6}
                            sx={{
                              width: "35%",
                              textAlign: "left",
                              boxShadow: 5,
                              borderRadius: 1,
                            }}
                          >
                          </TextField>) : (<></>) }
                         
                      </Grid> 
                      <Grid item xs={12} sx={{ width: "100%" }}>
                          <TextField
                            id="outlined-turnoluglio-currency"
                            label="Turno dal 1 Luglio al 31 Luglio"
                            defaultValue=""
                            placeholder="Seleziona"
                            value={selectedRequest.turnoLuglio.toUpperCase()}
                            xs={6}
                            sx={{
                              width: "63%",
                              textAlign: "left",
                              boxShadow: 5,
                              borderRadius: 1,
                              marginRight: "1%"
                            }}
                          >
                          </TextField>
                          { (selectedRequest.turnoLuglio.toUpperCase() === "SI") ? ( <TextField
                            id="outlined-lugliopriorita-currency"
                            
                            label="Priorita'"
                            defaultValue=""
                            placeholder="Seleziona"
                            value={selectedRequest.prioritaTurnoLuglio === "" ? "ALTRO" : selectedRequest.prioritaTurnoLuglio }
                            xs={6}
                            sx={{
                              width: "35%",
                              textAlign: "left",
                              boxShadow: 5,
                              borderRadius: 1,
                            }}
                          >
                          </TextField>) : (<></>) }
                          
                      </Grid> 
                      <Grid item xs={12} sx={{ width: "100%" }}>
                          <TextField
                            id="outlined-turnoagosto-currency"
                            label="Turno dal 1 Agosto al 31 Agosto"
                            defaultValue=""
                            placeholder="Seleziona"
                            value={selectedRequest.turnoAgosto.toUpperCase()}
                            xs={6}
                            sx={{
                              width: "63%",
                              textAlign: "left",
                              boxShadow: 5,
                              borderRadius: 1,
                              marginRight: "1%"
                            }}
                          >
                          </TextField>
                          { (selectedRequest.turnoAgosto.toUpperCase() === "SI") ? ( <TextField
                            id="outlined-agostopriorita-currency"
                            label="Priorita'"
                            defaultValue=""
                            placeholder="Seleziona"
                            value={selectedRequest.prioritaTurnoAgosto === "" ? "ALTRO" : selectedRequest.prioritaTurnoAgosto }
                            xs={6}
                            sx={{
                              width: "35%",
                              textAlign: "left",
                              boxShadow: 5,
                              borderRadius: 1,
                            }}
                          >
                          </TextField>) : (<></>) }
                          
                      </Grid> 
                      <Grid item xs={12} sx={{ width: "100%" }}>
                          <TextField
                            id="outlined-turnosettembre-currency"
                            label="Turno dal 1 Settembre al 15 Settembre"
                            defaultValue=""
                            placeholder="Seleziona"
                            value={selectedRequest.turnoSettembre.toUpperCase()}
                            xs={6}
                            sx={{
                              width: "63%",
                              textAlign: "left",
                              boxShadow: 5,
                              borderRadius: 1,
                              marginRight: "1%"
                            }}
                          >
                          </TextField>
                          { (selectedRequest.turnoSettembre.toUpperCase() === "SI") ? ( <TextField
                            id="outlined-agostopriorita-currency"
                            label="Priorita'"
                            defaultValue=""
                            placeholder="Seleziona"
                            value={selectedRequest.prioritaTurnoSettembre === "" ? "ALTRO" : selectedRequest.prioritaTurnoSettembre }
                            xs={6}
                            sx={{
                              width: "35%",
                              textAlign: "left",
                              boxShadow: 5,
                              borderRadius: 1,
                            }}
                          >
                          </TextField>) : (<></>) }
                          
                      </Grid> 
                </Grid>
              </CustomTabPanel>
              <CustomTabPanel value={valueTab} index={3}>
              <Grid
            container
            sx={{ width: "100%",  paddingTop: 2, paddingBottom:5 }}
            rowGap={3}
          >
                <TextField
                      id="outlined-figliminorenni-currency"
                      value={selectedRequest.figliFinoA12}
                      defaultValue="Figli minorenni"
                      label="Figli minorenni"
                      placeholder="Seleziona"
                      xs={6}
                      sx={{
                        width: "100%",
                        textAlign: "left",
                        boxShadow: 5,
                        borderRadius: 1,
                      }}
                    >
                </TextField>
              <Grid item xs={12} sx={{ width: "100%" }}>
              <TextField
                      id="outlined-numberofparents-currency"
                      
                      label="Numero richieste abbonamenti oltre il titolare"
                      defaultValue=""
                      placeholder="Seleziona"
                      value={selectedRequest.numeroAltriAbbonamenti}
                      xs={12}
                      sx={{
                        width: "100%",
                        textAlign: "left",
                        boxShadow: 5,
                        borderRadius: 1,
                      }}
                    >
                    </TextField>
              </Grid>
             
              { (parseInt(selectedRequest.numeroAltriAbbonamenti) >= 1) ? (
                <Grid item xs={12} sx={{ width: "100%" }}>
                      <TextField
                        id="outlined-gradodiparentelaEA1-currency"
                        
                        label="Grado di parentela"
                        value={selectedRequest.gradoParentelaEA1}
                        defaultValue=""
                        placeholder="Seleziona"
                        xs={4}
                        sx={{
                          width: "20%",
                          textAlign: "left",
                          boxShadow: 5,
                          borderRadius: 1,
                          marginRight: "1%"
                        }}
                      >
                      </TextField>
                      <TextField
                        
                        id="outlined-nomecognomeEA1-currency"
                        value={selectedRequest.nomeCognomeEA1}
                        label="Nome e Cognome"
                        placeholder=""
                        xs={4}
                        sx={{
                          width: "45%",
                          textAlign: "left",
                          boxShadow: 5,
                          borderRadius: 1,
                          marginRight: "1%"
                        }}
                  ></TextField>
                    <TextField
                        id="outlined-etaEA1-currency"
                        
                        label="Eta'"
                        defaultValue=""
                        placeholder="Seleziona"
                        value={(selectedRequest.etaEA1  === 0) ? ("Maggiore di 12 anni") : ("Fino a 12 anni compiuti") }
                        xs={4}
                        sx={{
                          width: "15%",
                          textAlign: "left",
                          boxShadow: 5,
                          borderRadius: 1,
                          marginRight: "1%"
                        }}
                      >
                      </TextField>
                      <TextField
                        required
                        id="outlined-noteEA1-currency"
                        value={selectedRequest.noteEA1}
                        label="Note turni"
                        placeholder=""
                        xs={4}
                        sx={{
                          width: "15%",
                          textAlign: "left",
                          boxShadow: 5,
                          borderRadius: 1,
                        }}
                  ></TextField>
                </Grid>
              ) : (<></>)}
              { (parseInt(selectedRequest.numeroAltriAbbonamenti) >= 2) ? (
               <Grid item xs={12} sx={{ width: "100%" }}>
               <TextField
                 id="outlined-gradodiparentelaEA2-currency"
                 
                 label="Grado di parentela"
                 value={selectedRequest.gradoParentelaEA2}
                 defaultValue=""
                 placeholder="Seleziona"
                 xs={4}
                 sx={{
                   width: "20%",
                   textAlign: "left",
                   boxShadow: 5,
                   borderRadius: 1,
                   marginRight: "1%"
                 }}
               >
                   
               </TextField>
               <TextField
                 
                 id="outlined-nomecognomeEA2-currency"
                 value={selectedRequest.nomeCognomeEA2}
                 label="Nome e Cognome"
                 placeholder=""
                 xs={4}
                 sx={{
                   width: "45%",
                   textAlign: "left",
                   boxShadow: 5,
                   borderRadius: 1,
                   marginRight: "1%"
                 }}
           ></TextField>
             <TextField
                 id="outlined-etaEA2-currency"
                 
                 label="Eta'"
                 defaultValue=""
                 placeholder="Seleziona"
              
                 value={(selectedRequest.etaEA2  === 0) ? ("Maggiore di 12 anni") : ("Fino a 12 anni compiuti") }
                 xs={4}
                 sx={{
                   width: "15%",
                   textAlign: "left",
                   boxShadow: 5,
                   borderRadius: 1,
                   marginRight: "1%"
                 }}
               >
               </TextField>
               <TextField
                 
                 id="outlined-noteEA2-currency"
                
                 value={selectedRequest.noteEA2}
                 label="Note turni"
                 placeholder=""
                 xs={4}
                 sx={{
                   width: "15%",
                   textAlign: "left",
                   boxShadow: 5,
                   borderRadius: 1,
                 }}
           ></TextField>
                </Grid>
              ) : (<></>)}
              { (parseInt(selectedRequest.numeroAltriAbbonamenti) >= 3) ? (
                <Grid item xs={12} sx={{ width: "100%" }}>
                <TextField
                  id="outlined-gradodiparentelaEA3-currency"
                  
                  label="Grado di parentela"
                 
                  value={selectedRequest.gradoParentelaEA3}
                  defaultValue=""
                  placeholder="Seleziona"
                  xs={4}
                  sx={{
                    width: "20%",
                    textAlign: "left",
                    boxShadow: 5,
                    borderRadius: 1,
                    marginRight: "1%"
                  }}
                >
                   
                </TextField>
                <TextField
                  
                  id="outlined-nomecognomeEA3-currency"
                 
                  value={selectedRequest.nomeCognomeEA3}
                  label="Nome e Cognome"
                  placeholder=""
                  xs={4}
                  sx={{
                    width: "45%",
                    textAlign: "left",
                    boxShadow: 5,
                    borderRadius: 1,
                    marginRight: "1%"
                  }}
            ></TextField>
              <TextField
                  id="outlined-etaEA3-currency"
                  
                  label="Eta'"
                  defaultValue=""
                  placeholder="Seleziona"
             
                  value={(selectedRequest.etaEA3  === 0) ? ("Maggiore di 12 anni") : ("Fino a 12 anni compiuti") }
                  xs={4}
                  sx={{
                    width: "15%",
                    textAlign: "left",
                    boxShadow: 5,
                    borderRadius: 1,
                    marginRight: "1%"
                  }}
                >
                </TextField>
                <TextField
                  
                  id="outlined-noteEA3-currency"
                  
                  value={selectedRequest.noteEA3}
                  label="Note turni"
                  placeholder=""
                  xs={4}
                  sx={{
                    width: "15%",
                    textAlign: "left",
                    boxShadow: 5,
                    borderRadius: 1,
                  }}
            ></TextField>
                 </Grid>
              ) : (<></>)}
               { (parseInt(selectedRequest.numeroAltriAbbonamenti) >= 4) ? (
                <Grid item xs={12} sx={{ width: "100%" }}>
               <TextField
                 id="outlined-gradodiparentelaEA4-currency"
                 
                 label="Grado di parentela"
               
                 value={selectedRequest.gradoParentelaEA4}
                 defaultValue=""
                 placeholder="Seleziona"
                 xs={4}
                 sx={{
                   width: "20%",
                   textAlign: "left",
                   boxShadow: 5,
                   borderRadius: 1,
                   marginRight: "1%"
                 }}
               >
                   
               </TextField>
               <TextField
                 
                 id="outlined-nomecognomeEA4-currency"
                
                 value={selectedRequest.nomeCognomeEA4}
                 label="Nome e Cognome"
                 placeholder=""
                 xs={4}
                 sx={{
                   width: "45%",
                   textAlign: "left",
                   boxShadow: 5,
                   borderRadius: 1,
                   marginRight: "1%"
                 }}
           ></TextField>
             <TextField
                 id="outlined-etaEA4-currency"
                 
                 label="Eta'"
                 defaultValue=""
                 placeholder="Seleziona"
               
                 value={(selectedRequest.etaEA4  === 0) ? ("Maggiore di 12 anni") : ("Fino a 12 anni compiuti") }
                 xs={4}
                 sx={{
                   width: "15%",
                   textAlign: "left",
                   boxShadow: 5,
                   borderRadius: 1,
                   marginRight: "1%"
                 }}
               >
               </TextField>
               <TextField
                 
                 id="outlined-noteEA4-currency"
               
                 value={selectedRequest.noteEA4}
                 label="Note turni"
                 placeholder=""
                 xs={4}
                 sx={{
                   width: "15%",
                   textAlign: "left",
                   boxShadow: 5,
                   borderRadius: 1,
                 }}
           ></TextField>
                </Grid>
              ) : (<></>)}
               { (parseInt(selectedRequest.numeroAltriAbbonamenti) >= 5) ? (
                  <Grid item xs={12} sx={{ width: "100%" }}>
                <TextField
                  id="outlined-gradodiparentelaEA5-currency"
                  
                  label="Grado di parentela"
                  value={selectedRequest.gradoParentelaEA5}
                  defaultValue=""
                  placeholder="Seleziona"
                  xs={4}
                  sx={{
                    width: "20%",
                    textAlign: "left",
                    boxShadow: 5,
                    borderRadius: 1,
                    marginRight: "1%"
                  }}
                >
                   
                </TextField>
                <TextField
                  
                  id="outlined-nomecognomeEA5-currency"
       
                  value={selectedRequest.nomeCognomeEA5}
                  label="Nome e Cognome"
                  placeholder=""
                  xs={4}
                  sx={{
                    width: "45%",
                    textAlign: "left",
                    boxShadow: 5,
                    borderRadius: 1,
                    marginRight: "1%"
                  }}
            ></TextField>
              <TextField
                  id="outlined-etaEA5-currency"
                  
                  label="Eta'"
                  defaultValue=""
                  placeholder="Seleziona"
             
                  value={(selectedRequest.etaEA5  === 0) ? ("Maggiore di 12 anni") : ("Fino a 12 anni compiuti") }
                  xs={4}
                  sx={{
                    width: "15%",
                    textAlign: "left",
                    boxShadow: 5,
                    borderRadius: 1,
                    marginRight: "1%"
                  }}
                >
                   
                </TextField>
                <TextField
                  
                  id="outlined-noteEA5-currency"
              
                  value={selectedRequest.noteEA5}
                  label="Note turni"
                  placeholder=""
                  xs={4}
                  sx={{
                    width: "15%",
                    textAlign: "left",
                    boxShadow: 5,
                    borderRadius: 1,
                  }}
            ></TextField>
                  </Grid>
              ) : (<></>)}
              { (parseInt(selectedRequest.numeroAltriAbbonamenti) >= 6) ? (
                  <Grid item xs={12} sx={{ width: "100%" }}>
                  <TextField
                    id="outlined-gradodiparentelaEA6-currency"
                    
                    label="Grado di parentela"
                 
                    value={selectedRequest.gradoParentelaEA6}
                    defaultValue=""
                    placeholder="Seleziona"
                    xs={4}
                    sx={{
                      width: "20%",
                      textAlign: "left",
                      boxShadow: 5,
                      borderRadius: 1,
                      marginRight: "1%"
                    }}
                  >
                      
                  </TextField>
                  <TextField
                    
                    id="outlined-nomecognomeEA6-currency"
              
                    value={selectedRequest.nomeCognomeEA6}
                    label="Nome e Cognome"
                    placeholder=""
                    xs={4}
                    sx={{
                      width: "45%",
                      textAlign: "left",
                      boxShadow: 5,
                      borderRadius: 1,
                      marginRight: "1%"
                    }}
              ></TextField>
                <TextField
                    id="outlined-etaEA6-currency"
                    
                    label="Eta'"
                    defaultValue=""
                    placeholder="Seleziona"
                   
                    value={(selectedRequest.etaEA6  === 0) ? ("Maggiore di 12 anni") : ("Fino a 12 anni compiuti") }
                    xs={4}
                    sx={{
                      width: "15%",
                      textAlign: "left",
                      boxShadow: 5,
                      borderRadius: 1,
                      marginRight: "1%"
                    }}
                  >
                
                  </TextField>
                  <TextField
                    
                    id="outlined-noteEA6-currency"
                  
                    value={selectedRequest.noteEA6}
                    label="Note turni"
                    placeholder=""
                    xs={4}
                    sx={{
                      width: "15%",
                      textAlign: "left",
                      boxShadow: 5,
                      borderRadius: 1,
                    }}
              ></TextField>
                  </Grid>
              ) : (<></>)}
               { (parseInt(selectedRequest.numeroAltriAbbonamenti) >= 7) ? (
                    <Grid item xs={12} sx={{ width: "100%" }}>
                  <TextField
                    id="outlined-gradodiparentelaEA7-currency"
                    
                    label="Grado di parentela"
                 
                    value={selectedRequest.gradoParentelaEA7}
                    defaultValue=""
                    placeholder="Seleziona"
                    xs={4}
                    sx={{
                      width: "20%",
                      textAlign: "left",
                      boxShadow: 5,
                      borderRadius: 1,
                      marginRight: "1%"
                    }}
                  >
                     
                  </TextField>
                  <TextField
                    
                    id="outlined-nomecognomeEA7-currency"
                   
                    value={selectedRequest.nomeCognomeEA7}
                    label="Nome e Cognome"
                    placeholder=""
                    xs={4}
                    sx={{
                      width: "45%",
                      textAlign: "left",
                      boxShadow: 5,
                      borderRadius: 1,
                      marginRight: "1%"
                    }}
              ></TextField>
                <TextField
                    id="outlined-etaEA7-currency"
                    
                    label="Eta'"
                    defaultValue=""
                    placeholder="Seleziona"
                  
                    value={(selectedRequest.etaEA7  === 0) ? ("Maggiore di 12 anni") : ("Fino a 12 anni compiuti") }
                    xs={4}
                    sx={{
                      width: "15%",
                      textAlign: "left",
                      boxShadow: 5,
                      borderRadius: 1,
                      marginRight: "1%"
                    }}
                  >
                      
                  </TextField>
                  <TextField
                    
                    id="outlined-noteEA7-currency"
                   
                    value={selectedRequest.noteEA7}
                    label="Note turni"
                    placeholder=""
                    xs={4}
                    sx={{
                      width: "15%",
                      textAlign: "left",
                      boxShadow: 5,
                      borderRadius: 1,
                    }}
              ></TextField>
                    </Grid>
              ) : (<></>)}
               { (parseInt(selectedRequest.numeroAltriAbbonamenti) >= 8) ? (
                  <Grid item xs={12} sx={{ width: "100%" }}>
                <TextField
                  id="outlined-gradodiparentelaEA8-currency"
                  
                  label="Grado di parentela"
                
                  value={selectedRequest.gradoParentelaEA8}
                  defaultValue=""
                  placeholder="Seleziona"
                  xs={4}
                  sx={{
                    width: "20%",
                    textAlign: "left",
                    boxShadow: 5,
                    borderRadius: 1,
                    marginRight: "1%"
                  }}
                >
                   
                </TextField>
                <TextField
                  
                  id="outlined-nomecognomeEA8-currency"
                
                  value={selectedRequest.nomeCognomeEA8}
                  label="Nome e Cognome"
                  placeholder=""
                  xs={4}
                  sx={{
                    width: "45%",
                    textAlign: "left",
                    boxShadow: 5,
                    borderRadius: 1,
                    marginRight: "1%"
                  }}
            ></TextField>
              <TextField
                  id="outlined-etaEA8-currency"
                  
                  label="Eta'"
                  defaultValue=""
                  placeholder="Seleziona"
                 
                  value={(selectedRequest.etaEA8  === 0) ? ("Maggiore di 12 anni") : ("Fino a 12 anni compiuti") }
                  xs={4}
                  sx={{
                    width: "15%",
                    textAlign: "left",
                    boxShadow: 5,
                    borderRadius: 1,
                    marginRight: "1%"
                  }}
                >
                  
                </TextField>
                <TextField
                  
                  id="outlined-noteEA8-currency"
                 
                  value={selectedRequest.noteEA8}
                  label="Note turni"
                  placeholder=""
                  xs={4}
                  sx={{
                    width: "15%",
                    textAlign: "left",
                    boxShadow: 5,
                    borderRadius: 1,
                  }}
            ></TextField>
                  </Grid>
              ) : (<></>)}
               { (parseInt(selectedRequest.numeroAltriAbbonamenti) >= 9) ? (
                 <Grid item xs={12} sx={{ width: "100%" }}>
                 <TextField
                   id="outlined-gradodiparentelaEA9-currency"
                   
                   label="Grado di parentela"
             
                   value={selectedRequest.gradoParentelaEA9}
                   defaultValue=""
                   placeholder="Seleziona"
                   xs={4}
                   sx={{
                     width: "20%",
                     textAlign: "left",
                     boxShadow: 5,
                     borderRadius: 1,
                     marginRight: "1%"
                   }}
                 >
                    
                 </TextField>
                 <TextField
                   
                   id="outlined-nomecognomeEA9-currency"
                 
                   value={selectedRequest.nomeCognomeEA9}
                   label="Nome e Cognome"
                   placeholder=""
                   xs={4}
                   sx={{
                     width: "45%",
                     textAlign: "left",
                     boxShadow: 5,
                     borderRadius: 1,
                     marginRight: "1%"
                   }}
             ></TextField>
               <TextField
                   id="outlined-etaEA9-currency"
                   
                   label="Eta'"
                   defaultValue=""
                   placeholder="Seleziona"
                
                   value={(selectedRequest.etaEA9  === 0) ? ("Maggiore di 12 anni") : ("Fino a 12 anni compiuti") }
                   xs={4}
                   sx={{
                     width: "15%",
                     textAlign: "left",
                     boxShadow: 5,
                     borderRadius: 1,
                     marginRight: "1%"
                   }}
                 >
                    
                 </TextField>
                 <TextField
                        
                        id="outlined-noteEA9-currency"
                    
                        value={selectedRequest.noteEA9}
                        label="Note turni"
                        placeholder=""
                        xs={4}
                        sx={{
                          width: "15%",
                          textAlign: "left",
                          boxShadow: 5,
                          borderRadius: 1,
                        }}
                  ></TextField>
                   </Grid>
              ) : (<></>)}
               { (parseInt(selectedRequest.numeroAltriAbbonamenti) >= 10) ? (
                 <Grid item xs={12} sx={{ width: "100%" }}>
                 <TextField
                   id="outlined-gradodiparentelaEA10-currency"
                   
                   label="Grado di parentela"
                   value={selectedRequest.gradoParentelaEA10}
                   defaultValue=""
                   placeholder="Seleziona"
                   xs={4}
                   sx={{
                     width: "20%",
                     textAlign: "left",
                     boxShadow: 5,
                     borderRadius: 1,
                     marginRight: "1%"
                   }}
                 >
                   
                 </TextField>
                 <TextField
                   
                   id="outlined-nomecognomeEA10-currency"
              
                   value={selectedRequest.nomeCognomeEA10}
                   label="Nome e Cognome"
                   placeholder=""
                   xs={4}
                   sx={{
                     width: "45%",
                     textAlign: "left",
                     boxShadow: 5,
                     borderRadius: 1,
                     marginRight: "1%"
                   }}
             ></TextField>
               <TextField
                   id="outlined-etaEA10-currency"
                   
                   label="Eta'"
                   defaultValue=""
                   placeholder="Seleziona"
                   
                   value={(selectedRequest.etaEA10  === 0) ? ("Maggiore di 12 anni") : ("Fino a 12 anni compiuti") }
                   xs={4}
                   sx={{
                     width: "15%",
                     textAlign: "left",
                     boxShadow: 5,
                     borderRadius: 1,
                     marginRight: "1%"
                   }}
                 >
                    
                 </TextField>
                 <TextField
                        
                        id="outlined-noteEA10-currency"
                        
                        value={selectedRequest.noteEA10}
                        label="Note turni"
                        placeholder=""
                        xs={4}
                        sx={{
                          width: "15%",
                          textAlign: "left",
                          boxShadow: 5,
                          borderRadius: 1,
                        }}
                  ></TextField>
                   </Grid>
              ) : (<></>)}
          </Grid>
              </CustomTabPanel>
              <CustomTabPanel value={valueTab} index={4}>
                
              <Card variant="outlined" sx={{ width: "100%", marginBottom:5 }}>
                    <Box sx={{ p: 2 }}>
                      <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Typography gutterBottom variant="h6" component="div">
                          STATO RICHIESTA E COMUNICAZIONI
                        </Typography>
                       
                        <Typography gutterBottom variant="h6" component="div">
                        <Button sx={{border:1, marginRight:2}} onClick={updateRichiesta}>SALVA</Button>
                        </Typography>
                      </Stack>
                    </Box>
                    <Divider />
                    <Box sx={{ p: 2 }}>
                      <Typography gutterBottom variant="body2">
                        
                      </Typography>
                      <Stack direction="row" spacing={2}> 
                      <TextField
                        id="outlined-statorichiesta-currency"
                        select
                        label="Stato Richiesta"
                        onChange={handleStatoRichiestaSelectedChange}
                        onBlur={handleStatoRichiestaSelectedChange}
                        error={selectedStatoRichiestaError}
                        value={selectedStatoRichiesta}
                        defaultValue=""
                        placeholder="Seleziona"
                        xs={4}
                        sx={{
                          width: "30%",
                          textAlign: "left",
                          borderRadius: 1,
                        
                        }}
                      >
                          {statoRichiesta.map((option) => (
                          <MenuItem key={option.value} value={option.value} style={{whiteSpace: 'normal'}}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </TextField>
                        <Button sx={{border:1, marginRight:2}} onClick={inviaEmailApprovazione}>INVIA EMAIL APPROVAZIONE (SOLO AA)</Button>
                       {/*  <Button sx={{border:1, marginRight:2}} onClick={inviaEmailApprovazioneSoloGiugno}>INIVA EMAIL APPROVAZIONE SOLO GIUGNO</Button> */}
                        <Button sx={{border:1, marginRight:2}} onClick={inviaEmailDocumentazione}>INVIA EMAIL RICHIESTA DOCUMENTAZIONE (SOLO AA)</Button>
                     
                         </Stack>

                        <Stack direction="row" spacing={2} sx={{marginTop:2}}> 
                            <Button sx={{border:1, marginRight:2}} onClick={inviaEmailDocumentazionePreliminare}>INVIA EMAIL RICHIESTA DOC (ALTRE CAT)</Button>
                            <Button sx={{border:1, marginRight:2}} onClick={inviaEmailApprovazioneDefinitiva}>INVIA EMAIL APPROVAZIONE (ALTRE CAT)</Button>
                            <Button sx={{border:1, marginRight:2}} onClick={inviaEmailDatiAccessoCaricaDocumenti}>INVIA EMAIL RICHIESTA RICEVUTA PAGAMENTO (ALTRE CAT)</Button>
                          </Stack>

                          <Stack direction="row" spacing={2} sx={{marginTop:2}}> 
                            <Button sx={{border:1, marginRight:2}} onClick={inviaEmailRespinta}>INVIA EMAIL RICHIESTA RESPINTA (NO REQUISITI)</Button>
                            <Button sx={{border:1, marginRight:2}} onClick={inviaEmailRespinta2}>INVIA EMAIL RICHIESTA RESPINTA (INDISPONIBILITA)</Button>
                            <Button sx={{border:1, marginRight:2}} onClick={inviaEmailRitirata}>INVIA EMAIL RICHIESTA RITIRO</Button>
                          </Stack>
                    </Box>
                  </Card>

                  <Card variant="outlined" sx={{ width: "100%", marginBottom:5 }}>
                    <Box sx={{ p: 2 }}>
                      <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Typography gutterBottom variant="h6" component="div">
                          TURNI TITOLARE
                        </Typography>
                        <Typography gutterBottom variant="h6" component="div">
                         
                        </Typography>
                      </Stack>
                     
                    </Box>
                    <Divider />
                    <Box sx={{ p: 2 }}>
                      <Typography gutterBottom variant="body2">
                        
                      </Typography>
                      <Stack direction="row" spacing={1}>
                        <Grid  container
                              sx={{ width: "100%",  paddingTop: 2, paddingBottom:5 }}
                              rowGap={3}
                            >
                               <Grid item xs={12} sx={{ width: "100%" }}>
                                  <TextField
                                        label="Turno dal 15 Giugno al 30 Giugno"
                                        defaultValue=""
                                        placeholder="Seleziona"
                                        value={selectedRequest.turnoGiugno}
                                        xs={6}
                                        sx={{
                                          width: "30%",
                                          textAlign: "left",
                                          borderRadius: 1,
                                          marginRight: "1%"
                                        }}
                                      >
                                      </TextField>
                                      <TextField
                                        label="Priorita'"
                                          defaultValue=""
                                          placeholder="Seleziona"
                                          value={selectedRequest.prioritaTurnoGiugno !== "" ? (selectedRequest.prioritaTurnoGiugno) : "--"}
                                          xs={6}
                                          sx={{
                                            width: "10%",
                                            textAlign: "left",
                                            marginRight: "1%",
                                            borderRadius: 1,
                                          }}
                                        >
                                    </TextField>
                                    {
                                      (selectedRequest.turnoGiugno === "SI" && selectedRequest.stato !== "respinta") ? (  <><TextField
                                        select
                                        label="Approva Giugno"
                                        defaultValue=""
                                        placeholder="Seleziona"
                                        onChange={handleApprovaGiugnoSelectedChange}
                                        onBlur={handleApprovaGiugnoSelectedChange}
                                        error={selectedApprovaGiugnoError}
                                        value={selectedApprovaGiugno}
                                        xs={6}
                                        sx={{
                                          width: "25%",
                                          textAlign: "left",
                                          borderRadius: 1,
                                          marginRight: "1%"
                                        }}
                                      >
                                          <MenuItem key={1} value={"SI"} style={{whiteSpace: 'normal'}}>
                                            SI
                                          </MenuItem>
                                          <MenuItem key={2} value={"NO"} style={{whiteSpace: 'normal'}}>
                                            NO
                                          </MenuItem>
                                    </TextField>
                                    <TextField
                                    label="Costo"
                                    defaultValue=""
                                    placeholder="Seleziona"
                                    value={categoria.find(o => o.value === selectedRequest.categoriaDiAppartenenza.toUpperCase()).halfMonth.toUpperCase()}
                                    xs={6}
                                    sx={{
                                      width: "5%",
                                      textAlign: "left",
                                      borderRadius: 1,
                                      marginRight: "1%"
                                    }}
                                  >
                                </TextField>
                                </>) : (
                                      <></>
                                    )
                                    }
                                  
                               </Grid>
                               <Grid item xs={12} sx={{ width: "100%" }}>
                                  <TextField
                                        label="Turno dal 1 Luglio al 31 Luglio"
                                        defaultValue=""
                                        placeholder="Seleziona"
                                        value={selectedRequest.turnoLuglio}
                                        xs={6}
                                        sx={{
                                          width: "30%",
                                          textAlign: "left",
                                          borderRadius: 1,
                                          marginRight: "1%"
                                        }}
                                      >
                                      </TextField>
                                        <TextField
                                      label="Priorita'"
                                        defaultValue=""
                                        placeholder="Seleziona"
                                        value={selectedRequest.prioritaTurnoLuglio !== "" ? (selectedRequest.prioritaTurnoLuglio) : "--"}
                                        xs={6}
                                        sx={{
                                          width: "10%",
                                          textAlign: "left",
                                          borderRadius: 1,
                                          marginRight: "1%",
                                        }}
                                      >
                                  </TextField>
                                  {
                                      (selectedRequest.turnoLuglio === "SI" && selectedRequest.stato !== "respinta") ? (   <><TextField
                                        select
                                        label="Approva Luglio"
                                        defaultValue=""
                                        placeholder="Seleziona"
                                        onChange={handleApprovaLuglioSelectedChange}
                                        onBlur={handleApprovaLuglioSelectedChange}
                                        error={selectedApprovaLuglioError}
                                        value={selectedApprovaLuglio}
                                        xs={6}
                                        sx={{
                                          width: "25%",
                                          textAlign: "left",
                                          borderRadius: 1,
                                          marginRight: "1%"
                                        }}
                                      >
                                          <MenuItem key={1} value={"SI"} style={{whiteSpace: 'normal'}}>
                                            SI
                                          </MenuItem>
                                          <MenuItem key={2} value={"NO"} style={{whiteSpace: 'normal'}}>
                                            NO
                                          </MenuItem>
                                    </TextField>
                                     <TextField
                                     label="Costo"
                                     defaultValue=""
                                     placeholder="Seleziona"
                                     value={categoria.find(o => o.value === selectedRequest.categoriaDiAppartenenza.toUpperCase()).fullMonth.toUpperCase()}
                                     xs={6}
                                     sx={{
                                       width: "5%",
                                       textAlign: "left",
                                       borderRadius: 1,
                                       marginRight: "1%"
                                     }}
                                   >
                                 </TextField>
                                 </>) : (
                                      <></>
                                    )
                                    }
                                 
                               </Grid>
                               <Grid item xs={12} sx={{ width: "100%" }}>
                                  <TextField
                                        label="Turno dal 1 Agosto al 31 Agosto"
                                        defaultValue=""
                                        placeholder="Seleziona"
                                        value={selectedRequest.turnoAgosto}
                                        xs={6}
                                        sx={{
                                          width: "30%",
                                          textAlign: "left",
                                          borderRadius: 1,
                                          marginRight: "1%"
                                        }}
                                      >
                                      </TextField>
                                        <TextField
                                      label="Priorita'"
                                        defaultValue=""
                                        placeholder="Seleziona"
                                        value={selectedRequest.prioritaTurnoAgosto !== "" ? (selectedRequest.prioritaTurnoAgosto) : "--"}
                                        xs={6}
                                        sx={{
                                          width: "10%",
                                          textAlign: "left",
                                          borderRadius: 1,
                                          marginRight: "1%",
                                        }}
                                      >
                                  </TextField>
                                  {
                                      (selectedRequest.turnoAgosto === "SI" && selectedRequest.stato !== "respinta") ? (  <><TextField
                                        select
                                        label="Approva Agosto"
                                        defaultValue=""
                                        placeholder="Seleziona"
                                        onChange={handleApprovaAgostoSelectedChange}
                                        onBlur={handleApprovaAgostoSelectedChange}
                                        error={selectedApprovaAgostoError}
                                        value={selectedApprovaAgosto}
                                        xs={6}
                                        sx={{
                                          width: "25%",
                                          textAlign: "left",
                                          borderRadius: 1,
                                          marginRight: "1%"
                                        }}
                                      >
                                          <MenuItem key={1} value={"SI"} style={{whiteSpace: 'normal'}}>
                                            SI
                                          </MenuItem>
                                          <MenuItem key={2} value={"NO"} style={{whiteSpace: 'normal'}}>
                                            NO
                                          </MenuItem>
                                    </TextField>
                                     <TextField
                                     label="Costo"
                                     defaultValue=""
                                     placeholder="Seleziona"
                                     value={categoria.find(o => o.value === selectedRequest.categoriaDiAppartenenza.toUpperCase()).fullMonth.toUpperCase()}
                                     xs={6}
                                     sx={{
                                       width: "5%",
                                       textAlign: "left",
                                       borderRadius: 1,
                                       marginRight: "1%"
                                     }}
                                   >
                                 </TextField>
                                 </>) : (
                                      <></>
                                    )
                                    }
                                  
                                  
                               </Grid>
                               <Grid item xs={12} sx={{ width: "100%" }}>
                                  <TextField
                                        label="Turno dal 1 Settembre al 15 Settembre"
                                        defaultValue=""
                                        placeholder="Seleziona"
                                        value={selectedRequest.turnoSettembre}
                                        xs={6}
                                        sx={{
                                          width: "30%",
                                          textAlign: "left",
                                          borderRadius: 1,
                                          marginRight: "1%"
                                        }}
                                      >
                                      </TextField>
                                        <TextField
                                      label="Priorita'"
                                        defaultValue=""
                                        placeholder="Seleziona"
                                        value={selectedRequest.prioritaTurnoSettembre !== "" ? (selectedRequest.prioritaTurnoSettembre) : "--"}
                                        xs={6}
                                        sx={{
                                          width: "10%",
                                          textAlign: "left",
                                          borderRadius: 1,
                                          marginRight: "1%",
                                        }}
                                      >
                                  </TextField>
                                  {
                                      (selectedRequest.turnoSettembre === "SI" && selectedRequest.stato !== "respinta") ? ( <><TextField
                                        select
                                        label="Approva Settembre"
                                        defaultValue=""
                                        placeholder="Seleziona"
                                        onChange={handleApprovaSettembreSelectedChange}
                                        onBlur={handleApprovaSettembreSelectedChange}
                                        error={selectedApprovaSettembreError}
                                        value={selectedApprovaSettembre}
                                        xs={6}
                                        sx={{
                                          width: "25%",
                                          textAlign: "left",
                                          borderRadius: 1,
                                          marginRight: "1%"
                                        }}
                                      >
                                          <MenuItem key={1} value={"SI"} style={{whiteSpace: 'normal'}}>
                                            SI
                                          </MenuItem>
                                          <MenuItem key={2} value={"NO"} style={{whiteSpace: 'normal'}}>
                                            NO
                                          </MenuItem>
                                    </TextField>
                                     <TextField
                                     label="Costo"
                                     defaultValue=""
                                     placeholder="Seleziona"
                                     value={categoria.find(o => o.value === selectedRequest.categoriaDiAppartenenza.toUpperCase()).halfMonth.toUpperCase()}
                                     xs={6}
                                     sx={{
                                       width: "5%",
                                       textAlign: "left",
                                       borderRadius: 1,
                                       marginRight: "1%"
                                     }}
                                   >
                                 </TextField>
                                 </>) : (
                                      <></>
                                    )
                                    }
                                  
                               </Grid>

                        </Grid>
                      </Stack>
                    </Box>
                  </Card>

                  <Card variant="outlined" sx={{ width: "100%", marginBottom:5 }}>
                    <Box sx={{ p: 2 }}>
                      <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Typography gutterBottom variant="h6" component="div">
                          TURNI FAMILIARI E/O CONVIVENTI
                        </Typography>
                        <Typography gutterBottom variant="h6" component="div">
                         
                        </Typography>
                      </Stack>
                     
                    </Box>
                    <Divider />
                    <Box sx={{ p: 2 }}>
                      <Typography gutterBottom variant="body2">
                        
                      </Typography>
                      <Stack direction="row" spacing={1}>
                        <Grid  container
                              sx={{ width: "100%",  paddingTop: 2, paddingBottom:5 }}
                              rowGap={3}
                            >
                              { (parseInt(selectedRequest.numeroAltriAbbonamenti) === 0) ? (
                               <Grid item xs={12} sx={{ width: "100%" }}>
                                 <Typography gutterBottom variant="body2">
                                  Il titolare non ha rchiesto altri abbonamenti oltre il proprio.
                                  </Typography>
                                </Grid>
                                ) : (<></>) }
                                { (parseInt(selectedRequest.numeroAltriAbbonamenti) >= 1) ? (
                               <Grid item xs={12} sx={{ width: "100%" }}>
                               <TextField
                                     label="1) Dati Familiare e/o Convivente"
                                     defaultValue=""
                                     placeholder="Seleziona"
                                     value={ selectedRequest.gradoParentelaEA1 + " | " + selectedRequest.nomeCognomeEA1.toUpperCase() + " " + ((selectedRequest.etaEA1  === 0) ? (" (Maggiore di 12 anni) ") : (" (Fino a 12 anni compiuti) ")) + " | Note: " + selectedRequest.noteEA1.toUpperCase() }
                                     xs={6}
                                     sx={{
                                       width: "60%",
                                       textAlign: "left",
                                       borderRadius: 1,
                                       marginRight: "1%"
                                     }}
                                   >
                                   </TextField>
                                 <TextField
                                     select
                                     label="Giugno"
                                     defaultValue=""
                                     placeholder="Seleziona"
                                     value={selectedApprovaGiugnoEA1}
                                     onChange={handleApprovaGiugnoEA1SelectedChange}
                                     
                                     xs={6}
                                     sx={{
                                       width: "5%",
                                       textAlign: "left",
                                       borderRadius: 1,
                                       marginRight: "1%"
                                     }}
                                   >
                                       <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                         SI
                                       </MenuItem>
                                       <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                         NO
                                       </MenuItem>
                                 </TextField>
                                 <TextField
                                     select
                                     label="Luglio"
                                     defaultValue=""
                                     placeholder="Seleziona"
                                     onChange={handleApprovaLuglioEA1SelectedChange}
                                     onBlur={handleApprovaLuglioEA1SelectedChange}
                                     error={selectedApprovaLuglioEA1Error}
                                     value={selectedApprovaLuglioEA1}
                                     xs={6}
                                     sx={{
                                       width: "5%",
                                       textAlign: "left",
                                       borderRadius: 1,
                                       marginRight: "1%"
                                     }}
                                   >
                                       <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                         SI
                                       </MenuItem>
                                       <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                         NO
                                       </MenuItem>
                                 </TextField>
                                 <TextField
                                     select
                                     label="Agosto"
                                     defaultValue=""
                                     placeholder="Seleziona"
                                     onChange={handleApprovaAgostoEA1SelectedChange}
                                     onBlur={handleApprovaAgostoEA1SelectedChange}
                                     error={selectedApprovaAgostoEA1Error}
                                     value={selectedApprovaAgostoEA1}
                                     xs={6}
                                     sx={{
                                       width: "5%",
                                       textAlign: "left",
                                       borderRadius: 1,
                                       marginRight: "1%"
                                     }}
                                   >
                                       <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                         SI
                                       </MenuItem>
                                       <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                         NO
                                       </MenuItem>
                                 </TextField>
                                 <TextField
                                     select
                                     label="Settembre"
                                     defaultValue=""
                                     placeholder="Seleziona"
                                     onChange={handleApprovaSettembreEA1SelectedChange}
                                     onBlur={handleApprovaSettembreEA1SelectedChange}
                                     error={selectedApprovaSettembreEA1Error}
                                     value={selectedApprovaSettembreEA1}
                                     xs={6}
                                     sx={{
                                       width: "5%",
                                       textAlign: "left",
                                       borderRadius: 1,
                                       marginRight: "1%"
                                     }}
                                   >
                                       <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                         SI
                                       </MenuItem>
                                       <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                         NO
                                       </MenuItem>
                                 </TextField>
                                 <TextField
                                    label="Costo totale"
                                    defaultValue=""
                                    placeholder="Seleziona"
                                    value={costoTotaleEA1}
                                    xs={6}
                                    sx={{
                                      width: "8%",
                                      textAlign: "left",
                                      borderRadius: 1,
                                      marginRight: "1%"
                                    }}
                                  >
                                </TextField>
                                </Grid>
                                ) : (<></>) }
                                { (parseInt(selectedRequest.numeroAltriAbbonamenti) >= 2) ? (
                                  <Grid item xs={12} sx={{ width: "100%" }}>
                                  <TextField
                                        label="2) Dati Familiare e/o Convivente"
                                        defaultValue=""
                                        placeholder="Seleziona"
                                        value={ selectedRequest.gradoParentelaEA2 + " | " + selectedRequest.nomeCognomeEA2.toUpperCase() + " " + ((selectedRequest.etaEA2  === 0) ? (" (Maggiore di 12 anni) ") : (" (Fino a 12 anni compiuti) ")) + " | Note: " + selectedRequest.noteEA2.toUpperCase() }
                                        xs={6}
                                        sx={{
                                          width: "60%",
                                          textAlign: "left",
                                          borderRadius: 1,
                                          marginRight: "1%"
                                        }}
                                      >
                                      </TextField>
                                    <TextField
                                        select
                                        label="Giugno"
                                        defaultValue=""
                                        placeholder="Seleziona"
                                        onChange={handleApprovaGiugnoEA2SelectedChange}
                                        onBlur={handleApprovaGiugnoEA2SelectedChange}
                                        error={selectedApprovaGiugnoEA2Error}
                                        value={selectedApprovaGiugnoEA2}
                                        xs={6}
                                        sx={{
                                          width: "5%",
                                          textAlign: "left",
                                          borderRadius: 1,
                                          marginRight: "1%"
                                        }}
                                      >
                                          <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                            SI
                                          </MenuItem>
                                          <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                            NO
                                          </MenuItem>
                                    </TextField>
                                    <TextField
                                        select
                                        label="Luglio"
                                        defaultValue=""
                                        placeholder="Seleziona"
                                        onChange={handleApprovaLuglioEA2SelectedChange}
                                        onBlur={handleApprovaLuglioEA2SelectedChange}
                                        error={selectedApprovaLuglioEA2Error}
                                        value={selectedApprovaLuglioEA2}
                                        xs={6}
                                        sx={{
                                          width: "5%",
                                          textAlign: "left",
                                          borderRadius: 1,
                                          marginRight: "1%"
                                        }}
                                      >
                                          <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                            SI
                                          </MenuItem>
                                          <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                            NO
                                          </MenuItem>
                                    </TextField>
                                    <TextField
                                        select
                                        label="Agosto"
                                        defaultValue=""
                                        placeholder="Seleziona"
                                        onChange={handleApprovaAgostoEA2SelectedChange}
                                        onBlur={handleApprovaAgostoEA2SelectedChange}
                                        error={selectedApprovaAgostoEA2Error}
                                        value={selectedApprovaAgostoEA2}
                                        xs={6}
                                        sx={{
                                          width: "5%",
                                          textAlign: "left",
                                          borderRadius: 1,
                                          marginRight: "1%"
                                        }}
                                      >
                                          <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                            SI
                                          </MenuItem>
                                          <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                            NO
                                          </MenuItem>
                                    </TextField>
                                    <TextField
                                        select
                                        label="Settembre"
                                        defaultValue=""
                                        placeholder="Seleziona"
                                        onChange={handleApprovaSettembreEA2SelectedChange}
                                        onBlur={handleApprovaSettembreEA2SelectedChange}
                                        error={selectedApprovaSettembreEA2Error}
                                        value={selectedApprovaSettembreEA2}
                                        xs={6}
                                        sx={{
                                          width: "5%",
                                          textAlign: "left",
                                          borderRadius: 1,
                                          marginRight: "1%"
                                        }}
                                      >
                                          <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                            SI
                                          </MenuItem>
                                          <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                            NO
                                          </MenuItem>
                                    </TextField>
                                    <TextField
                                    label="Costo totale"
                                    defaultValue=""
                                    placeholder="Seleziona"
                                    value={costoTotaleEA2}
                                    xs={6}
                                    sx={{
                                      width: "8%",
                                      textAlign: "left",
                                      borderRadius: 1,
                                      marginRight: "1%"
                                    }}
                                  >
                                </TextField>
                               </Grid>
                                ) : (<></>) }
                                  { (parseInt(selectedRequest.numeroAltriAbbonamenti) >= 3) ? (
                                  <Grid item xs={12} sx={{ width: "100%" }}>
                                  <TextField
                                        label="3) Dati Familiare e/o Convivente"
                                        defaultValue=""
                                        placeholder="Seleziona"
                                        value={ selectedRequest.gradoParentelaEA3 + " | " + selectedRequest.nomeCognomeEA3.toUpperCase() + " " + ((selectedRequest.etaEA3  === 0) ? (" (Maggiore di 12 anni) ") : (" (Fino a 12 anni compiuti) ")) + " | Note: " + selectedRequest.noteEA3.toUpperCase() }
                                        xs={6}
                                        sx={{
                                          width: "60%",
                                          textAlign: "left",
                                          borderRadius: 1,
                                          marginRight: "1%"
                                        }}
                                      >
                                      </TextField>
                                    <TextField
                                        select
                                        label="Giugno"
                                        defaultValue=""
                                        placeholder="Seleziona"
                                        onChange={handleApprovaGiugnoEA3SelectedChange}
                                        onBlur={handleApprovaGiugnoEA3SelectedChange}
                                        error={selectedApprovaGiugnoEA3Error}
                                        value={selectedApprovaGiugnoEA3}
                                        xs={6}
                                        sx={{
                                          width: "5%",
                                          textAlign: "left",
                                          borderRadius: 1,
                                          marginRight: "1%"
                                        }}
                                      >
                                          <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                            SI
                                          </MenuItem>
                                          <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                            NO
                                          </MenuItem>
                                    </TextField>
                                    <TextField
                                        select
                                        label="Luglio"
                                        defaultValue=""
                                        placeholder="Seleziona"
                                        onChange={handleApprovaLuglioEA3SelectedChange}
                                        onBlur={handleApprovaLuglioEA3SelectedChange}
                                        error={selectedApprovaLuglioEA3Error}
                                        value={selectedApprovaLuglioEA3}
                                        xs={6}
                                        sx={{
                                          width: "5%",
                                          textAlign: "left",
                                          borderRadius: 1,
                                          marginRight: "1%"
                                        }}
                                      >
                                          <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                            SI
                                          </MenuItem>
                                          <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                            NO
                                          </MenuItem>
                                    </TextField>
                                    <TextField
                                        select
                                        label="Agosto"
                                        defaultValue=""
                                        placeholder="Seleziona"
                                        onChange={handleApprovaAgostoEA3SelectedChange}
                                        onBlur={handleApprovaAgostoEA3SelectedChange}
                                        error={selectedApprovaAgostoEA3Error}
                                        value={selectedApprovaAgostoEA3}
                                        xs={6}
                                        sx={{
                                          width: "5%",
                                          textAlign: "left",
                                          borderRadius: 1,
                                          marginRight: "1%"
                                        }}
                                      >
                                          <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                            SI
                                          </MenuItem>
                                          <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                            NO
                                          </MenuItem>
                                    </TextField>
                                    <TextField
                                        select
                                        label="Settembre"
                                        defaultValue=""
                                        placeholder="Seleziona"
                                        onChange={handleApprovaSettembreEA3SelectedChange}
                                        onBlur={handleApprovaSettembreEA3SelectedChange}
                                        error={selectedApprovaSettembreEA3Error}
                                        value={selectedApprovaSettembreEA3}
                                        xs={6}
                                        sx={{
                                          width: "5%",
                                          textAlign: "left",
                                          borderRadius: 1,
                                          marginRight: "1%"
                                        }}
                                      >
                                          <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                            SI
                                          </MenuItem>
                                          <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                            NO
                                          </MenuItem>
                                    </TextField>
                                    <TextField
                                    label="Costo totale"
                                    defaultValue=""
                                    placeholder="Seleziona"
                                    value={costoTotaleEA3}
                                    xs={6}
                                    sx={{
                                      width: "8%",
                                      textAlign: "left",
                                      borderRadius: 1,
                                      marginRight: "1%"
                                    }}
                                  >
                                </TextField>
                               </Grid>
                                ) : (<></>) }
                                { (parseInt(selectedRequest.numeroAltriAbbonamenti) >= 4) ? (
                                <Grid item xs={12} sx={{ width: "100%" }}>
                                <TextField
                                      label="4) Dati Familiare e/o Convivente"
                                      defaultValue=""
                                      placeholder="Seleziona"
                                      value={ selectedRequest.gradoParentelaEA4 + " | " + selectedRequest.nomeCognomeEA4.toUpperCase() + " " + ((selectedRequest.etaEA4  === 0) ? (" (Maggiore di 12 anni) ") : (" (Fino a 12 anni compiuti) ")) + " | Note: " + selectedRequest.noteEA4.toUpperCase() }
                                      xs={6}
                                      sx={{
                                        width: "60%",
                                        textAlign: "left",
                                        borderRadius: 1,
                                        marginRight: "1%"
                                      }}
                                    >
                                    </TextField>
                                  <TextField
                                      select
                                      label="Giugno"
                                      defaultValue=""
                                      placeholder="Seleziona"
                                      onChange={handleApprovaGiugnoEA4SelectedChange}
                                      onBlur={handleApprovaGiugnoEA4SelectedChange}
                                      error={selectedApprovaGiugnoEA4Error}
                                      value={selectedApprovaGiugnoEA4}
                                      xs={6}
                                      sx={{
                                        width: "5%",
                                        textAlign: "left",
                                        borderRadius: 1,
                                        marginRight: "1%"
                                      }}
                                    >
                                        <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                          SI
                                        </MenuItem>
                                        <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                          NO
                                        </MenuItem>
                                  </TextField>
                                  <TextField
                                      select
                                      label="Luglio"
                                      defaultValue=""
                                      placeholder="Seleziona"
                                      onChange={handleApprovaLuglioEA4SelectedChange}
                                      onBlur={handleApprovaLuglioEA4SelectedChange}
                                      error={selectedApprovaLuglioEA4Error}
                                      value={selectedApprovaLuglioEA4}
                                      xs={6}
                                      sx={{
                                        width: "5%",
                                        textAlign: "left",
                                        borderRadius: 1,
                                        marginRight: "1%"
                                      }}
                                    >
                                        <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                          SI
                                        </MenuItem>
                                        <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                          NO
                                        </MenuItem>
                                  </TextField>
                                  <TextField
                                      select
                                      label="Agosto"
                                      defaultValue=""
                                      placeholder="Seleziona"
                                      onChange={handleApprovaAgostoEA4SelectedChange}
                                      onBlur={handleApprovaAgostoEA4SelectedChange}
                                      error={selectedApprovaAgostoEA4Error}
                                      value={selectedApprovaAgostoEA4}
                                      xs={6}
                                      sx={{
                                        width: "5%",
                                        textAlign: "left",
                                        borderRadius: 1,
                                        marginRight: "1%"
                                      }}
                                    >
                                        <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                          SI
                                        </MenuItem>
                                        <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                          NO
                                        </MenuItem>
                                  </TextField>
                                  <TextField
                                      select
                                      label="Settembre"
                                      defaultValue=""
                                      placeholder="Seleziona"
                                      onChange={handleApprovaSettembreEA4SelectedChange}
                                      onBlur={handleApprovaSettembreEA4SelectedChange}
                                      error={selectedApprovaSettembreEA4Error}
                                      value={selectedApprovaSettembreEA4}
                                      xs={6}
                                      sx={{
                                        width: "5%",
                                        textAlign: "left",
                                        borderRadius: 1,
                                        marginRight: "1%"
                                      }}
                                    >
                                        <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                          SI
                                        </MenuItem>
                                        <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                          NO
                                        </MenuItem>
                                  </TextField>
                                  <TextField
                                    label="Costo totale"
                                    defaultValue=""
                                    placeholder="Seleziona"
                                    value={costoTotaleEA4}
                                    xs={6}
                                    sx={{
                                      width: "8%",
                                      textAlign: "left",
                                      borderRadius: 1,
                                      marginRight: "1%"
                                    }}
                                  >
                                </TextField>
                                  </Grid>
                                ) : (<></>) }
                                { (parseInt(selectedRequest.numeroAltriAbbonamenti) >= 5) ? (
                                  <Grid item xs={12} sx={{ width: "100%" }}>
                                  <TextField
                                        label="5) Dati Familiare e/o Convivente"
                                        defaultValue=""
                                        placeholder="Seleziona"
                                        value={ selectedRequest.gradoParentelaEA5 + " | " + selectedRequest.nomeCognomeEA5.toUpperCase() + " " + ((selectedRequest.etaEA5  === 0) ? (" (Maggiore di 12 anni) ") : (" (Fino a 12 anni compiuti) ")) + " | Note: " + selectedRequest.noteEA5.toUpperCase() }
                                        xs={6}
                                        sx={{
                                          width: "60%",
                                          textAlign: "left",
                                          borderRadius: 1,
                                          marginRight: "1%"
                                        }}
                                      >
                                      </TextField>
                                    <TextField
                                        select
                                        label="Giugno"
                                        defaultValue=""
                                        placeholder="Seleziona"
                                        onChange={handleApprovaGiugnoEA5SelectedChange}
                                        onBlur={handleApprovaGiugnoEA5SelectedChange}
                                        error={selectedApprovaGiugnoEA5Error}
                                        value={selectedApprovaGiugnoEA5}
                                        xs={6}
                                        sx={{
                                          width: "5%",
                                          textAlign: "left",
                                          borderRadius: 1,
                                          marginRight: "1%"
                                        }}
                                      >
                                          <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                            SI
                                          </MenuItem>
                                          <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                            NO
                                          </MenuItem>
                                    </TextField>
                                    <TextField
                                        select
                                        label="Luglio"
                                        defaultValue=""
                                        placeholder="Seleziona"
                                        onChange={handleApprovaLuglioEA5SelectedChange}
                                        onBlur={handleApprovaLuglioEA5SelectedChange}
                                        error={selectedApprovaLuglioEA5Error}
                                        value={selectedApprovaLuglioEA5}
                                        xs={6}
                                        sx={{
                                          width: "5%",
                                          textAlign: "left",
                                          borderRadius: 1,
                                          marginRight: "1%"
                                        }}
                                      >
                                          <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                            SI
                                          </MenuItem>
                                          <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                            NO
                                          </MenuItem>
                                    </TextField>
                                    <TextField
                                        select
                                        label="Agosto"
                                        defaultValue=""
                                        placeholder="Seleziona"
                                        onChange={handleApprovaAgostoEA5SelectedChange}
                                        onBlur={handleApprovaAgostoEA5SelectedChange}
                                        error={selectedApprovaAgostoEA5Error}
                                        value={selectedApprovaAgostoEA5}
                                        xs={6}
                                        sx={{
                                          width: "5%",
                                          textAlign: "left",
                                          borderRadius: 1,
                                          marginRight: "1%"
                                        }}
                                      >
                                          <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                            SI
                                          </MenuItem>
                                          <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                            NO
                                          </MenuItem>
                                    </TextField>
                                    <TextField
                                        select
                                        label="Settembre"
                                        defaultValue=""
                                        placeholder="Seleziona"
                                        onChange={handleApprovaSettembreEA5SelectedChange}
                                        onBlur={handleApprovaSettembreEA5SelectedChange}
                                        error={selectedApprovaSettembreEA5Error}
                                        value={selectedApprovaSettembreEA5}
                                        xs={6}
                                        sx={{
                                          width: "5%",
                                          textAlign: "left",
                                          borderRadius: 1,
                                          marginRight: "1%"
                                        }}
                                      >
                                          <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                            SI
                                          </MenuItem>
                                          <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                            NO
                                          </MenuItem>
                                    </TextField>
                                    <TextField
                                    label="Costo totale"
                                    defaultValue=""
                                    placeholder="Seleziona"
                                    value={costoTotaleEA5}
                                    xs={6}
                                    sx={{
                                      width: "8%",
                                      textAlign: "left",
                                      borderRadius: 1,
                                      marginRight: "1%"
                                    }}
                                  >
                                </TextField>
                               </Grid>
                                ) : (<></>) }
                                { (parseInt(selectedRequest.numeroAltriAbbonamenti) >= 6) ? (
                                  <Grid item xs={12} sx={{ width: "100%" }}>
                                  <TextField
                                        label="6) Dati Familiare e/o Convivente"
                                        defaultValue=""
                                        placeholder="Seleziona"
                                        value={ selectedRequest.gradoParentelaEA6 + " | " + selectedRequest.nomeCognomeEA6.toUpperCase() + " " + ((selectedRequest.etaEA6  === 0) ? (" (Maggiore di 12 anni) ") : (" (Fino a 12 anni compiuti) ")) + " | Note: " + selectedRequest.noteEA6.toUpperCase() }
                                        xs={6}
                                        sx={{
                                          width: "60%",
                                          textAlign: "left",
                                          borderRadius: 1,
                                          marginRight: "1%"
                                        }}
                                      >
                                      </TextField>
                                    <TextField
                                        select
                                        label="Giugno"
                                        defaultValue=""
                                        placeholder="Seleziona"
                                        onChange={handleApprovaGiugnoEA6SelectedChange}
                                        onBlur={handleApprovaGiugnoEA6SelectedChange}
                                        error={selectedApprovaGiugnoEA6Error}
                                        value={selectedApprovaGiugnoEA6}
                                        xs={6}
                                        sx={{
                                          width: "5%",
                                          textAlign: "left",
                                          borderRadius: 1,
                                          marginRight: "1%"
                                        }}
                                      >
                                          <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                            SI
                                          </MenuItem>
                                          <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                            NO
                                          </MenuItem>
                                    </TextField>
                                    <TextField
                                        select
                                        label="Luglio"
                                        defaultValue=""
                                        placeholder="Seleziona"
                                        onChange={handleApprovaLuglioEA6SelectedChange}
                                        onBlur={handleApprovaLuglioEA6SelectedChange}
                                        error={selectedApprovaLuglioEA6Error}
                                        value={selectedApprovaLuglioEA6}
                                        xs={6}
                                        sx={{
                                          width: "5%",
                                          textAlign: "left",
                                          borderRadius: 1,
                                          marginRight: "1%"
                                        }}
                                      >
                                          <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                            SI
                                          </MenuItem>
                                          <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                            NO
                                          </MenuItem>
                                    </TextField>
                                    <TextField
                                        select
                                        label="Agosto"
                                        defaultValue=""
                                        placeholder="Seleziona"
                                        onChange={handleApprovaAgostoEA6SelectedChange}
                                        onBlur={handleApprovaAgostoEA6SelectedChange}
                                        error={selectedApprovaAgostoEA6Error}
                                        value={selectedApprovaAgostoEA6}
                                        xs={6}
                                        sx={{
                                          width: "5%",
                                          textAlign: "left",
                                          borderRadius: 1,
                                          marginRight: "1%"
                                        }}
                                      >
                                          <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                            SI
                                          </MenuItem>
                                          <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                            NO
                                          </MenuItem>
                                    </TextField>
                                    <TextField
                                        select
                                        label="Settembre"
                                        defaultValue=""
                                        placeholder="Seleziona"
                                        onChange={handleApprovaSettembreEA6SelectedChange}
                                        onBlur={handleApprovaSettembreEA6SelectedChange}
                                        error={selectedApprovaSettembreEA6Error}
                                        value={selectedApprovaSettembreEA6}
                                        xs={6}
                                        sx={{
                                          width: "5%",
                                          textAlign: "left",
                                          borderRadius: 1,
                                          marginRight: "1%"
                                        }}
                                      >
                                          <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                            SI
                                          </MenuItem>
                                          <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                            NO
                                          </MenuItem>
                                    </TextField>
                                    <TextField
                                    label="Costo totale"
                                    defaultValue=""
                                    placeholder="Seleziona"
                                    value={costoTotaleEA6}
                                    xs={6}
                                    sx={{
                                      width: "8%",
                                      textAlign: "left",
                                      borderRadius: 1,
                                      marginRight: "1%"
                                    }}
                                  >
                                </TextField>
                               </Grid>
                                ) : (<></>) }
                                { (parseInt(selectedRequest.numeroAltriAbbonamenti) >= 7) ? (
                                <Grid item xs={12} sx={{ width: "100%" }}>
                                <TextField
                                      label="7) Dati Familiare e/o Convivente"
                                      defaultValue=""
                                      placeholder="Seleziona"
                                      value={ selectedRequest.gradoParentelaEA7 + " | " + selectedRequest.nomeCognomeEA7.toUpperCase() + " " + ((selectedRequest.etaEA7  === 0) ? (" (Maggiore di 12 anni) ") : (" (Fino a 12 anni compiuti) ")) + " | Note: " + selectedRequest.noteEA7.toUpperCase() }
                                      xs={6}
                                      sx={{
                                        width: "60%",
                                        textAlign: "left",
                                        borderRadius: 1,
                                        marginRight: "1%"
                                      }}
                                    >
                                    </TextField>
                                  <TextField
                                      select
                                      label="Giugno"
                                      defaultValue=""
                                      placeholder="Seleziona"
                                      onChange={handleApprovaGiugnoEA7SelectedChange}
                                      onBlur={handleApprovaGiugnoEA7SelectedChange}
                                      error={selectedApprovaGiugnoEA7Error}
                                      value={selectedApprovaGiugnoEA7}
                                      xs={6}
                                      sx={{
                                        width: "5%",
                                        textAlign: "left",
                                        borderRadius: 1,
                                        marginRight: "1%"
                                      }}
                                    >
                                        <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                          SI
                                        </MenuItem>
                                        <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                          NO
                                        </MenuItem>
                                  </TextField>
                                  <TextField
                                      select
                                      label="Luglio"
                                      defaultValue=""
                                      placeholder="Seleziona"
                                      onChange={handleApprovaLuglioEA7SelectedChange}
                                      onBlur={handleApprovaLuglioEA7SelectedChange}
                                      error={selectedApprovaLuglioEA7Error}
                                      value={selectedApprovaLuglioEA7}
                                      xs={6}
                                      sx={{
                                        width: "5%",
                                        textAlign: "left",
                                        borderRadius: 1,
                                        marginRight: "1%"
                                      }}
                                    >
                                        <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                          SI
                                        </MenuItem>
                                        <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                          NO
                                        </MenuItem>
                                  </TextField>
                                  <TextField
                                      select
                                      label="Agosto"
                                      defaultValue=""
                                      placeholder="Seleziona"
                                      onChange={handleApprovaAgostoEA7SelectedChange}
                                      onBlur={handleApprovaAgostoEA7SelectedChange}
                                      error={selectedApprovaAgostoEA7Error}
                                      value={selectedApprovaAgostoEA7}
                                      xs={6}
                                      sx={{
                                        width: "5%",
                                        textAlign: "left",
                                        borderRadius: 1,
                                        marginRight: "1%"
                                      }}
                                    >
                                        <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                          SI
                                        </MenuItem>
                                        <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                          NO
                                        </MenuItem>
                                  </TextField>
                                  <TextField
                                      select
                                      label="Settembre"
                                      defaultValue=""
                                      placeholder="Seleziona"
                                      onChange={handleApprovaSettembreEA7SelectedChange}
                                      onBlur={handleApprovaSettembreEA7SelectedChange}
                                      error={selectedApprovaSettembreEA7Error}
                                      value={selectedApprovaSettembreEA7}
                                      xs={6}
                                      sx={{
                                        width: "5%",
                                        textAlign: "left",
                                        borderRadius: 1,
                                        marginRight: "1%"
                                      }}
                                    >
                                        <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                          SI
                                        </MenuItem>
                                        <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                          NO
                                        </MenuItem>
                                  </TextField>
                                  <TextField
                                    label="Costo totale"
                                    defaultValue=""
                                    placeholder="Seleziona"
                                    value={costoTotaleEA7}
                                    xs={6}
                                    sx={{
                                      width: "8%",
                                      textAlign: "left",
                                      borderRadius: 1,
                                      marginRight: "1%"
                                    }}
                                  >
                                </TextField>
                             </Grid>
                                ) : (<></>) }
                                 { (parseInt(selectedRequest.numeroAltriAbbonamenti) >= 8) ? (
                                 <Grid item xs={12} sx={{ width: "100%" }}>
                                 <TextField
                                       label="8) Dati Familiare e/o Convivente"
                                       defaultValue=""
                                       placeholder="Seleziona"
                                       value={ selectedRequest.gradoParentelaEA8 + " | " + selectedRequest.nomeCognomeEA8.toUpperCase() + " " + ((selectedRequest.etaEA8  === 0) ? (" (Maggiore di 12 anni) ") : (" (Fino a 12 anni compiuti) ")) + " | Note: " + selectedRequest.noteEA8.toUpperCase() }
                                       xs={6}
                                       sx={{
                                         width: "60%",
                                         textAlign: "left",
                                         borderRadius: 1,
                                         marginRight: "1%"
                                       }}
                                     >
                                     </TextField>
                                   <TextField
                                       select
                                       label="Giugno"
                                       defaultValue=""
                                       placeholder="Seleziona"
                                       onChange={handleApprovaGiugnoEA8SelectedChange}
                                       onBlur={handleApprovaGiugnoEA8SelectedChange}
                                       error={selectedApprovaGiugnoEA8Error}
                                       value={selectedApprovaGiugnoEA8}
                                       xs={6}
                                       sx={{
                                         width: "5%",
                                         textAlign: "left",
                                         borderRadius: 1,
                                         marginRight: "1%"
                                       }}
                                     >
                                         <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                           SI
                                         </MenuItem>
                                         <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                           NO
                                         </MenuItem>
                                   </TextField>
                                   <TextField
                                       select
                                       label="Luglio"
                                       defaultValue=""
                                       placeholder="Seleziona"
                                       onChange={handleApprovaLuglioEA8SelectedChange}
                                       onBlur={handleApprovaLuglioEA8SelectedChange}
                                       error={selectedApprovaLuglioEA8Error}
                                       value={selectedApprovaLuglioEA8}
                                       xs={6}
                                       sx={{
                                         width: "5%",
                                         textAlign: "left",
                                         borderRadius: 1,
                                         marginRight: "1%"
                                       }}
                                     >
                                         <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                           SI
                                         </MenuItem>
                                         <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                           NO
                                         </MenuItem>
                                   </TextField>
                                   <TextField
                                       select
                                       label="Agosto"
                                       defaultValue=""
                                       placeholder="Seleziona"
                                       onChange={handleApprovaAgostoEA8SelectedChange}
                                       onBlur={handleApprovaAgostoEA8SelectedChange}
                                       error={selectedApprovaAgostoEA8Error}
                                       value={selectedApprovaAgostoEA8}
                                       xs={6}
                                       sx={{
                                         width: "5%",
                                         textAlign: "left",
                                         borderRadius: 1,
                                         marginRight: "1%"
                                       }}
                                     >
                                         <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                           SI
                                         </MenuItem>
                                         <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                           NO
                                         </MenuItem>
                                   </TextField>
                                   <TextField
                                       select
                                       label="Settembre"
                                       defaultValue=""
                                       placeholder="Seleziona"
                                       onChange={handleApprovaSettembreEA8SelectedChange}
                                       onBlur={handleApprovaSettembreEA8SelectedChange}
                                       error={selectedApprovaSettembreEA8Error}
                                       value={selectedApprovaSettembreEA8}
                                       xs={6}
                                       sx={{
                                         width: "5%",
                                         textAlign: "left",
                                         borderRadius: 1,
                                         marginRight: "1%"
                                       }}
                                     >
                                         <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                           SI
                                         </MenuItem>
                                         <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                           NO
                                         </MenuItem>
                                   </TextField>
                                   <TextField
                                    label="Costo totale"
                                    defaultValue=""
                                    placeholder="Seleziona"
                                    value={costoTotaleEA8}
                                    xs={6}
                                    sx={{
                                      width: "8%",
                                      textAlign: "left",
                                      borderRadius: 1,
                                      marginRight: "1%"
                                    }}
                                  >
                                </TextField>
                              </Grid>
                                ) : (<></>) }
                                { (parseInt(selectedRequest.numeroAltriAbbonamenti) >= 9) ? (
                                     <Grid item xs={12} sx={{ width: "100%" }}>
                                     <TextField
                                           label="9) Dati Familiare e/o Convivente"
                                           defaultValue=""
                                           placeholder="Seleziona"
                                           value={ selectedRequest.gradoParentelaEA9 + " | " + selectedRequest.nomeCognomeEA9.toUpperCase() + " " + ((selectedRequest.etaEA9  === 0) ? (" (Maggiore di 12 anni) ") : (" (Fino a 12 anni compiuti) ")) + " | Note: " + selectedRequest.noteEA9.toUpperCase() }
                                           xs={6}
                                           sx={{
                                             width: "60%",
                                             textAlign: "left",
                                             borderRadius: 1,
                                             marginRight: "1%"
                                           }}
                                         >
                                         </TextField>
                                       <TextField
                                           select
                                           label="Giugno"
                                           defaultValue=""
                                           placeholder="Seleziona"
                                           onChange={handleApprovaGiugnoEA9SelectedChange}
                                           onBlur={handleApprovaGiugnoEA9SelectedChange}
                                           error={selectedApprovaGiugnoEA9Error}
                                           value={selectedApprovaGiugnoEA9}
                                           xs={6}
                                           sx={{
                                             width: "5%",
                                             textAlign: "left",
                                             borderRadius: 1,
                                             marginRight: "1%"
                                           }}
                                         >
                                             <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                               SI
                                             </MenuItem>
                                             <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                               NO
                                             </MenuItem>
                                       </TextField>
                                       <TextField
                                           select
                                           label="Luglio"
                                           defaultValue=""
                                           placeholder="Seleziona"
                                           onChange={handleApprovaLuglioEA9SelectedChange}
                                           onBlur={handleApprovaLuglioEA9SelectedChange}
                                           error={selectedApprovaLuglioEA9Error}
                                           value={selectedApprovaLuglioEA9}
                                           xs={6}
                                           sx={{
                                             width: "5%",
                                             textAlign: "left",
                                             borderRadius: 1,
                                             marginRight: "1%"
                                           }}
                                         >
                                             <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                               SI
                                             </MenuItem>
                                             <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                               NO
                                             </MenuItem>
                                       </TextField>
                                       <TextField
                                           select
                                           label="Agosto"
                                           defaultValue=""
                                           placeholder="Seleziona"
                                           onChange={handleApprovaAgostoEA9SelectedChange}
                                           onBlur={handleApprovaAgostoEA9SelectedChange}
                                           error={selectedApprovaAgostoEA9Error}
                                           value={selectedApprovaAgostoEA9}
                                           xs={6}
                                           sx={{
                                             width: "5%",
                                             textAlign: "left",
                                             borderRadius: 1,
                                             marginRight: "1%"
                                           }}
                                         >
                                             <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                               SI
                                             </MenuItem>
                                             <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                               NO
                                             </MenuItem>
                                       </TextField>
                                       <TextField
                                           select
                                           label="Settembre"
                                           defaultValue=""
                                           placeholder="Seleziona"
                                           onChange={handleApprovaSettembreEA9SelectedChange}
                                           onBlur={handleApprovaSettembreEA9SelectedChange}
                                           error={selectedApprovaSettembreEA9Error}
                                           value={selectedApprovaSettembreEA9}
                                           xs={6}
                                           sx={{
                                             width: "5%",
                                             textAlign: "left",
                                             borderRadius: 1,
                                             marginRight: "1%"
                                           }}
                                         >
                                             <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                               SI
                                             </MenuItem>
                                             <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                               NO
                                             </MenuItem>
                                       </TextField>
                                       <TextField
                                    label="Costo totale"
                                    defaultValue=""
                                    placeholder="Seleziona"
                                    value={costoTotaleEA9}
                                    xs={6}
                                    sx={{
                                      width: "8%",
                                      textAlign: "left",
                                      borderRadius: 1,
                                      marginRight: "1%"
                                    }}
                                  >
                                </TextField>
                                  </Grid>
                                ) : (<></>) }
                                { (parseInt(selectedRequest.numeroAltriAbbonamenti) >= 10) ? (
                                   <Grid item xs={12} sx={{ width: "100%" }}>
                                   <TextField
                                         label="10) Dati Familiare e/o Convivente"
                                         defaultValue=""
                                         placeholder="Seleziona"
                                         value={ selectedRequest.gradoParentelaEA10 + " | " + selectedRequest.nomeCognomeEA10.toUpperCase() + " " + ((selectedRequest.etaEA10  === 0) ? (" (Maggiore di 12 anni) ") : (" (Fino a 12 anni compiuti) ")) + " | Note: " + selectedRequest.noteEA10.toUpperCase() }
                                         xs={6}
                                         sx={{
                                           width: "60%",
                                           textAlign: "left",
                                           borderRadius: 1,
                                           marginRight: "1%"
                                         }}
                                       >
                                       </TextField>
                                     <TextField
                                         select
                                         label="Giugno"
                                         defaultValue=""
                                         placeholder="Seleziona"
                                         onChange={handleApprovaGiugnoEA10SelectedChange}
                                         onBlur={handleApprovaGiugnoEA10SelectedChange}
                                         error={selectedApprovaGiugnoEA10Error}
                                         value={selectedApprovaGiugnoEA10}
                                         xs={6}
                                         sx={{
                                           width: "5%",
                                           textAlign: "left",
                                           borderRadius: 1,
                                           marginRight: "1%"
                                         }}
                                       >
                                           <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                             SI
                                           </MenuItem>
                                           <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                             NO
                                           </MenuItem>
                                     </TextField>
                                     <TextField
                                         select
                                         label="Luglio"
                                         defaultValue=""
                                         placeholder="Seleziona"
                                         onChange={handleApprovaLuglioEA10SelectedChange}
                                         onBlur={handleApprovaLuglioEA10SelectedChange}
                                         error={selectedApprovaLuglioEA10Error}
                                         value={selectedApprovaLuglioEA10}
                                         xs={6}
                                         sx={{
                                           width: "5%",
                                           textAlign: "left",
                                           borderRadius: 1,
                                           marginRight: "1%"
                                         }}
                                       >
                                           <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                             SI
                                           </MenuItem>
                                           <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                             NO
                                           </MenuItem>
                                     </TextField>
                                     <TextField
                                         select
                                         label="Agosto"
                                         defaultValue=""
                                         placeholder="Seleziona"
                                         onChange={handleApprovaAgostoEA10SelectedChange}
                                         onBlur={handleApprovaAgostoEA10SelectedChange}
                                         error={selectedApprovaAgostoEA10Error}
                                         value={selectedApprovaAgostoEA10}
                                         xs={6}
                                         sx={{
                                           width: "5%",
                                           textAlign: "left",
                                           borderRadius: 1,
                                           marginRight: "1%"
                                         }}
                                       >
                                           <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                             SI
                                           </MenuItem>
                                           <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                             NO
                                           </MenuItem>
                                     </TextField>
                                     <TextField
                                         select
                                         label="Settembre"
                                         defaultValue=""
                                         placeholder="Seleziona"
                                         onChange={handleApprovaSettembreEA10SelectedChange}
                                         onBlur={handleApprovaSettembreEA10SelectedChange}
                                         error={selectedApprovaSettembreEA10Error}
                                         value={selectedApprovaSettembreEA10}
                                         xs={6}
                                         sx={{
                                           width: "5%",
                                           textAlign: "left",
                                           borderRadius: 1,
                                           marginRight: "1%"
                                         }}
                                       >
                                           <MenuItem key={1} value={1} style={{whiteSpace: 'normal'}}>
                                             SI
                                           </MenuItem>
                                           <MenuItem key={2} value={2} style={{whiteSpace: 'normal'}}>
                                             NO
                                           </MenuItem>
                                     </TextField>
                                     <TextField
                                    label="Costo totale"
                                    defaultValue=""
                                    placeholder="Seleziona"
                                    value={costoTotaleEA10}
                                    xs={6}
                                    sx={{
                                      width: "8%",
                                      textAlign: "left",
                                      borderRadius: 1,
                                      marginRight: "1%"
                                    }}
                                  >
                                </TextField>
                                </Grid>
                                ) : (<></>) }

                        </Grid>
                      </Stack>
                    </Box>
                  </Card>

                  <Card variant="outlined" sx={{ width: "100%", marginBottom:5 }}>
                    <Box sx={{ p: 2 }}>
                      <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Typography gutterBottom variant="h6" component="div">
                          PAGAMENTI
                        </Typography>
                        <Typography gutterBottom variant="h6" component="div">
                        <Button sx={{border:1, marginRight:2}} onClick={updateRichiesta}>SALVA</Button>
                        </Typography>
                      </Stack>
                     
                    </Box>
                    <Divider />
                    <Box sx={{ p: 2 }}>
                      <Typography gutterBottom variant="body2" sx={{paddingBottom:4}}>
                      Di sequito sono riportati i dettagli delle quote da pagare e dei pagamenti effettuati
                      </Typography>
                      <Stack direction="row" spacing={1}>
                      <TextField
                        label="Totale da versare"
                        value={selectedTotaleDaVersare}
                        defaultValue=""
                        placeholder="Seleziona"
                        xs={4}
                        sx={{
                          width: "30%",
                          textAlign: "left",
                          borderRadius: 1,
                          paddingBottom:3
                        
                        }}
                      >
                      </TextField>
                      <TextField
                        select
                        label="Pagamento verificato"
                        defaultValue=""
                        placeholder="Seleziona"
                        onChange={handlePagamentoEffettuatoSelectedChange}
                        onBlur={handlePagamentoEffettuatoSelectedChange}
                        error={selectedPagamentoEffettuatoError}
                        value={selectedPagamentoEffettuato}
                        xs={6}
                        sx={{
                          width: "25%",
                          textAlign: "left",
                          borderRadius: 1,
                          marginRight: "1%"
                        }}
                      >
                          <MenuItem key={1} value={"SI"} style={{whiteSpace: 'normal'}}>
                            SI
                          </MenuItem>
                          <MenuItem key={2} value={"NO"} style={{whiteSpace: 'normal'}}>
                            NO
                          </MenuItem>
                    </TextField>
                      </Stack>
                    </Box>
                  </Card>

                  <Card variant="outlined" sx={{ width: "100%", marginBottom:5 }}>
                    <Box sx={{ p: 2 }}>
                      <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Typography gutterBottom variant="h6" component="div">
                          DOCUMENTAZIONE
                        </Typography>
                        <Typography gutterBottom variant="h6" component="div">
                       
                        <Button sx={{border:1, marginRight:2}} onClick={updateRichiesta}>SALVA</Button>
                        </Typography>
                      </Stack>
                     
                    </Box>
                    <Divider />
                    <Box sx={{ p: 2 }}>
                    <TextField
                        id="outlined-statorichiesta-currency"
                        select
                        label="Stato Documentazione"
                        onChange={handleStatoDocumentazioneSelectedChange}
                        onBlur={handleStatoDocumentazioneSelectedChange}
                        error={selectedStatoDocumentazioneError}
                        value={selectedStatoDocumentazione}
                        defaultValue=""
                        placeholder="Seleziona"
                        xs={4}
                        sx={{
                          width: "100%",
                          textAlign: "left",
                          borderRadius: 1,
                          paddingBottom:3
                        
                        }}
                      >
                          {statoDocumentazione.map((option) => (
                          <MenuItem key={option.value} value={option.value} style={{whiteSpace: 'normal'}}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </TextField>
                      <Divider />
                      {(attachments.length === 0) ? (<Typography gutterBottom variant="body2"  sx={{
                          paddingTop:3
                        }}>
                      Non è presente nessuna documentazione.
                      </Typography>) : (
                        <><Typography gutterBottom variant="body2" sx={{
                          paddingTop:3
                        }}>
                     Di seguito la lista dei documenti caricati dall' utente
                      </Typography>
                     <Stack direction="row" spacing={1}>
                     <List >
                           {attachments.map((item) => (
                             <ListItem>
                               <a href={item.url} target='_blank'>{item.name}</a>
                             </ListItem>
                           ))}
                           </List>
                     </Stack></>)}
                      
                     
                    </Box>
                  </Card>

                  <Card variant="outlined" sx={{ width: "100%", marginBottom:5 }}>
                    <Box sx={{ p: 2 }}>
                      <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Typography gutterBottom variant="h6" component="div">
                          ABBONAMENTI
                        </Typography>
                        <Typography gutterBottom variant="h6" component="div">
                        <Button sx={{border:1, marginRight:2}} onClick={inviaEmailAbbonamenti}>INVIA MAIL ABBONAMENTI</Button>
                        <Button sx={{border:1, marginRight:2}} onClick={generaAbbonamenti}>GENERA</Button>
                        </Typography>
                      </Stack>
                     
                    </Box>
                    <Divider />
                    <Box sx={{ p: 2 }}>
                    {(abbonamenti.length === 0) ? (<Typography gutterBottom variant="body2"  sx={{
                          paddingTop:3
                        }}>
                        Non sono stati generati aoncora abbonamenti per questa richiesta.
                      </Typography>) : (
                        <><Typography gutterBottom variant="body2" sx={{
                          paddingTop:3
                        }}>
                        Di seguito la lista degli abbonamenti associati alla presente richiesta
                      </Typography>
                     
                     <Grid
                        container
                        sx={{ width: "100%",  paddingTop: 2, paddingBottom:5 }}
                        rowGap={3}
                      >
                           {abbonamentiGiugno.map((item) => (
                               <Grid item xs={12} sx={{ width: "100%"}}>
                               <TextField
                                      
                                      value={item.categoriaTitolare}
                                      label="Categoria Titolare"
                                      placeholder=""
                                      xs={12}
                                      sx={{
                                        width: "15%",
                                        textAlign: "left",
                                        borderRadius: 1,
                                        paddingRight: 2,
                                
                                      }}
                                ></TextField>
                                 <TextField
                                      
                                      value={item.nomeTitolare + " " + item.cognomeTitolare}
                                      label="Nome e Cognome Titolare"
                                      placeholder=""
                                      xs={12}
                                      sx={{
                                        width: "15%",
                                        textAlign: "left",
                                        borderRadius: 1,
                                        paddingRight: 2,
                                      }}
                                ></TextField>
                                 <TextField
                                      
                                      value={item.turnoAbbonamento.toUpperCase()}
                                      label="Turno"
                                      placeholder=""
                                      xs={12}
                                      sx={{
                                        width: "15%",
                                        textAlign: "left",
                                        borderRadius: 1,
                                        paddingRight: 2,
                                      }}
                                ></TextField>
                                {(item.nomeCognomeAbbonato != "") ? (
                                 <> <TextField
                                      
                                      value={item.gradoParentela.toUpperCase()}
                                      label="Grado parentela"
                                      placeholder=""
                                      xs={12}
                                      sx={{
                                        width: "15%",
                                        textAlign: "left",
                                        borderRadius: 1,
                                        paddingRight: 2,
                                      }}
                                ></TextField>
                                <TextField
                                      
                                      value={item.nomeCognomeAbbonato.toUpperCase()}
                                      label="Nome e Cognome Abbonato"
                                      placeholder=""
                                      xs={12}
                                      sx={{
                                        width: "15%",
                                        textAlign: "left",
                                        borderRadius: 1,
                                        paddingRight: 2,
                                      }}
                                ></TextField></>
                                ) : (<> <TextField
                                      
                                  value="--"
                                  label="Grado parentela"
                                  placeholder=""
                                  xs={12}
                                  sx={{
                                    width: "15%",
                                    textAlign: "left",
                                    borderRadius: 1,
                                    paddingRight: 2,
                                  }}
                            ></TextField>
                            <TextField
                                  
                                  value="--"
                                  label="Nome e Cognome Abbonato"
                                  placeholder=""
                                  xs={12}
                                  sx={{
                                    width: "15%",
                                    textAlign: "left",
                                    borderRadius: 1,
                                    paddingRight: 2,
                                  }}
                            ></TextField></>)}
                             </Grid>
                           ))}
                      </Grid>
                      <Grid
                        container
                        sx={{ width: "100%",  paddingTop: 2, paddingBottom:5 }}
                        rowGap={3}
                      >
                           {abbonamentiLuglio.map((item) => (
                               <Grid item xs={12} sx={{ width: "100%"}}>
                               <TextField
                                      
                                      value={item.categoriaTitolare}
                                      label="Categoria Titolare"
                                      placeholder=""
                                      xs={12}
                                      sx={{
                                        width: "15%",
                                        textAlign: "left",
                                        borderRadius: 1,
                                        paddingRight: 2,
                                
                                      }}
                                ></TextField>
                                 <TextField
                                      
                                      value={item.nomeTitolare + " " + item.cognomeTitolare}
                                      label="Nome e Cognome Titolare"
                                      placeholder=""
                                      xs={12}
                                      sx={{
                                        width: "15%",
                                        textAlign: "left",
                                        borderRadius: 1,
                                        paddingRight: 2,
                                      }}
                                ></TextField>
                                 <TextField
                                      
                                      value={item.turnoAbbonamento.toUpperCase()}
                                      label="Turno"
                                      placeholder=""
                                      xs={12}
                                      sx={{
                                        width: "15%",
                                        textAlign: "left",
                                        borderRadius: 1,
                                        paddingRight: 2,
                                      }}
                                ></TextField>
                                {(item.nomeCognomeAbbonato != "") ? (
                                 <> <TextField
                                      
                                      value={item.gradoParentela.toUpperCase()}
                                      label="Grado parentela"
                                      placeholder=""
                                      xs={12}
                                      sx={{
                                        width: "15%",
                                        textAlign: "left",
                                        borderRadius: 1,
                                        paddingRight: 2,
                                      }}
                                ></TextField>
                                <TextField
                                      
                                      value={item.nomeCognomeAbbonato.toUpperCase()}
                                      label="Nome e Cognome Abbonato"
                                      placeholder=""
                                      xs={12}
                                      sx={{
                                        width: "15%",
                                        textAlign: "left",
                                        borderRadius: 1,
                                        paddingRight: 2,
                                      }}
                                ></TextField></>
                                ) : (<> <TextField
                                      
                                  value="--"
                                  label="Grado parentela"
                                  placeholder=""
                                  xs={12}
                                  sx={{
                                    width: "15%",
                                    textAlign: "left",
                                    borderRadius: 1,
                                    paddingRight: 2,
                                  }}
                            ></TextField>
                            <TextField
                                  
                                  value="--"
                                  label="Nome e Cognome Abbonato"
                                  placeholder=""
                                  xs={12}
                                  sx={{
                                    width: "15%",
                                    textAlign: "left",
                                    borderRadius: 1,
                                    paddingRight: 2,
                                  }}
                            ></TextField></>)}
                             </Grid>
                           ))}
                      </Grid>
                      <Grid
                        container
                        sx={{ width: "100%",  paddingTop: 2, paddingBottom:5 }}
                        rowGap={3}
                      >
                           {abbonamentiAgosto.map((item) => (
                               <Grid item xs={12} sx={{ width: "100%"}}>
                               <TextField
                                      
                                      value={item.categoriaTitolare}
                                      label="Categoria Titolare"
                                      placeholder=""
                                      xs={12}
                                      sx={{
                                        width: "15%",
                                        textAlign: "left",
                                        borderRadius: 1,
                                        paddingRight: 2,
                                
                                      }}
                                ></TextField>
                                 <TextField
                                      
                                      value={item.nomeTitolare + " " + item.cognomeTitolare}
                                      label="Nome e Cognome Titolare"
                                      placeholder=""
                                      xs={12}
                                      sx={{
                                        width: "15%",
                                        textAlign: "left",
                                        borderRadius: 1,
                                        paddingRight: 2,
                                      }}
                                ></TextField>
                                 <TextField
                                      
                                      value={item.turnoAbbonamento.toUpperCase()}
                                      label="Turno"
                                      placeholder=""
                                      xs={12}
                                      sx={{
                                        width: "15%",
                                        textAlign: "left",
                                        borderRadius: 1,
                                        paddingRight: 2,
                                      }}
                                ></TextField>
                                {(item.nomeCognomeAbbonato != "") ? (
                                 <> <TextField
                                      
                                      value={item.gradoParentela.toUpperCase()}
                                      label="Grado parentela"
                                      placeholder=""
                                      xs={12}
                                      sx={{
                                        width: "15%",
                                        textAlign: "left",
                                        borderRadius: 1,
                                        paddingRight: 2,
                                      }}
                                ></TextField>
                                <TextField
                                      
                                      value={item.nomeCognomeAbbonato.toUpperCase()}
                                      label="Nome e Cognome Abbonato"
                                      placeholder=""
                                      xs={12}
                                      sx={{
                                        width: "15%",
                                        textAlign: "left",
                                        borderRadius: 1,
                                        paddingRight: 2,
                                      }}
                                ></TextField></>
                                ) : (<> <TextField
                                      
                                  value="--"
                                  label="Grado parentela"
                                  placeholder=""
                                  xs={12}
                                  sx={{
                                    width: "15%",
                                    textAlign: "left",
                                    borderRadius: 1,
                                    paddingRight: 2,
                                  }}
                            ></TextField>
                            <TextField
                                  
                                  value="--"
                                  label="Nome e Cognome Abbonato"
                                  placeholder=""
                                  xs={12}
                                  sx={{
                                    width: "15%",
                                    textAlign: "left",
                                    borderRadius: 1,
                                    paddingRight: 2,
                                  }}
                            ></TextField></>)}
                             </Grid>
                           ))}
                      </Grid>
                      <Grid
                        container
                        sx={{ width: "100%",  paddingTop: 2, paddingBottom:5 }}
                        rowGap={3}
                      >
                           {abbonamentiSettembre.map((item) => (
                               <Grid item xs={12} sx={{ width: "100%"}}>
                               <TextField
                                      
                                      value={item.categoriaTitolare}
                                      label="Categoria Titolare"
                                      placeholder=""
                                      xs={12}
                                      sx={{
                                        width: "15%",
                                        textAlign: "left",
                                        borderRadius: 1,
                                        paddingRight: 2,
                                
                                      }}
                                ></TextField>
                                 <TextField
                                      
                                      value={item.nomeTitolare + " " + item.cognomeTitolare}
                                      label="Nome e Cognome Titolare"
                                      placeholder=""
                                      xs={12}
                                      sx={{
                                        width: "15%",
                                        textAlign: "left",
                                        borderRadius: 1,
                                        paddingRight: 2,
                                      }}
                                ></TextField>
                                 <TextField
                                      
                                      value={item.turnoAbbonamento.toUpperCase()}
                                      label="Turno"
                                      placeholder=""
                                      xs={12}
                                      sx={{
                                        width: "15%",
                                        textAlign: "left",
                                        borderRadius: 1,
                                        paddingRight: 2,
                                      }}
                                ></TextField>
                                {(item.nomeCognomeAbbonato != "") ? (
                                 <> <TextField
                                      
                                      value={item.gradoParentela.toUpperCase()}
                                      label="Grado parentela"
                                      placeholder=""
                                      xs={12}
                                      sx={{
                                        width: "15%",
                                        textAlign: "left",
                                        borderRadius: 1,
                                        paddingRight: 2,
                                      }}
                                ></TextField>
                                <TextField
                                      
                                      value={item.nomeCognomeAbbonato.toUpperCase()}
                                      label="Nome e Cognome Abbonato"
                                      placeholder=""
                                      xs={12}
                                      sx={{
                                        width: "15%",
                                        textAlign: "left",
                                        borderRadius: 1,
                                        paddingRight: 2,
                                      }}
                                ></TextField></>
                                ) : (  <> <TextField
                                      
                                  value="--"
                                  label="Grado parentela"
                                  placeholder=""
                                  xs={12}
                                  sx={{
                                    width: "15%",
                                    textAlign: "left",
                                    borderRadius: 1,
                                    paddingRight: 2,
                                  }}
                            ></TextField>
                            <TextField
                                  
                                  value="--"
                                  label="Nome e Cognome Abbonato"
                                  placeholder=""
                                  xs={12}
                                  sx={{
                                    width: "15%",
                                    textAlign: "left",
                                    borderRadius: 1,
                                    paddingRight: 2,
                                  }}
                            ></TextField></>)}
                             </Grid>
                           ))}
                      </Grid>
                     </>)}
                    </Box>
                  
                  
                  </Card>
               
                  
              </CustomTabPanel>
              <Box sx={{ p: 2 }} hidden={!showOmbrelloni}>
                   
                   
                   { abbonamenti.length > 0 ? ( <Grid
                         container
                         sx={{ width: "100%",  paddingTop: 2, paddingBottom:5 }}
                         rowGap={3}
                       >
                          <Grid item xs={12} sx={{ width: "100%"}}>
                               {abbonamentiGiugno.length > 0 ? ( <TextField 
                                       value={ombrelloneGiugno}
                                      
                                       label="Ombrellone Giugno"
                                       onChange={handleOmbrelloneGiugnoChange}
                                       onBlur={handleOmbrelloneGiugnoChange}
                                       placeholder=""
                                       xs={12}
                                       sx={{
                                         width: "15%",
                                         textAlign: "left",
                                         borderRadius: 1,
                                         paddingRight: 2,
                                         
                                 
                                       }}
                                 ></TextField>) : ( <TextField 
                                   value="--"
                                   label="Ombrellone Giugno"
                                   placeholder=""
                                   xs={12}
                                   sx={{
                                     width: "15%",
                                     textAlign: "left",
                                     borderRadius: 1,
                                     paddingRight: 2,
                             
                                   }}
                             ></TextField>)}
                              {abbonamentiLuglio.length > 0 ? ( <TextField 
                                       value={ombrelloneLuglio}
                                       label="Ombrellone Luglio"
                                       onChange={handleOmbrelloneLuglioChange}
                                       onBlur={handleOmbrelloneLuglioChange}
                                       placeholder=""
                                       id="outlined-ombrelloneluglio-currency"
                                       xs={12}
                                       sx={{
                                         width: "15%",
                                         textAlign: "left",
                                         borderRadius: 1,
                                         paddingRight: 2,
                                 
                                       }}
                                 ></TextField>) : ( <TextField 
                                   value="--"
                                   label="Ombrellone Luglio"
                                   placeholder=""
                                   xs={12}
                                   sx={{
                                     width: "15%",
                                     textAlign: "left",
                                     borderRadius: 1,
                                     paddingRight: 2,
                             
                                   }}
                             ></TextField>)}
                              {abbonamentiAgosto.length > 0 ? ( <TextField 
                                       value={ombrelloneAgosto}
                                       label="Ombrellone Agosto"
                                       onChange={handleOmbrelloneAgostoChange}
                                       onBlur={handleOmbrelloneAgostoChange}
                                       placeholder=""
                                       xs={12}
                                       sx={{
                                         width: "15%",
                                         textAlign: "left",
                                         borderRadius: 1,
                                         paddingRight: 2,
                                 
                                       }}
                                 ></TextField>) : ( <TextField 
                                   value="--"
                                   label="Ombrellone Agosto"
                                   placeholder=""
                                   xs={12}
                                   sx={{
                                     width: "15%",
                                     textAlign: "left",
                                     borderRadius: 1,
                                     paddingRight: 2,
                             
                                   }}
                             ></TextField>)}
                                {abbonamentiSettembre.length > 0 ? ( <TextField 
                                       value={ombrelloneSettembre}
                                       label="Ombrellone Settembre"
                                       onChange={handleOmbrelloneSettembreChange}
                                       onBlur={handleOmbrelloneSettembreChange}
                                       placeholder=""
                                       xs={12}
                                       sx={{
                                         width: "15%",
                                         textAlign: "left",
                                         borderRadius: 1,
                                         paddingRight: 2,
                                 
                                       }}
                                 ></TextField>) : ( <TextField 
                                   value="--"
                                   label="Ombrellone Settembre"
                                   placeholder=""
                                   xs={12}
                                   sx={{
                                     width: "15%",
                                     textAlign: "left",
                                     borderRadius: 1,
                                     paddingRight: 2,
                             
                                   }}
                             ></TextField>)}
                                   <Button sx={{border:1, marginRight:2}} onClick={salvaAbbonamenti}>SALVA OMBRELLONI</Button>
                                 </Grid>
                     </Grid>) : (<></>)}
                   
                    
                     </Box>
        
            </Box>
            ) : ( <></>)
            }
           <div className="Container" hidden={showDetails}>
                <Typography variant="h4" gutterBottom >RICHIESTE</Typography>
                <div className="Grid">
                <DataGrid
                rows={rows}
                columns={columns}
                slots={{
                    toolbar: GridToolbar,
                  }}
                initialState={{
                pagination: {
                    paginationModel: {
                    pageSize: 25,
                    },
                },
                }}
                pageSizeOptions={[25]}
               
                //checkboxSelection
                //disableRowSelectionOnClick
            />
                </div>
            </div>
            <div className="Container" hidden={showDetails}>
            <Typography variant="h4" gutterBottom sx={{ paddingTop:5}}>ABBONAMENTI EMESSI</Typography>
                <div className="Grid">
                <DataGrid
                rows={rowsAll}
                columns={columnsAll}
                slots={{
                    toolbar: GridToolbar,
                  }}
                initialState={{
                pagination: {
                    paginationModel: {
                    pageSize: 25,
                    },
                },
                }}
                pageSizeOptions={[25]}
               
                //checkboxSelection
                //disableRowSelectionOnClick
            />
                </div>
            </div>
            <Snackbar open={openSnackBar} autoHideDuration={6000} onClose={handleCloseSnackBar}>
                <Alert
                  onClose={handleCloseSnackBar}
                  severity="success"
                  variant="filled"
                  sx={{ width: '100%' }}
                >
                  {snackBarMessage}
                </Alert>
              </Snackbar>
          </Box>
        
  );
}

export default Manager;